import {
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instanceat14thlj150z as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toString14fd7g605f91p as toString_0,
  Char__hashCode_impl_otmys1ewos5t0dm35g as Char__hashCode_impl_otmys,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  joinToString1cxrrlmo0chqs as joinToString,
  booleanArray2jdug9b51huk7 as booleanArray,
  StringBuildermazzzhj6kkai as StringBuilder,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_0,
  toLongw1zpgk99d84b as toLong,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong1a4cndvg6c52s as numberToLong,
  println2shhhgwwt4c61 as println,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  mapOf1xd03cq9cnmy8 as mapOf,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instance3jf2rsvdhmxzn as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp2zkq9ykxbil7d as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  getKClass1s3j9wy1cofik as getKClass,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  KProperty02ce7r476m8633 as KProperty0,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstance8lqb2pbph5yn as Console_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_1,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstance2cg04z8rod8ga as Level_WARN_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance2r8kc48nhvjcq as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_2,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstance39o54489czp6d as Companion_getInstance_3,
  Os_UNKNOWN_getInstancecnx3cm3i6e2g as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  DenoPointerpb0vypijx63v as DenoPointer,
  get_pointerlkbwhoqlhapz as get_pointer,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_4,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_6,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_7,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_2,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance293l0r179rei7 as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration__hashCode_impl_y13la6nym0c1xbwjaa as FastDuration__hashCode_impl_y13la6,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  FastDuration__minus_impl_evs237bt7zqxxnwet as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  minus2npwq73u0d9yx as minus,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab30y5opwsu5po5 as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  clonelcrqoxe4ne5i as clone,
  Companion_instancejzamqjlqqs4y as Companion_instance_4,
  _Int8Buffer___init__impl__e20lvcp4p2uvfo996c as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulbq12sgwh1jcvh as _Int8Buffer___get_buffer__impl__q0gulb,
  _Float32Buffer___init__impl__403k2m1hlz2hcoqnaef as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9xp04xjj40882q as _Float32Buffer___get_buffer__impl__x5nu9x,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  Companion_getInstance35xii7iw9kdg2 as Companion_getInstance_9,
  ByteUnits__toString_impl_ox2ku22zb4xrvk9phl9 as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  arrayequal25g4om83vd8w1 as arrayequal,
  copyOfnqvdm0sc8lk as copyOf,
  setArrayLEwil75hzlfusu as setArrayLE,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliu1ltqm2yo4vfb6 as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu2fcy7ilfo0o6g as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34sznedf8x821xo8e0 as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  insert42sy0xc4ax89g9 as insert4,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  insert8f3zk23r8x9da as insert8,
  insert32d422lnha9g5r as insert3,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  min1z074tc6jeruz as min,
  max1izmzj76cv5b4 as max_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate35pbs3ac913y4 as interpolate,
  interpolate2g7wzskc23f1q as interpolate_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3 as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8 as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v as _RGBAPremultiplied___get_rf__impl__pt0c4y,
  _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq as _RGBAPremultiplied___get_gf__impl__ivron7,
  _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni as _RGBAPremultiplied___get_bf__impl__qa3on2,
  _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx as _RGBAPremultiplied___get_af__impl__euwcjn,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_instance1sgltfeqg9bxt as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1yhww5yoq3a9l as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instance1zw3l6m7tnvps as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  Companion_getInstance2ou2xyvohty1g as Companion_getInstance_11,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance2vt0vokm4ixbh as Companion_getInstance_12,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay2vwv568c245r8 as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  delay1blitpytzu6gr as delay_0,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  cancelChildrennwartoz0yn6c as cancelChildren,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin2j6ktsickm6hy as cancelAndJoin,
  await24mygle6x7vn5 as await_0,
  MainScope1gi1r4abhrtmm as MainScope,
} from './kotlinx-coroutines-core.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance2i0t7ux7bzoqc as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_13,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-inject-root-korlibs-inject.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  FFILiby83bova0zjfy as FFILib,
  Companion_getInstance2ww1whxsubyyu as Companion_getInstance_14,
  FuncInfocud0a7bce10z as FuncInfo,
  CreateFFIPointernsr7ilwulbub as CreateFFIPointer,
  get_pointer2afz2rc14joly as get_pointer_0,
  CreateFFIMemoryv82e6jbfcdze as CreateFFIMemory,
  set3216gyp8r69gas8 as set32,
  CreateFFIMemory2iekizxdvtyvt as CreateFFIMemory_0,
  setFFIPointerjzarmbova4sm as setFFIPointer,
  getS32284qh8a5ldxzn as getS32,
} from './korlibs-ffi-root-korlibs-ffi-legacy.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.a65_1 = eventLoop;
    this.b65_1 = now;
    this.c65_1 = time;
    this.d65_1 = interval;
    this.e65_1 = callback;
  }
  f65(value) {
    this.b65_1 = Duration__minus_impl_q5cfm7(value, this.c65_1);
  }
  g65() {
    return Duration__plus_impl_yu9v8f(this.b65_1, this.c65_1);
  }
  h65(other) {
    return Duration__compareTo_impl_pchp0f(this.g65(), other.g65());
  }
  d(other) {
    return this.h65(other instanceof TimedTask ? other : THROW_CCE());
  }
  c6() {
    this.d65_1 = false;
    this.a65_1.r65_1.v2l(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.a66_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.j65_1 = immediateRun;
    this.k65_1 = new SyncPauseable();
    this.l65_1 = paused$factory(this.k65_1);
    this.m65_1 = new Lock();
    this.n65_1 = true;
    this.o65_1 = Monotonic_instance.ej();
    var tmp = this;
    tmp.p65_1 = SyncEventLoop$nowProvider$lambda(this);
    this.q65_1 = ArrayDeque.jk();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_0;
    tmp_0.r65_1 = tmp_1.g2q(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_2 = this;
    tmp_2.s65_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.t65_1 = null;
  }
  u65(task) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.m65_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.d1v();
      try {
        this.q65_1.mk(task);
        this.m65_1.h1v();
        break $l$block;
      }finally {
        this_0.f1v();
      }
    }
  }
  v65(time, task) {
    return _queueAfter(this, time, false, task);
  }
  c6() {
    var oldImmediateRun = this.j65_1;
    try {
      this.j65_1 = true;
      this.w65();
      this.n65_1 = false;
    }finally {
      this.j65_1 = oldImmediateRun;
    }
  }
  x65(task) {
    if (this.j65_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.r65_1.m2q().g65()) >= 0;
  }
  y65(runTimers) {
    var count = 0;
    while (this.z65(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  w65(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.y65(runTimers) : $super.y65.call(this, runTimers);
  }
  z65(runTimers) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.m65_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.d1v();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.r65_1.g1()) {
            tmp_1 = this.x65(this.r65_1.m2q());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.r65_1.n2q();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.f1v();
      }
    }
    var timedTask = tmp$ret$2;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        timedTask.e65_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.s65_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.d65_1 && !this.j65_1) {
        timedTask.f65(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.g65(), timedTask.c65_1)), new Duration(_get_now__e6dlkr(this))).kj_1);
        this.r65_1.u2l(timedTask);
      }
    }
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_1 = this.m65_1;
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_1.d1v();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.q65_1.g1()) {
          tmp_2 = this.q65_1.nk();
        } else {
          tmp_2 = null;
        }
        tmp$ret$7 = tmp_2;
        break $l$block_0;
      }finally {
        this_1.f1v();
      }
    }
    var task = tmp$ret$7;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (task == null)
        null;
      else
        task();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.s65_1(e_0);
      } else {
        throw $p;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.b66_1 = func;
    this.c66_1 = node;
    this.d66_1 = base;
  }
  c6() {
    if (this.c66_1.f66_1.j3(this)) {
      __updateChildListenerCount(this.d66_1, this.c66_1.e66_1, -1);
    }
  }
  h66() {
    this.c66_1.f66_1.h(this);
    __updateChildListenerCount(this.d66_1, this.c66_1.e66_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.e66_1 = type;
    this.f66_1 = FastArrayList.ny();
    this.g66_1 = FastArrayList.ny();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.w4(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.yr(this.o66(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.q66(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.x66(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.q66(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.q66(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.y66(event.n29(), event);
}
class BaseEventListener {
  static m66() {
    var $this = createThis(this);
    $this.i66_1 = null;
    $this.j66_1 = null;
    $this.k66_1 = null;
    $this.l66_1 = null;
    return $this;
  }
  vx(_set____db54di) {
    this.i66_1 = _set____db54di;
  }
  wx() {
    return this.i66_1;
  }
  n66(other) {
    var tmp0_safe_receiver = this.j66_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.j66_1 = other;
    var tmp1_safe_receiver = this.j66_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  }
  o66(type, handler) {
    if (this.k66_1 == null)
      this.k66_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.k66_1);
      var res = get_0(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.h66();
    return this_1;
  }
  p66(type) {
    var tmp0_safe_receiver = this.k66_1;
    var tmp = tmp0_safe_receiver == null ? null : get_0(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  q66(type, event, result, up, down) {
    var eventListenerCount = this.r66(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.s66(type, event, result);
    }
    var listeners = this.p66(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.f66_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.g66_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.ly_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].b66_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.u66_1 = result.u66_1 + 1 | 0;
          }
        }
      }finally {
        temp.h3();
      }
    }
    if (up) {
      this.v66(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.t66_1 = result.t66_1 + 1 | 0;
    }
    return event.w66();
  }
  x66(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  z66(event) {
    return dispatch_0.call(this, event);
  }
  v66(type, event, result) {
  }
  s66(type, event, result) {
  }
  r66(type) {
    var tmp0_safe_receiver = this.l66_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.t66_1 = iterationCount;
    this.u66_1 = resultCount;
  }
  c2q() {
    this.t66_1 = 0;
    this.u66_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.t66_1 + ', resultCount=' + this.u66_1 + ')';
  }
  hashCode() {
    var result = this.t66_1;
    result = imul(result, 31) + this.u66_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.t66_1 === tmp0_other_with_cast.t66_1))
      return false;
    if (!(this.u66_1 === tmp0_other_with_cast.u66_1))
      return false;
    return true;
  }
}
class Companion {}
class Event {
  constructor() {
    this.g67_1 = null;
    this.h67_1 = false;
  }
  i67(_set____db54di) {
    this.g67_1 = _set____db54di;
  }
  t69(reason) {
    throw StopPropagatingException.j6a(reason);
  }
  j67(_set____db54di) {
    this.h67_1 = _set____db54di;
  }
  w66() {
    return this.h67_1;
  }
  k67(reason) {
    this.h67_1 = true;
  }
  l67(reason, $super) {
    reason = reason === VOID ? null : reason;
    var tmp;
    if ($super === VOID) {
      this.k67(reason);
      tmp = Unit_instance;
    } else {
      tmp = $super.k67.call(this, reason);
    }
    return tmp;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.f67_1 = type;
  }
  n29() {
    return this.f67_1;
  }
}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_8);
  }
}
class Companion_0 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_9);
  }
}
class Companion_1 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_10);
  }
}
class Companion_2 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_11);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_19();
    super(Companion_getInstance_19());
    this.p67_1 = true;
    this.q67_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.p67_1 + ', render=' + this.q67_1 + ')';
  }
}
class Companion_3 extends RenderEvent {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_20();
    super(Companion_getInstance_20());
  }
}
class Companion_4 extends InitEvent {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class Companion_5 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_14);
  }
}
class Companion_6 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_15);
    this.u67_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.u67_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.u67_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.u67_1 === tmp0_other_with_cast.u67_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height, setPos) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    setPos = setPos === VOID ? true : setPos;
    super(Companion_instance_16);
    this.y67_1 = x;
    this.z67_1 = y;
    this.a68_1 = width;
    this.b68_1 = height;
    this.c68_1 = setPos;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.y67_1 + ', y=' + this.z67_1 + ', width=' + this.a68_1 + ', height=' + this.b68_1 + ', setPos=' + this.c68_1 + ')';
  }
  hashCode() {
    var result = this.y67_1;
    result = imul(result, 31) + this.z67_1 | 0;
    result = imul(result, 31) + this.a68_1 | 0;
    result = imul(result, 31) + this.b68_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c68_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.y67_1 === tmp0_other_with_cast.y67_1))
      return false;
    if (!(this.z67_1 === tmp0_other_with_cast.z67_1))
      return false;
    if (!(this.a68_1 === tmp0_other_with_cast.a68_1))
      return false;
    if (!(this.b68_1 === tmp0_other_with_cast.b68_1))
      return false;
    if (!(this.c68_1 === tmp0_other_with_cast.c68_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_17 = this;
    this.d68_1 = values();
  }
}
class Type extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.g68_1 = type;
    this.h68_1 = id;
    this.i68_1 = key;
    this.j68_1 = keyCode;
    this.k68_1 = character;
    this.l68_1 = shift;
    this.m68_1 = ctrl;
    this.n68_1 = alt;
    this.o68_1 = meta;
    this.p68_1 = str;
    this.q68_1 = Companion_getInstance().lj_1;
  }
  n29() {
    return this.g68_1;
  }
  r68() {
    var tmp0_elvis_lhs = this.p68_1;
    return tmp0_elvis_lhs == null ? toString_0(this.k68_1) : tmp0_elvis_lhs;
  }
  s68() {
    return Companion_getInstance_2().eu().bu() ? this.o68_1 : this.m68_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.g68_1) + ', id=' + this.h68_1 + ', key=' + this.i68_1.toString() + ', keyCode=' + this.j68_1 + ', character=' + toString_0(this.k68_1) + ', shift=' + this.l68_1 + ', ctrl=' + this.m68_1 + ', alt=' + this.n68_1 + ', meta=' + this.o68_1 + ', str=' + this.p68_1 + ')';
  }
  hashCode() {
    var result = this.g68_1.hashCode();
    result = imul(result, 31) + this.h68_1 | 0;
    result = imul(result, 31) + this.i68_1.hashCode() | 0;
    result = imul(result, 31) + this.j68_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.k68_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l68_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m68_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n68_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o68_1) | 0;
    result = imul(result, 31) + (this.p68_1 == null ? 0 : getStringHashCode(this.p68_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.g68_1.equals(tmp0_other_with_cast.g68_1))
      return false;
    if (!(this.h68_1 === tmp0_other_with_cast.h68_1))
      return false;
    if (!this.i68_1.equals(tmp0_other_with_cast.i68_1))
      return false;
    if (!(this.j68_1 === tmp0_other_with_cast.j68_1))
      return false;
    if (!(this.k68_1 === tmp0_other_with_cast.k68_1))
      return false;
    if (!(this.l68_1 === tmp0_other_with_cast.l68_1))
      return false;
    if (!(this.m68_1 === tmp0_other_with_cast.m68_1))
      return false;
    if (!(this.n68_1 === tmp0_other_with_cast.n68_1))
      return false;
    if (!(this.o68_1 === tmp0_other_with_cast.o68_1))
      return false;
    if (!(this.p68_1 == tmp0_other_with_cast.p68_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_18 = this;
    this.t68_1 = values_0();
  }
}
class Type_0 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.w68_1 = scale;
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.z68_1 = type;
    this.a69_1 = id;
    this.b69_1 = x;
    this.c69_1 = y;
    this.d69_1 = button;
    this.e69_1 = buttons;
    this.f69_1 = scrollDeltaX;
    this.g69_1 = scrollDeltaY;
    this.h69_1 = scrollDeltaZ;
    this.i69_1 = isShiftDown;
    this.j69_1 = isCtrlDown;
    this.k69_1 = isAltDown;
    this.l69_1 = isMetaDown;
    this.m69_1 = scaleCoords;
    this.n69_1 = emulated;
    this.o69_1 = scrollDeltaMode;
    this.p69_1 = null;
    var tmp = this;
    tmp.q69_1 = MouseEvent$requestLock$lambda;
  }
  n29() {
    return this.z68_1;
  }
  r69(other) {
    this.z68_1 = other.z68_1;
    this.a69_1 = other.a69_1;
    this.b69_1 = other.b69_1;
    this.c69_1 = other.c69_1;
    this.d69_1 = other.d69_1;
    this.e69_1 = other.e69_1;
    this.f69_1 = other.f69_1;
    this.g69_1 = other.g69_1;
    this.h69_1 = other.h69_1;
    this.i69_1 = other.i69_1;
    this.j69_1 = other.j69_1;
    this.k69_1 = other.k69_1;
    this.l69_1 = other.l69_1;
    this.m69_1 = other.m69_1;
    this.n69_1 = other.n69_1;
    this.o69_1 = other.o69_1;
  }
  s69(mode, x, y, z) {
    this.o69_1 = mode;
    this.f69_1 = x;
    this.g69_1 = y;
    this.h69_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.z68_1) + ', id=' + this.a69_1 + ', x=' + this.b69_1 + ', y=' + this.c69_1 + ', button=' + this.d69_1.toString() + ', buttons=' + this.e69_1 + ', scrollDeltaX=' + this.f69_1 + ', scrollDeltaY=' + this.g69_1 + ', scrollDeltaZ=' + this.h69_1 + ', isShiftDown=' + this.i69_1 + ', isCtrlDown=' + this.j69_1 + ', isAltDown=' + this.k69_1 + ', isMetaDown=' + this.l69_1 + ', scaleCoords=' + this.m69_1 + ', emulated=' + this.n69_1 + ', scrollDeltaMode=' + this.o69_1.toString() + ')';
  }
  hashCode() {
    var result = this.z68_1.hashCode();
    result = imul(result, 31) + this.a69_1 | 0;
    result = imul(result, 31) + this.b69_1 | 0;
    result = imul(result, 31) + this.c69_1 | 0;
    result = imul(result, 31) + this.d69_1.hashCode() | 0;
    result = imul(result, 31) + this.e69_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.f69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h69_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i69_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j69_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k69_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l69_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m69_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n69_1) | 0;
    result = imul(result, 31) + this.o69_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.z68_1.equals(tmp0_other_with_cast.z68_1))
      return false;
    if (!(this.a69_1 === tmp0_other_with_cast.a69_1))
      return false;
    if (!(this.b69_1 === tmp0_other_with_cast.b69_1))
      return false;
    if (!(this.c69_1 === tmp0_other_with_cast.c69_1))
      return false;
    if (!this.d69_1.equals(tmp0_other_with_cast.d69_1))
      return false;
    if (!(this.e69_1 === tmp0_other_with_cast.e69_1))
      return false;
    if (!equals(this.f69_1, tmp0_other_with_cast.f69_1))
      return false;
    if (!equals(this.g69_1, tmp0_other_with_cast.g69_1))
      return false;
    if (!equals(this.h69_1, tmp0_other_with_cast.h69_1))
      return false;
    if (!(this.i69_1 === tmp0_other_with_cast.i69_1))
      return false;
    if (!(this.j69_1 === tmp0_other_with_cast.j69_1))
      return false;
    if (!(this.k69_1 === tmp0_other_with_cast.k69_1))
      return false;
    if (!(this.l69_1 === tmp0_other_with_cast.l69_1))
      return false;
    if (!(this.m69_1 === tmp0_other_with_cast.m69_1))
      return false;
    if (!(this.n69_1 === tmp0_other_with_cast.n69_1))
      return false;
    if (!this.o69_1.equals(tmp0_other_with_cast.o69_1))
      return false;
    return true;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_19 = this;
    this.u69_1 = values_1();
  }
}
class Type_1 extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.x69_1 = type;
    this.y69_1 = id;
    this.z69_1 = amountX;
    this.a6a_1 = amountY;
  }
  n29() {
    return this.x69_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.x69_1) + ', id=' + this.y69_1 + ', amountX=' + this.z69_1 + ', amountY=' + this.a6a_1 + ')';
  }
  hashCode() {
    var result = this.x69_1.hashCode();
    result = imul(result, 31) + this.y69_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.z69_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a6a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.x69_1.equals(tmp0_other_with_cast.x69_1))
      return false;
    if (!(this.y69_1 === tmp0_other_with_cast.y69_1))
      return false;
    if (!equals(this.z69_1, tmp0_other_with_cast.z69_1))
      return false;
    if (!equals(this.a6a_1, tmp0_other_with_cast.a6a_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    this.b6a_1 = values_2();
  }
}
class Type_2 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance() : type;
    files = files === VOID ? null : files;
    super();
    this.e6a_1 = type;
    this.f6a_1 = files;
  }
  n29() {
    return this.e6a_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.e6a_1) + ', files=' + toString_1(this.f6a_1) + ')';
  }
  hashCode() {
    var result = this.e6a_1.hashCode();
    result = imul(result, 31) + (this.f6a_1 == null ? 0 : hashCode(this.f6a_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.e6a_1.equals(tmp0_other_with_cast.e6a_1))
      return false;
    if (!equals(this.f6a_1, tmp0_other_with_cast.f6a_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  static j6a(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.sd();
    captureStack($this, $this.i6a_1);
    $this.h6a_1 = reason;
    return $this;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    this.k6a_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_28();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_4().g25_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.l6a_1 = new Mixin();
    this.m6a_1 = index;
    this.n6a_1 = id;
    this.o6a_1 = p;
    this.p6a_1 = force;
    this.q6a_1 = status;
    this.r6a_1 = kind;
    this.s6a_1 = button;
  }
  t6a() {
    return this.o6a_1.e25_1;
  }
  u6a() {
    return this.o6a_1.f25_1;
  }
  u14() {
    return !this.q6a_1.equals(Status_REMOVE_getInstance());
  }
  v6a(other) {
    this.n6a_1 = other.n6a_1;
    this.o6a_1 = other.o6a_1;
    this.p6a_1 = other.p6a_1;
    this.q6a_1 = other.q6a_1;
    this.r6a_1 = other.r6a_1;
    this.s6a_1 = other.s6a_1;
  }
  hashCode() {
    return this.m6a_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.m6a_1 === other.m6a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.m6a_1 + ', id=' + this.n6a_1 + ', p=' + this.o6a_1.toString() + ', force=' + this.p6a_1 + ', status=' + this.q6a_1.toString() + ', kind=' + this.r6a_1.toString() + ', button=' + this.s6a_1.toString() + ')';
  }
  vx(value) {
    this.l6a_1.vx(value);
  }
  wx() {
    return this.l6a_1.wx();
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    this.w6a_1 = values_3();
  }
}
class Type_3 extends Enum {}
class Companion_14 {
  constructor() {
    this.x6a_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_8().j1u_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.a6b_1 = type;
    this.b6b_1 = screen;
    this.c6b_1 = currentTime;
    this.d6b_1 = scaleCoords;
    this.e6b_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_23.x6a_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.f6b_1 = tmp_2;
    this.g6b_1 = FastArrayList.ny();
    this.h6b_1 = FastArrayList.ny();
    this.i6b_1 = FastIntMap();
  }
  n29() {
    return this.a6b_1;
  }
  j6b() {
    return this.g6b_1;
  }
  k6b() {
    return this.j6b().e1();
  }
  l6b(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.i6b_1.get(id);
  }
  toString() {
    var tmp = toString(this.a6b_1);
    var tmp_0 = this.k6b();
    var tmp_1 = this.j6b();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  m6b(type) {
    this.a6b_1 = type;
    this.c6b_1 = Companion_getInstance_8().n1u();
    this.g6b_1.h3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.i6b_1.clear();
  }
  n6b() {
    this.h6b_1.h3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.j6b();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      if (it.u14()) {
        this.h6b_1.h(it);
      }
    }
  }
  o6b(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.i6b_1.get(id);
    return tmp0_elvis_lhs == null ? this.p6b(id) : tmp0_elvis_lhs;
  }
  p6b(id) {
    var touch = this.f6b_1[this.g6b_1.e1()];
    touch.n6a_1 = id;
    this.g6b_1.h(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.i6b_1;
    var key = touch.n6a_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  }
  q6b(id, p, status, force, kind, button) {
    var touch = this.o6b(id);
    touch.o6a_1 = p;
    touch.q6a_1 = status;
    touch.p6a_1 = force;
    touch.r6a_1 = kind;
    touch.s6a_1 = button;
  }
  r6b(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.q6b(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.q6b.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  s6b(touch) {
    this.q6b(touch.n6a_1, touch.o6a_1, touch.q6a_1, touch.p6a_1, touch.r6a_1, touch.s6a_1);
  }
  t6b(other) {
    this.a6b_1 = other.a6b_1;
    this.b6b_1 = other.b6b_1;
    this.c6b_1 = other.c6b_1;
    this.d6b_1 = other.d6b_1;
    this.e6b_1 = other.e6b_1;
    var inductionVariable = 0;
    var last = Companion_instance_23.x6a_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.f6b_1[n].v6a(other.f6b_1[n]);
      }
       while (inductionVariable < last);
    this.g6b_1.h3();
    this.h6b_1.h3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.i6b_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.j6b();
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.d1(_unary__edvuaz);
      var touch = this.f6b_1[otherTouch.m6a_1];
      this.g6b_1.h(touch);
      if (touch.u14()) {
        this.h6b_1.h(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.i6b_1;
      var key = touch.n6a_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  }
  u6b() {
    return this.a6b_1.equals(Type_START_getInstance_0());
  }
  v6b() {
    return this.a6b_1.equals(Type_END_getInstance_0());
  }
  hashCode() {
    var result = this.a6b_1.hashCode();
    result = imul(result, 31) + this.b6b_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.c6b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d6b_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e6b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.a6b_1.equals(tmp0_other_with_cast.a6b_1))
      return false;
    if (!(this.b6b_1 === tmp0_other_with_cast.b6b_1))
      return false;
    if (!equals(this.c6b_1, tmp0_other_with_cast.c6b_1))
      return false;
    if (!(this.d6b_1 === tmp0_other_with_cast.d6b_1))
      return false;
    if (!(this.e6b_1 === tmp0_other_with_cast.e6b_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.w6b_1 = new TouchEvent();
    this.x6b_1 = new TouchEvent();
    this.y6b_1 = Mode_JS_getInstance();
  }
  z6b(type, scaleCoords) {
    this.x6b_1.d6b_1 = scaleCoords;
    this.x6b_1.m6b(type);
    if (this.y6b_1.n3_1 === 2) {
      this.x6b_1.t6b(this.w6b_1);
      this.x6b_1.a6b_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.x6b_1.g6b_1;
      var n = 0;
      var m = 0;
      while (n < this_0.e1()) {
        if (m >= 0 && !(m === n)) {
          this_0.k3(m, this_0.d1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.d1(n);
        var tmp;
        if (it.u14()) {
          it.q6a_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.x6b_1.i6b_1;
          var key = it.n6a_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.e1() > m) {
        this_0.l3(this_0.e1() - 1 | 0);
      }
    }
  }
  a6c() {
    switch (this.y6b_1.n3_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.w6b_1.j6b();
        var n = 0;
        while (n < this_0.e1()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.d1(_unary__edvuaz);
          if (this.x6b_1.l6b(oldTouch.n6a_1) == null) {
            if (oldTouch.u14()) {
              oldTouch.q6a_1 = Status_REMOVE_getInstance();
              this.x6b_1.s6b(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.x6b_1.n6b();
    this.w6b_1.t6b(this.x6b_1);
    return this.x6b_1;
  }
  b6c(id, p, force, kind, button) {
    var touch = this.x6b_1.o6b(id);
    touch.o6a_1 = p;
    touch.p6a_1 = force;
    touch.r6a_1 = kind;
    touch.s6a_1 = button;
    if (this.y6b_1.n3_1 === 2) {
      var tmp = touch;
      switch (this.x6b_1.a6b_1.n3_1) {
        case 0:
          tmp.q6a_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.q6a_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.q6a_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.w6b_1.l6b(id);
      touch.q6a_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  c6c(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.b6c(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.b6c.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.d6c_1 = dispatcher;
    this.e6c_1 = booleanArray(4);
    this.f6c_1 = new GamePadUpdateEvent();
    this.g6c_1 = new GamePadConnectionEvent();
    this.h6c_1 = IntArrayList.n2j();
  }
  i6c() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.f6c_1.m6c_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].o6c_1 = false;
    }
    this.f6c_1.l6c_1 = 0;
  }
  u6c(info) {
    var _receiver__tnumb7 = this.f6c_1;
    var _unary__edvuaz = _receiver__tnumb7.l6c_1;
    _receiver__tnumb7.l6c_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.f6c_1.m6c_1[index];
    pad.v6c(info);
    pad.o6c_1 = true;
    pad.n6c_1 = index;
  }
  w6c(out) {
    out.h3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.f6c_1.m6c_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.e6c_1[it.n6c_1] === it.o6c_1)) {
        this.e6c_1[it.n6c_1] = it.o6c_1;
        out.t2j(it.n6c_1);
        if (!it.o6c_1) {
          it.p6c_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.g6c_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.z6c_1 = Companion_getInstance_33().c6d(it.o6c_1);
        this_1.a6d_1 = it.n6c_1;
        this.d6c_1.z66(this_1);
      }
    }
    this.d6c_1.z66(this.f6c_1);
    return out;
  }
}
class BatteryStatus extends Enum {}
class Companion_15 {
  constructor() {
    this.d6d_1 = 'Wireless Controller';
    this.e6d_1 = 4;
    this.f6d_1 = 0.075;
  }
  g6d(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  h6d(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.g6d(value, margin, apply) : $super.g6d.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_24.d6d_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.n6c_1 = index;
    this.o6c_1 = connected;
    this.p6c_1 = name;
    this.q6c_1 = rawButtons;
    this.r6c_1 = batteryLevel;
    this.s6c_1 = name2;
    this.t6c_1 = batteryStatus;
  }
  i6d() {
    var tmp0_elvis_lhs = this.p6c_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.s6c_1;
  }
  v6c(that) {
    this.n6c_1 = that.n6c_1;
    this.p6c_1 = that.p6c_1;
    this.s6c_1 = that.s6c_1;
    this.o6c_1 = that.o6c_1;
    this.r6c_1 = that.r6c_1;
    this.t6c_1 = that.t6c_1;
    var tmp = that.q6c_1;
    var tmp_0 = this.q6c_1;
    // Inline function 'kotlin.math.min' call
    var a = this.q6c_1.length;
    var b = that.q6c_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  j6d(button) {
    return this.q6c_1[button.m6d()];
  }
  n6d(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.ob('Gamepad[' + this.n6c_1 + '][' + this.i6d() + ']');
    if (includeButtons) {
      this_0.ob('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.j6d(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.ob(',');
          }
          this_0.ob(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.ob(']');
    }
    return this_0.toString();
  }
  o6d(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.n6d(includeButtons) : $super.n6d.call(this, includeButtons);
  }
  toString() {
    return this.n6d(false);
  }
}
class Companion_16 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.l6c_1 = gamepadsLength;
    this.m6c_1 = gamepads;
  }
  n29() {
    return Companion_instance_25;
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.m6c_1;
    var destination = ArrayList.h1();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.o6c_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.o6d();
      destination_0.h(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.l6c_1;
    result = imul(result, 31) + hashCode(this.m6c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.l6c_1 === tmp0_other_with_cast.l6c_1))
      return false;
    if (!equals(this.m6c_1, tmp0_other_with_cast.m6c_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.b6d_1 = values_4();
  }
  c6d(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.z6c_1 = type;
    this.a6d_1 = gamepad;
  }
  n29() {
    return this.z6c_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.z6c_1) + ', gamepad=' + this.a6d_1 + ')';
  }
  hashCode() {
    var result = this.z6c_1.hashCode();
    result = imul(result, 31) + this.a6d_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.z6c_1.equals(tmp0_other_with_cast.z6c_1))
      return false;
    if (!(this.a6d_1 === tmp0_other_with_cast.a6d_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.p6d_1 = values_5();
    this.q6d_1 = 32;
  }
}
class GameButton extends Enum {
  m6d() {
    return this.n3_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.r6d_1 = Key_UNKNOWN_getInstance().n3_1 + 1 | 0;
    this.s6d_1 = Key_ENTER_getInstance();
    this.t6d_1 = Key_N0_getInstance();
    this.u6d_1 = Key_N1_getInstance();
    this.v6d_1 = Key_N2_getInstance();
    this.w6d_1 = Key_N3_getInstance();
    this.x6d_1 = Key_N4_getInstance();
    this.y6d_1 = Key_N5_getInstance();
    this.z6d_1 = Key_N6_getInstance();
    this.a6e_1 = Key_N7_getInstance();
    this.b6e_1 = Key_N8_getInstance();
    this.c6e_1 = Key_N9_getInstance();
  }
  d6e() {
    return Key_CONTROL_getInstance();
  }
  e6e() {
    return Key_CONTROL_getInstance();
  }
  f6e() {
    return Key_SHIFT_getInstance();
  }
  g6e() {
    return Key_SHIFT_getInstance();
  }
  h6e() {
    return Key_ALT_getInstance();
  }
  i6e() {
    return Key_ALT_getInstance();
  }
  j6e() {
    return Key_SUPER_getInstance();
  }
  k6e() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  n6e() {
    switch (this.n3_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.o6e_1 = MouseButton_NONE_getInstance().n3_1 + 1 | 0;
    this.p6e_1 = values_6();
  }
  d1(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.p6e_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.s6e_1 = id;
    this.t6e_1 = bits;
  }
}
class ISoftKeyboardConfig {}
class SoftKeyboardType extends Enum {}
class SoftKeyboardReturnKeyType extends Enum {}
class SoftKeyboardConfig {
  constructor(softKeyboardType, softKeyboardSmartDashes, softKeyboardSmartQuotes, softKeyboardSpellChecking, softKeyboardTextContentType, softKeyboardSmartInsertDelete, softKeyboardPassword, softKeyboardReturnKeyType, softKeyboardAutocapitalization, softKeyboardAutocorrection, softKeyboardEnablesReturnKeyAutomatically) {
    softKeyboardType = softKeyboardType === VOID ? SoftKeyboardType_DEFAULT_getInstance() : softKeyboardType;
    softKeyboardSmartDashes = softKeyboardSmartDashes === VOID ? null : softKeyboardSmartDashes;
    softKeyboardSmartQuotes = softKeyboardSmartQuotes === VOID ? null : softKeyboardSmartQuotes;
    softKeyboardSpellChecking = softKeyboardSpellChecking === VOID ? null : softKeyboardSpellChecking;
    softKeyboardTextContentType = softKeyboardTextContentType === VOID ? null : softKeyboardTextContentType;
    softKeyboardSmartInsertDelete = softKeyboardSmartInsertDelete === VOID ? null : softKeyboardSmartInsertDelete;
    softKeyboardPassword = softKeyboardPassword === VOID ? false : softKeyboardPassword;
    softKeyboardReturnKeyType = softKeyboardReturnKeyType === VOID ? SoftKeyboardReturnKeyType_DEFAULT_getInstance() : softKeyboardReturnKeyType;
    softKeyboardAutocapitalization = softKeyboardAutocapitalization === VOID ? null : softKeyboardAutocapitalization;
    softKeyboardAutocorrection = softKeyboardAutocorrection === VOID ? null : softKeyboardAutocorrection;
    softKeyboardEnablesReturnKeyAutomatically = softKeyboardEnablesReturnKeyAutomatically === VOID ? false : softKeyboardEnablesReturnKeyAutomatically;
    this.u6e_1 = softKeyboardType;
    this.v6e_1 = softKeyboardSmartDashes;
    this.w6e_1 = softKeyboardSmartQuotes;
    this.x6e_1 = softKeyboardSpellChecking;
    this.y6e_1 = softKeyboardTextContentType;
    this.z6e_1 = softKeyboardSmartInsertDelete;
    this.a6f_1 = softKeyboardPassword;
    this.b6f_1 = softKeyboardReturnKeyType;
    this.c6f_1 = softKeyboardAutocapitalization;
    this.d6f_1 = softKeyboardAutocorrection;
    this.e6f_1 = softKeyboardEnablesReturnKeyAutomatically;
  }
  toString() {
    return 'SoftKeyboardConfig(softKeyboardType=' + this.u6e_1.toString() + ', softKeyboardSmartDashes=' + this.v6e_1 + ', softKeyboardSmartQuotes=' + this.w6e_1 + ', softKeyboardSpellChecking=' + this.x6e_1 + ', softKeyboardTextContentType=' + this.y6e_1 + ', softKeyboardSmartInsertDelete=' + this.z6e_1 + ', softKeyboardPassword=' + this.a6f_1 + ', softKeyboardReturnKeyType=' + this.b6f_1.toString() + ', softKeyboardAutocapitalization=' + this.c6f_1 + ', softKeyboardAutocorrection=' + this.d6f_1 + ', softKeyboardEnablesReturnKeyAutomatically=' + this.e6f_1 + ')';
  }
  hashCode() {
    var result = this.u6e_1.hashCode();
    result = imul(result, 31) + (this.v6e_1 == null ? 0 : getBooleanHashCode(this.v6e_1)) | 0;
    result = imul(result, 31) + (this.w6e_1 == null ? 0 : getBooleanHashCode(this.w6e_1)) | 0;
    result = imul(result, 31) + (this.x6e_1 == null ? 0 : getBooleanHashCode(this.x6e_1)) | 0;
    result = imul(result, 31) + (this.y6e_1 == null ? 0 : getStringHashCode(this.y6e_1)) | 0;
    result = imul(result, 31) + (this.z6e_1 == null ? 0 : getBooleanHashCode(this.z6e_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a6f_1) | 0;
    result = imul(result, 31) + this.b6f_1.hashCode() | 0;
    result = imul(result, 31) + (this.c6f_1 == null ? 0 : getBooleanHashCode(this.c6f_1)) | 0;
    result = imul(result, 31) + (this.d6f_1 == null ? 0 : getBooleanHashCode(this.d6f_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e6f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SoftKeyboardConfig))
      return false;
    var tmp0_other_with_cast = other instanceof SoftKeyboardConfig ? other : THROW_CCE();
    if (!this.u6e_1.equals(tmp0_other_with_cast.u6e_1))
      return false;
    if (!(this.v6e_1 == tmp0_other_with_cast.v6e_1))
      return false;
    if (!(this.w6e_1 == tmp0_other_with_cast.w6e_1))
      return false;
    if (!(this.x6e_1 == tmp0_other_with_cast.x6e_1))
      return false;
    if (!(this.y6e_1 == tmp0_other_with_cast.y6e_1))
      return false;
    if (!(this.z6e_1 == tmp0_other_with_cast.z6e_1))
      return false;
    if (!(this.a6f_1 === tmp0_other_with_cast.a6f_1))
      return false;
    if (!this.b6f_1.equals(tmp0_other_with_cast.b6f_1))
      return false;
    if (!(this.c6f_1 == tmp0_other_with_cast.c6f_1))
      return false;
    if (!(this.d6f_1 == tmp0_other_with_cast.d6f_1))
      return false;
    if (!(this.e6f_1 === tmp0_other_with_cast.e6f_1))
      return false;
    return true;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.f6f_1 = Companion_getInstance_1().mw('AG');
    this.g6f_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_isUniformBuffersSupported() {
  var tmp0_safe_receiver = this.h6g();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6g();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp0_safe_receiver = this.h6g();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j6g();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
class AG {
  static l6f() {
    Companion_getInstance_37();
    var $this = createThis(this);
    $this.h6f_1 = new Mixin();
    $this.i6f_1 = AGFrameBuffer.z6f(true);
    $this.j6f_1 = 0;
    $this.k6f_1 = new AGStats();
    return $this;
  }
  a6g() {
    return this.i6f_1;
  }
  b6g() {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_37().f6f_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.k2t(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_37().f6f_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.j2t(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.k2t(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.j6f_1 = this.j6f_1 + 1 | 0;
  }
  c6g() {
    return this.d6g(AGFinish_instance);
  }
  e6g() {
    return Unit_instance;
  }
  n6b() {
    return Unit_instance;
  }
  d6g(command) {
    return Unit_instance;
  }
  f6g(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.d6g(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  g6g(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.d6g(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
  vx(value) {
    this.h6f_1.vx(value);
  }
  wx() {
    return this.h6f_1.wx();
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.t6h_1 = parentFeatures;
    this.u6h_1 = graphicExtensions;
    this.v6h_1 = isInstancedSupported;
    this.w6h_1 = isUniformBuffersSupported;
    this.x6h_1 = isVertexArraysSupported;
    this.y6h_1 = isStorageMultisampleSupported;
    this.z6h_1 = isFloatTextureSupported;
  }
  h6g() {
    return this.t6h_1;
  }
  i6g() {
    return this.w6h_1;
  }
  j6g() {
    return this.x6h_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.t6h_1) + ', graphicExtensions=' + toString(this.u6h_1) + ', isInstancedSupported=' + this.v6h_1 + ', isUniformBuffersSupported=' + this.w6h_1 + ', isVertexArraysSupported=' + this.x6h_1 + ', isStorageMultisampleSupported=' + this.y6h_1 + ', isFloatTextureSupported=' + this.z6h_1 + ')';
  }
  hashCode() {
    var result = this.t6h_1 == null ? 0 : hashCode(this.t6h_1);
    result = imul(result, 31) + hashCode(this.u6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y6h_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z6h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.t6h_1, tmp0_other_with_cast.t6h_1))
      return false;
    if (!equals(this.u6h_1, tmp0_other_with_cast.u6h_1))
      return false;
    if (!(this.v6h_1 === tmp0_other_with_cast.v6h_1))
      return false;
    if (!(this.w6h_1 === tmp0_other_with_cast.w6h_1))
      return false;
    if (!(this.x6h_1 === tmp0_other_with_cast.x6h_1))
      return false;
    if (!(this.y6h_1 === tmp0_other_with_cast.y6h_1))
      return false;
    if (!(this.z6h_1 === tmp0_other_with_cast.z6h_1))
      return false;
    return true;
  }
}
class AGObject {
  constructor() {
    this.a6j_1 = null;
    this.b6j_1 = -1;
    this.c6j_1 = -2;
    this.d6j_1 = -1;
  }
  k6j() {
    this.e6j();
    this.c6j_1 = this.d6j_1 - 1 | 0;
  }
  e6j() {
    this.d6j_1 = this.d6j_1 + 1 | 0;
  }
  c6() {
    var tmp0_safe_receiver = this.a6j_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l6m();
    }
    this.a6j_1 = null;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.z6i_1 = null;
  }
  f6j(data, offset, length) {
    return upload(this, _Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)), false);
  }
  g6j(data, offset, length) {
    return upload(this, _Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(data, offset, length)), false);
  }
  h6j(data, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? data.length - offset | 0 : length;
    return $super === VOID ? this.g6j(data, offset, length) : $super.g6j.call(this, data, offset, length);
  }
  i6j(data, offset, length) {
    return upload(this, sliceWithSize(data, offset, length), true);
  }
  j6j(data) {
    return upload(this, data, true);
  }
  toString() {
    var tmp0_safe_receiver = this.z6i_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j12();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  }
}
class Companion_22 {
  constructor() {
    this.v6g_1 = 8;
  }
  w6g() {
    return AGTextureUnits.n6j();
  }
}
class AGTextureUnits {
  static o6j(textures, infos) {
    var $this = createThis(this);
    $this.l6j_1 = textures;
    $this.m6j_1 = infos;
    return $this;
  }
  static n6j(size) {
    size = size === VOID ? Companion_instance_31.v6g_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.o6j(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  e1() {
    return this.l6j_1.length;
  }
  p6j(index, texture, info) {
    this.l6j_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.m6j_1, index, info);
  }
  q6j(sampler, texture, info) {
    this.p6j(sampler.c6k_1, texture, info);
  }
  e6k(sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_40().g6k_1 : info;
    var tmp;
    if ($super === VOID) {
      this.q6j(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.q6j.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  h3() {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.p6j(n, null, Companion_getInstance_40().g6k_1);
      }
       while (inductionVariable < last);
  }
  sx() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.l6j_1.slice();
    return AGTextureUnits.o6j(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.m6j_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.l6j_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.m6j_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.l6j_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.m6j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.l6j_1, tmp0_other_with_cast.l6j_1))
      return false;
    if (!equals(this.m6j_1, tmp0_other_with_cast.m6j_1))
      return false;
    return true;
  }
}
class Companion_23 {
  constructor() {
    this.h6k_1 = 128;
    this.i6k_1 = 128;
  }
}
class AGFrameBuffer {
  static j6k(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.m6f_1 = base;
    $this.n6f_1 = id;
    $this.o6f_1 = 1;
    $this.p6f_1 = true;
    $this.q6f_1 = true;
    $this.r6f_1 = 0;
    $this.s6f_1 = 0;
    $this.t6f_1 = 128;
    $this.u6f_1 = 128;
    $this.v6f_1 = 128;
    $this.w6f_1 = 128;
    $this.x6f_1 = RectangleInt.h2f();
    $this.y6f_1 = null;
    return $this;
  }
  static z6f(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.j6k(new AGFrameBufferBase(isMain), id);
  }
  k6k() {
    return this.m6f_1.k6k();
  }
  s6k() {
    return this.m6f_1.p6k_1;
  }
  t6k() {
    return this.m6f_1.q6k_1;
  }
  s6h() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.r6f_1, this.s6f_1, this.t6f_1, this.u6f_1), this.o6f_1), this.q6f_1), this.p6f_1);
  }
  u6k(width, height) {
    return this.v6k(0, 0, width, height);
  }
  w6k(x, y, width, height, fullWidth, fullHeight) {
    if (this.r6f_1 === x && this.s6f_1 === y && this.t6f_1 === width && this.u6f_1 === height && this.v6f_1 === fullWidth && this.w6f_1 === fullHeight)
      return true;
    this.t6k().l6l(NullBitmap.o4c(width, height));
    this.m6f_1.r6k_1 = Companion_getInstance_9().i14(imul(imul(fullWidth, fullHeight), 8));
    this.r6f_1 = x;
    this.s6f_1 = y;
    this.t6f_1 = width;
    this.u6f_1 = height;
    this.v6f_1 = fullWidth;
    this.w6f_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  v6k(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.w6k(x, y, width, height, fullWidth, fullHeight) : $super.w6k.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  c6() {
    this.m6f_1.c6();
  }
  m6l(samples) {
    if (this.o6f_1 === samples)
      return Unit_instance;
    this.o6f_1 = samples;
    markAsDirty(this);
  }
  n6l(hasDepth, hasStencil) {
    if (this.q6f_1 === hasDepth && this.p6f_1 === hasStencil)
      return Unit_instance;
    this.q6f_1 = hasDepth;
    this.p6f_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.s6k() ? 'main' : '' + this.n6f_1) + ', ' + this.t6f_1 + ', ' + this.u6f_1 + ')';
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_51().o6l_1 : targetKind;
    super();
    this.b6l_1 = targetKind;
    this.c6l_1 = Companion_getInstance_1().mw('AGTexture');
    this.d6l_1 = false;
    this.e6l_1 = false;
    this.f6l_1 = null;
    this.g6l_1 = null;
    this.h6l_1 = null;
    this.i6l_1 = false;
    this.j6l_1 = null;
    this.k6l_1 = Companion_getInstance_9().j14(new Long(0, 0));
  }
  s6l() {
    var tmp0_safe_receiver = this.j6l_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m4b();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_51(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.b6l_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  m2i() {
    var tmp0_safe_receiver = this.h6l_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l3x_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  n2i() {
    var tmp0_safe_receiver = this.h6l_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m3x_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  u6l() {
    var tmp = this.h6l_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6m_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  }
  j6m(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.j6l_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.h6l_1 = bmp;
    this.k6l_1 = Companion_getInstance_9().i14(imul(imul(imul(this.m2i(), this.n2i()), this.u6l()), 4));
    this.e6j();
    this.e6l_1 = mipmaps;
    this.f6l_1 = baseMipmapLevel;
    this.g6l_1 = maxMipmapLevel;
    return this;
  }
  l6l(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.j6m(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.j6m.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  k6m(bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.l3x_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.m3x_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.m2i() + ',' + this.n2i() + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.p6k_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.d6l_1 = true;
    tmp.q6k_1 = this_0;
    this.r6k_1 = Companion_getInstance_9().i14(0);
  }
  k6k() {
    return !this.p6k_1;
  }
  c6() {
    this.q6k_1.c6();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.p6k_1 + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    this.f6k_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.g6k_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_52().n6m_1), Companion_getInstance_51().o6l_1);
  }
  m6m(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  q6m(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  r6m(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_52().n6m_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.q6m(wrap, linear, trilinear) : $super.q6m.call(this, new AGWrapMode(wrap), linear, trilinear).s6m_1;
  }
}
class AGTextureUnitInfo {
  constructor(data) {
    Companion_getInstance_40();
    this.s6m_1 = data;
  }
  toString() {
    return AGTextureUnitInfo__toString_impl_7im6je(this.s6m_1);
  }
  hashCode() {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.s6m_1);
  }
  equals(other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.s6m_1, other);
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.t6m_1 = FastIdentityMap();
  }
  c2q() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.t6m_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).c2q();
    }
  }
  c6n() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.t6m_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).d6n();
    }
  }
  e6n(block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.t6m_1;
      var res = get_0(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.f6n_1 = program;
    this.g6n_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.f6n_1.s6n_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.m6o_1;
      destination.h(tmp$ret$0);
    }
    tmp.h6n_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.h6n_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.c1().o6o_1 + 1 | 0;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.c1().o6o_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.i6n_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.i6n_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var _iterator__ex2g4s = this.h6n_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var layout = _iterator__ex2g4s.c1();
      tmp_4[layout.o6o_1] = layout;
    }
    tmp_1.j6n_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.j6n_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.j6n_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.g6n_1.e6n(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.k6n_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.j6n_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.k6n_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.u6m_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.l6n_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.j6n_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.k6n_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.v6m_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.m6n_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.j6n_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.n6n_1 = tmp_25;
  }
  s6o() {
    var inductionVariable = 0;
    var last = this.n6n_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.k6n_1[n];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6o();
        this.n6n_1[n] = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.n6n_1.slice();
    return new UniformBlocksBuffersRef(this.l6n_1, this.m6n_1, tmp$ret$1);
  }
}
class AGVertexArrayObject {
  static x6o(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.u6o_1 = new Mixin();
    $this.v6o_1 = list;
    $this.w6o_1 = isDynamic;
    return $this;
  }
  static y6o(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.x6o(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.v6o_1.toString() + ', isDynamic=' + this.w6o_1 + ')';
  }
  hashCode() {
    var result = this.v6o_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.w6o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.v6o_1.equals(tmp0_other_with_cast.v6o_1))
      return false;
    if (!(this.w6o_1 === tmp0_other_with_cast.w6o_1))
      return false;
    return true;
  }
  vx(value) {
    this.u6o_1.vx(value);
  }
  wx() {
    return this.u6o_1.wx();
  }
}
class AGVertexData {
  constructor(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.h6p([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.i6p_1 = layout;
    this.j6p_1 = buffer;
    this.k6p_1 = baseOffset;
  }
  toString() {
    return 'AGVertexData(layout=' + this.i6p_1.toString() + ', buffer=' + this.j6p_1.toString() + ', baseOffset=' + this.k6p_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.i6p_1);
    result = imul(result, 31) + hashCode(this.j6p_1) | 0;
    result = imul(result, 31) + this.k6p_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.i6p_1, tmp0_other_with_cast.i6p_1))
      return false;
    if (!equals(this.j6p_1, tmp0_other_with_cast.j6p_1))
      return false;
    if (!(this.k6p_1 === tmp0_other_with_cast.k6p_1))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.l6p_1 = _AGDrawType___init__impl__emm6mb(0);
    this.m6p_1 = _AGDrawType___init__impl__emm6mb(1);
    this.n6p_1 = _AGDrawType___init__impl__emm6mb(2);
    this.o6p_1 = _AGDrawType___init__impl__emm6mb(3);
    this.p6p_1 = _AGDrawType___init__impl__emm6mb(4);
    this.q6p_1 = _AGDrawType___init__impl__emm6mb(5);
    this.r6p_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class AGDrawType {
  constructor(ordinal) {
    Companion_getInstance_41();
    this.s6p_1 = ordinal;
  }
  toString() {
    return AGDrawType__toString_impl_eonaeb(this.s6p_1);
  }
  hashCode() {
    return AGDrawType__hashCode_impl_ylaury(this.s6p_1);
  }
  equals(other) {
    return AGDrawType__equals_impl_rtafo6(this.s6p_1, other);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.k6g_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.l6g_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.m6g_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.n6g_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.o6g_1 = _AGBlending___init__impl__upt3bq(-1);
    this.p6g_1 = Companion_getInstance_43().h6q(Companion_getInstance_53().z6p_1, Companion_getInstance_53().g6q_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().g6q_1);
    this.q6g_1 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().c6q_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().c6q_1);
    this.r6g_1 = Companion_getInstance_43().i6q(Companion_getInstance_53().z6p_1, Companion_getInstance_53().c6q_1);
    this.s6g_1 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().x6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
    this.t6g_1 = Companion_getInstance_43().h6q(Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
  }
  j6q(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  h6q(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_54().k6q_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.j6q(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.j6q.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).t6p_1;
  }
  n6q(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  i6q(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_54().k6q_1 : eq;
    return $super === VOID ? this.n6q(src, dst, eq) : $super.n6q.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).t6p_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_43();
    this.t6p_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.t6p_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.t6p_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.t6p_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.j6h_1 = AGScissor.s6q(0, 0, 0, 0);
    this.k6h_1 = Companion_getInstance_44().y2d(-2147483648, -2147483648, 2147483647, 2147483647);
    this.l6h_1 = Companion_getInstance_44().y2d(-32766, -32766, 2147483647, 2147483647);
    this.m6h_1 = Companion_getInstance_44().y2d(-32767, -32767, 2147483647, 2147483647);
  }
  y2d(left, top, right, bottom) {
    return AGScissor.s6q(left, top, right - left | 0, bottom - top | 0);
  }
  t6q(left, top, right, bottom) {
    return AGScissor.u6q(left, top, right - left, bottom - top);
  }
  v6q(rect) {
    if (rect == null)
      return this.m6h_1;
    if (rect.t25())
      return this.m6h_1;
    return AGScissor.w6q(rect.o25_1, rect.p25_1, rect.q25_1, rect.r25_1);
  }
  x6q(prev, next) {
    if (prev.equals(this.m6h_1))
      return next;
    if (next.equals(this.m6h_1))
      return prev;
    var intersectsX = prev.v25() <= next.w25() && prev.w25() >= next.v25();
    var intersectsY = prev.x25() <= next.y25() && prev.y25() >= next.x25();
    if (!intersectsX || !intersectsY)
      return this.j6h_1;
    // Inline function 'kotlin.math.max' call
    var a = prev.v25();
    var b = next.v25();
    var left = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = prev.x25();
    var b_0 = next.x25();
    var top = Math.max(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = prev.w25();
    var b_1 = next.w25();
    var right = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.min' call
    var a_2 = prev.y25();
    var b_2 = next.y25();
    var bottom = Math.min(a_2, b_2);
    return this.y2d(left, top, right, bottom);
  }
}
class AGScissor {
  static y6q(_left, _top, _right, _bottom) {
    Companion_getInstance_44();
    var $this = createThis(this);
    $this.o6q_1 = _left;
    $this.p6q_1 = _top;
    $this.q6q_1 = _right;
    $this.r6q_1 = _bottom;
    return $this;
  }
  t25() {
    return this.equals(Companion_getInstance_44().m6h_1);
  }
  static s6q(x, y, width, height) {
    Companion_getInstance_44();
    return this.y6q(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static u6q(x, y, width, height) {
    Companion_getInstance_44();
    return this.s6q(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static w6q(x, y, width, height) {
    Companion_getInstance_44();
    return this.s6q(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  v25() {
    return this.o6q_1;
  }
  x25() {
    return this.p6q_1;
  }
  w25() {
    return this.q6q_1;
  }
  y25() {
    return this.r6q_1;
  }
  t6a() {
    return this.v25();
  }
  u6a() {
    return this.x25();
  }
  m2i() {
    return this.w25() - this.v25() | 0;
  }
  n2i() {
    return this.y25() - this.x25() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_44().m6h_1))
      return 'null';
    return 'Scissor(x=' + this.t6a() + ', y=' + this.u6a() + ', width=' + this.m2i() + ', height=' + this.n2i() + ')';
  }
  z6q() {
    return this.t25() ? Companion_getInstance_5().d26() : Companion_getInstance_5().u2d(this.t6a(), this.u6a(), this.m2i(), this.n2i());
  }
  a6r() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.z6q();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.u25()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.o6q_1;
    result = imul(result, 31) + this.p6q_1 | 0;
    result = imul(result, 31) + this.q6q_1 | 0;
    result = imul(result, 31) + this.r6q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.o6q_1 === tmp0_other_with_cast.o6q_1))
      return false;
    if (!(this.p6q_1 === tmp0_other_with_cast.p6q_1))
      return false;
    if (!(this.q6q_1 === tmp0_other_with_cast.q6q_1))
      return false;
    if (!(this.r6q_1 === tmp0_other_with_cast.r6q_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.c6r_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.d6r_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.e6r_1 = frameBuffer;
    this.f6r_1 = frameBufferInfo;
    this.g6r_1 = color;
    this.h6r_1 = depth;
    this.i6r_1 = stencil;
    this.j6r_1 = clearColor;
    this.k6r_1 = clearDepth;
    this.l6r_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.e6r_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.f6r_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.g6r_1) + ', depth=' + this.h6r_1 + ', stencil=' + this.i6r_1 + ', clearColor=' + this.j6r_1 + ', clearDepth=' + this.k6r_1 + ', clearStencil=' + this.l6r_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.e6r_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.f6r_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.g6r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h6r_1) | 0;
    result = imul(result, 31) + this.i6r_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j6r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k6r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.e6r_1, tmp0_other_with_cast.e6r_1))
      return false;
    if (!equals(this.f6r_1, tmp0_other_with_cast.f6r_1))
      return false;
    if (!(this.g6r_1 === tmp0_other_with_cast.g6r_1))
      return false;
    if (!equals(this.h6r_1, tmp0_other_with_cast.h6r_1))
      return false;
    if (!(this.i6r_1 === tmp0_other_with_cast.i6r_1))
      return false;
    if (!(this.j6r_1 === tmp0_other_with_cast.j6r_1))
      return false;
    if (!(this.k6r_1 === tmp0_other_with_cast.k6r_1))
      return false;
    if (!(this.l6r_1 === tmp0_other_with_cast.l6r_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.x6g_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.y6g_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_46();
    this.m6r_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.m6r_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.m6r_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.m6r_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.z6g_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.a6h_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_57().q6r_1), Companion_getInstance_56().d6s_1, Companion_getInstance_56().d6s_1, Companion_getInstance_56().d6s_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_47();
    this.g6s_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.g6s_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.g6s_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.g6s_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.b6h_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.c6h_1 = _AGColorMask___init__impl__j38ai8_1();
    this.d6h_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.e6h_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.f6h_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.g6h_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class AGColorMask {
  constructor(data) {
    Companion_getInstance_48();
    this.k6s_1 = data;
  }
  toString() {
    return AGColorMask__toString_impl_5i5oqg(this.k6s_1);
  }
  hashCode() {
    return AGColorMask__hashCode_impl_g9082f(this.k6s_1);
  }
  equals(other) {
    return AGColorMask__equals_impl_mrih8l(this.k6s_1, other);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.h6h_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.i6h_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_57().q6r_1), Companion_getInstance_58().l6s_1);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.n6h_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.o6h_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.p6h_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.q6h_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.r6h_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGCullFace {
  constructor(ordinal) {
    Companion_getInstance_50();
    this.o6s_1 = ordinal;
  }
  toString() {
    return AGCullFace__toString_impl_7d891w(this.o6s_1);
  }
  hashCode() {
    return AGCullFace__hashCode_impl_t4e5ur(this.o6s_1);
  }
  equals(other) {
    return AGCullFace__equals_impl_wgngjr(this.o6s_1, other);
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.y6o([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_42().m6g_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().i6t_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_59().u6g_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_31.w6g() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_43().q6g_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_47().a6h_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_46().y6g_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_48().d6h_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_49().i6h_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_44().m6h_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_50().o6h_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_41().p6p_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.c6i_1 = frameBuffer;
    this.d6i_1 = frameBufferInfo;
    this.e6i_1 = vertexData;
    this.f6i_1 = indices;
    this.g6i_1 = indexType;
    this.h6i_1 = program;
    this.i6i_1 = uniformBlocks;
    this.j6i_1 = textureUnits;
    this.k6i_1 = blending;
    this.l6i_1 = stencilOpFunc;
    this.m6i_1 = stencilRef;
    this.n6i_1 = colorMask;
    this.o6i_1 = depthAndFrontFace;
    this.p6i_1 = scissor;
    this.q6i_1 = cullFace;
    this.r6i_1 = drawType;
    this.s6i_1 = drawOffset;
    this.t6i_1 = vertexCount;
    this.u6i_1 = instances;
  }
  b6i(ag) {
    ag.g6g(this.c6i_1, this.d6i_1, this.e6i_1, this.h6i_1, this.r6i_1, this.t6i_1, this.f6i_1, this.g6i_1, this.s6i_1, this.k6i_1, this.i6i_1, this.j6i_1, this.m6i_1, this.l6i_1, this.n6i_1, this.o6i_1, this.p6i_1, this.q6i_1, this.u6i_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.c6i_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.d6i_1) + ', vertexData=' + this.e6i_1.toString() + ', indices=' + toString_1(this.f6i_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.g6i_1) + ', program=' + this.h6i_1.toString() + ', uniformBlocks=' + toString(this.i6i_1) + ', textureUnits=' + this.j6i_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.k6i_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.l6i_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.m6i_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.n6i_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.o6i_1) + ', scissor=' + this.p6i_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.q6i_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.r6i_1) + ', drawOffset=' + this.s6i_1 + ', vertexCount=' + this.t6i_1 + ', instances=' + this.u6i_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.c6i_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.d6i_1) | 0;
    result = imul(result, 31) + this.e6i_1.hashCode() | 0;
    result = imul(result, 31) + (this.f6i_1 == null ? 0 : hashCode(this.f6i_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.g6i_1) | 0;
    result = imul(result, 31) + this.h6i_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.i6i_1) | 0;
    result = imul(result, 31) + this.j6i_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.k6i_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.l6i_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.m6i_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.n6i_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.o6i_1) | 0;
    result = imul(result, 31) + this.p6i_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.q6i_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.r6i_1) | 0;
    result = imul(result, 31) + this.s6i_1 | 0;
    result = imul(result, 31) + this.t6i_1 | 0;
    result = imul(result, 31) + this.u6i_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.c6i_1, tmp0_other_with_cast.c6i_1))
      return false;
    if (!equals(this.d6i_1, tmp0_other_with_cast.d6i_1))
      return false;
    if (!this.e6i_1.equals(tmp0_other_with_cast.e6i_1))
      return false;
    if (!equals(this.f6i_1, tmp0_other_with_cast.f6i_1))
      return false;
    if (!(this.g6i_1 === tmp0_other_with_cast.g6i_1))
      return false;
    if (!this.h6i_1.equals(tmp0_other_with_cast.h6i_1))
      return false;
    if (!equals(this.i6i_1, tmp0_other_with_cast.i6i_1))
      return false;
    if (!this.j6i_1.equals(tmp0_other_with_cast.j6i_1))
      return false;
    if (!(this.k6i_1 === tmp0_other_with_cast.k6i_1))
      return false;
    if (!(this.l6i_1 === tmp0_other_with_cast.l6i_1))
      return false;
    if (!equals(this.m6i_1, tmp0_other_with_cast.m6i_1))
      return false;
    if (!(this.n6i_1 === tmp0_other_with_cast.n6i_1))
      return false;
    if (!(this.o6i_1 === tmp0_other_with_cast.o6i_1))
      return false;
    if (!this.p6i_1.equals(tmp0_other_with_cast.p6i_1))
      return false;
    if (!(this.q6i_1 === tmp0_other_with_cast.q6i_1))
      return false;
    if (!(this.r6i_1 === tmp0_other_with_cast.r6i_1))
      return false;
    if (!(this.s6i_1 === tmp0_other_with_cast.s6i_1))
      return false;
    if (!(this.t6i_1 === tmp0_other_with_cast.t6i_1))
      return false;
    if (!(this.u6i_1 === tmp0_other_with_cast.u6i_1))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.o6l_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.p6l_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.q6l_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.r6l_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_51();
    this.t6l_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.t6l_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.t6l_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.t6l_1, other);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.n6m_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.o6m_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.p6m_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_52();
    this.k6t_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.k6t_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.k6t_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.k6t_1, other);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.x6p_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.y6p_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.z6p_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.a6q_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.b6q_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.c6q_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.d6q_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.e6q_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.f6q_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.g6q_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_53();
    this.l6t_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.l6t_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.l6t_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.l6t_1, other);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.k6q_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.l6q_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.m6q_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_54();
    this.m6t_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.m6t_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.m6t_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.m6t_1, other);
  }
}
class Companion_39 {
  n6t() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  b6r(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_49 = this;
    this.y6r_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.z6r_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.a6s_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.b6s_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.c6s_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.d6s_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.e6s_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.f6s_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_56();
    this.o6t_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.o6t_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.o6t_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.o6t_1, other);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.q6r_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.r6r_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.s6r_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.t6r_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.u6r_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.v6r_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.w6r_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.x6r_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_57();
    this.p6t_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.p6t_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.p6t_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.p6t_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.l6s_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.m6s_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.n6s_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.a6i_1 = list;
  }
  b6i(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a6i_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).b6i(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.a6i_1) + ')';
  }
  hashCode() {
    return hashCode(this.a6i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.a6i_1, tmp0_other_with_cast.a6i_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.q6t_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.q6t_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.q6t_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.q6t_1 === tmp0_other_with_cast.q6t_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_9().i14(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_9().i14(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_9().i14(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.r6t_1 = texturesCount;
    this.s6t_1 = texturesMemory;
    this.t6t_1 = buffersCount;
    this.u6t_1 = buffersMemory;
    this.v6t_1 = frameBuffersCount;
    this.w6t_1 = frameBuffersMemory;
    this.x6t_1 = texturesCreated;
    this.y6t_1 = texturesDeleted;
    this.z6t_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.r6t_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.s6t_1) + ', buffers[' + this.t6t_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.u6t_1) + ', frameBuffers[' + this.v6t_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.w6t_1) + ', programs[' + this.z6t_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.o6o_1 = fixedLocation;
    this.p6o_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.q6o_1 = ArrayList.h1();
    this.r6o_1 = 0;
  }
  o3() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  t6u() {
    return this.q6o_1;
  }
  u6u() {
    return this.p6o_1.e1();
  }
  v6u() {
    return nextMultipleOf(this.u6u(), 256);
  }
  w6u() {
    return this.t6u().e1();
  }
  x6u(name) {
    return this.e6v(name, VarType_Float1_getInstance(), 4, 4);
  }
  y6u(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.x6u(name) : $super.x6u.call(this, name);
  }
  z6u(name) {
    return this.e6v(name, VarType_Float2_getInstance(), 8, 8);
  }
  a6v(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.z6u(name) : $super.z6u.call(this, name);
  }
  b6v(name) {
    return this.e6v(name, VarType_Float4_getInstance(), 16, 16);
  }
  c6v(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.b6v(name) : $super.b6v.call(this, name);
  }
  d6v(name) {
    return this.e6v(name, VarType_Mat4_getInstance(), 64, 16);
  }
  g6u(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.d6v(name) : $super.d6v.call(this, name);
  }
  e6v(name, type, size, align) {
    var tmp = this.p6o_1.r7a(size, align);
    var _unary__edvuaz = this.r6o_1;
    this.r6o_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.t6u(), ', ') + ', fixedLocation=' + this.o6o_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    this.e6u_1 = this.g6u().q6u(this, u_ProjMat$factory());
    this.f6u_1 = this.g6u().q6u(this, u_ViewMat$factory());
  }
  r6u() {
    return this.e6u_1.ko(this, u_ProjMat$factory_0());
  }
  s6u() {
    return this.f6u_1.ko(this, u_ViewMat$factory_0());
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    this.p6s_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).h6v(this, u_Tex$factory());
    this.q6s_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).h6v(this, u_TexEx$factory());
    this.r6s_1 = Attribute.y6v('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.s6s_1 = Attribute.y6v('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.t6s_1 = Attribute.y6v('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.u6s_1 = Varying.k6w('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.v6s_1 = Varying.k6w('v_Col', VarType_Float4_getInstance());
    this.w6s_1 = Temp.w6w(0, VarType_Float4_getInstance());
    this.x6s_1 = Temp.w6w(1, VarType_Float4_getInstance());
    this.y6s_1 = Temp.w6w(2, VarType_Mat2_getInstance());
    this.z6s_1 = ProgramLayout.h6p([this.r6s_1, this.s6s_1, this.t6s_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.e6x(builder.a6x(), builder.b6x());
    builder.e6x(builder.f6x(), builder.g6x());
    builder.e6x(builder.h6x(), builder.i6x(builder.i6x(builder.r6u(), builder.s6u()), builder.l6x([builder.j6x(), builder.k6x(0.0), builder.k6x(1.0)])));
    tmp.a6t_1 = VertexShader(builder.m6x());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.n6x(this_0.a6x(), 'xy');
    this_0.e6x(this_0.h6x(), this_0.i6x(this_0.p6x(this_0.o6x(), coords), this_0.r6x(this_0.p6x(DefaultShaders_getInstance().q6x(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.m6x());
    tmp_0.b6t_1 = new Program(this.a6t_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.e6x(builder_0.h6x(), builder_0.l6x([builder_0.k6x(1.0), builder_0.k6x(1.0), builder_0.k6x(0.0), builder_0.k6x(1.0)]));
    tmp_1.c6t_1 = FragmentShader(builder_0.m6x());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.e6x(builder_1.h6x(), builder_1.f6x());
    tmp_2.d6t_1 = FragmentShader(builder_1.m6x());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.e6x(builder_2.h6x(), builder_2.i6x(builder_2.n6x(builder_2.p6x(builder_2.o6x(), builder_2.n6x(builder_2.a6x(), 'xy')), 'rgba'), builder_2.f6x()));
    var tmp$ret$5 = FragmentShader(builder_2.m6x());
    tmp_3.e6t_1 = new Program(this.a6t_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.e6x(builder_3.s6x(), builder_3.p6x(builder_3.o6x(), builder_3.n6x(builder_3.a6x(), 'xy')));
    builder_3.e6x(builder_3.n6x(builder_3.s6x(), 'rgb'), builder_3.t6x(builder_3.n6x(builder_3.s6x(), 'rgb'), builder_3.n6x(builder_3.s6x(), 'a')));
    builder_3.e6x(builder_3.h6x(), builder_3.i6x(builder_3.n6x(builder_3.s6x(), 'rgba'), builder_3.f6x()));
    var tmp$ret$6 = FragmentShader(builder_3.m6x());
    tmp_4.f6t_1 = new Program(this.a6t_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.g6t_1 = new Program(this.a6t_1, this.d6t_1, 'PROGRAM_SOLID_COLOR');
    this.h6t_1 = ProgramLayout.h6p([this.r6s_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.e6x(builder_4.h6x(), builder_4.l6x([builder_4.j6x(), builder_4.k6x(0.0), builder_4.k6x(1.0)]));
    var tmp_6 = VertexShader(builder_4.m6x());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.e6x(builder_5.h6x(), builder_5.l6x([builder_5.k6x(1.0), builder_5.k6x(0.0), builder_5.k6x(0.0), builder_5.k6x(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.m6x());
    tmp_5.i6t_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.e6x(builder_6.h6x(), builder_6.i6x(builder_6.i6x(builder_6.r6u(), builder_6.s6u()), builder_6.l6x([builder_6.j6x(), builder_6.k6x(0.0), builder_6.k6x(1.0)])));
    var tmp_8 = VertexShader(builder_6.m6x());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.e6x(builder_7.h6x(), builder_7.l6x([builder_7.k6x(1.0), builder_7.k6x(0.0), builder_7.k6x(0.0), builder_7.k6x(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.m6x());
    tmp_7.j6t_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  o6x() {
    return this.p6s_1.ko(this, u_Tex$factory_0());
  }
  q6x() {
    return this.q6s_1.ko(this, u_TexEx$factory_0());
  }
  r6u() {
    return ProjViewUB_getInstance().r6u().n6o_1;
  }
  s6u() {
    return ProjViewUB_getInstance().s6u().n6o_1;
  }
}
class VarTypeAccessor {}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function atan(y, x) {
  return Func.m7k('atan', [y, x], y.n29());
}
function texture2D(sampler, coord) {
  return Func.m7k('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.y7j(cond, otrue, ofalse);
}
function pow(b, e) {
  return Func.m7k('pow', [b, e], b.n29());
}
function sqrt(v) {
  return Func.m7k('sqrt', [v], v.n29());
}
function abs(v) {
  return Func.m7k('abs', [v], v.n29());
}
function fract(v) {
  return Func.m7k('fract', [v], v.n29());
}
function clamp(v, min, max) {
  return Func.m7k('clamp', [v, min, max], v.n29());
}
function min_0(a, b) {
  return Func.m7k('min', [a, b], a.n29());
}
function max_1(a, b) {
  return Func.m7k('max', [a, b], a.n29());
}
function fwidth(a) {
  return Func.m7k('fwidth', [a], a.n29());
}
function mix(a, b, step) {
  return Func.m7k('mix', [a, b, step], a.n29());
}
function smoothstep(a, b, c) {
  return Func.m7k('smoothstep', [a, b, c], a.n29());
}
function length(a) {
  return Func.m7k('length', [a], VarType_Float1_getInstance());
}
function get_lit(_this__u8e3s4) {
  return FloatLiteral.c7k(_this__u8e3s4);
}
function vec2(ops) {
  return Vector.d7k(VarType_Float2_getInstance(), ops);
}
function vec4(ops) {
  return Vector.d7k(VarType_Float4_getInstance(), ops);
}
function get_1(_this__u8e3s4, swizzle) {
  return Swizzle.e7k(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.n6x(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.n6x(_this__u8e3s4, 'y');
}
function get_z(_this__u8e3s4) {
  return this.n6x(_this__u8e3s4, 'z');
}
function get_w(_this__u8e3s4) {
  return this.n6x(_this__u8e3s4, 'w');
}
function get_a(_this__u8e3s4) {
  return this.n6x(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.a7k('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '==', that);
}
function lt(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '<', that);
}
function le(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '>', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.f6z(this.k6x(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.h6z(this.k6x(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.i6x(this.k6x(_this__u8e3s4), that);
}
function plus_4(_this__u8e3s4, that) {
  return this.h6z(_this__u8e3s4, this.k6x(that));
}
function times_1(_this__u8e3s4, that) {
  return this.i6x(_this__u8e3s4, this.k6x(that));
}
function div_0(_this__u8e3s4, that) {
  return this.t6x(_this__u8e3s4, this.k6x(that));
}
function lt_0(_this__u8e3s4, that) {
  return this.l6z(_this__u8e3s4, this.k6x(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.o6z(_this__u8e3s4, this.k6x(that));
}
function and(_this__u8e3s4, that) {
  return Binop.b7k(_this__u8e3s4, '&&', that);
}
class Builder {
  static u6x(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.c6x_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.d6x_1 = ArrayList.h1();
    return $this;
  }
  static x7i(parent) {
    return this.u6x(parent.c6x_1);
  }
  v6x() {
    return Builder.x7i(this);
  }
  w6x() {
    return FuncBuilder.w7i(this);
  }
  x6x() {
    return new Stms(toList(this.d6x_1));
  }
  y6x() {
    var funcs = LinkedHashMap.bc();
    (new Program$Builder$_funcs$1(funcs)).x7j(this.d6x_1);
    var _iterator__ex2g4s = this.c6x_1.p7k_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.set' call
      var key = func.b7g_1;
      funcs.e3(key, func);
    }
    return toList(funcs.i3());
  }
  m6x() {
    return to(this.x6x(), this.y6x());
  }
  z6x(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.w6x();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.u7i_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.s72_1, item.n29());
      destination.h(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.x6x());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.c6x_1.p7k_1.h(this_2);
    return this_2;
  }
  a6y(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  b6y(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.a6y(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.a6y;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  c6y(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  d6y(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.c6y(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.c6y;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  e6y(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  f6y(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.e6y(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.e6y;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  g6y(type) {
    var _receiver__tnumb7 = this.c6x_1;
    var _unary__edvuaz = _receiver__tnumb7.q7k_1;
    _receiver__tnumb7.q7k_1 = _unary__edvuaz + 1 | 0;
    return Temp.w6w(_unary__edvuaz, type);
  }
  h6y(initialValue) {
    var temp = this.g6y(initialValue.n29());
    this.e6x(temp, initialValue);
    return temp;
  }
  i6y(_this__u8e3s4, p0) {
    return CustomFunc.n7k(_this__u8e3s4, listOf(p0));
  }
  j6y(_this__u8e3s4, p0, p1) {
    return CustomFunc.n7k(_this__u8e3s4, listOf_0([p0, p1]));
  }
  k6y(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.n7k(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  l6y(_this__u8e3s4, callback) {
    var body = this.v6x();
    callback(body);
    _this__u8e3s4.o7h_1 = body.x6x();
  }
  m6y(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.k6z(ref, this.k6x(min));
      var body = this.v6x();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.x6x());
      // Inline function 'kotlin.collections.plusAssign' call
      this.d6x_1.h(stmIf);
      var tmp = stmIf;
      this.l6y(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.n6z(ref, this.k6x(middle));
      var body_0 = this.v6x();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.m6y(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.x6x());
      // Inline function 'kotlin.collections.plusAssign' call
      this.d6x_1.h(stmIf_0);
      var tmp_0 = stmIf_0;
      this.l6y(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  n6y(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.k6z(ref, this.k6x(min));
      var body = this.v6x();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_LIST.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.x6x());
      // Inline function 'kotlin.collections.plusAssign' call
      this.d6x_1.h(stmIf);
      var tmp = stmIf;
      this.l6y(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  }
  e6x(target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.d6x_1;
    var element = new Set(target, expr);
    this_0.h(element);
  }
  o6y() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.d6x_1;
    var element = Discard_getInstance();
    this_0.h(element);
  }
  p6y(operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.d6x_1;
    var element = new Return(operand);
    this_0.h(element);
  }
  q6y(operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.p6y(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.p6y.call(this, operand);
    }
    return tmp;
  }
  r6y(type) {
    var _receiver__tnumb7 = this.c6x_1;
    var _unary__edvuaz = _receiver__tnumb7.q7k_1;
    _receiver__tnumb7.q7k_1 = _unary__edvuaz + 1 | 0;
    return Temp.r7k(_unary__edvuaz, type, 1);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().o6x();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().r6u();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().s6u();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().r6s_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().s6s_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().t6s_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().u6s_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().v6s_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().w6s_1;
}
function get_t_Temp1() {
  return DefaultShaders_getInstance().x6s_1;
}
class ProgramBuilderDefault extends Builder {
  static z6w() {
    return this.u6x();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.s6z_1 = vao;
    this.t6z_1 = glId;
    this.u6z_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  static f70(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.ja('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.e70_1);
    $this.x6z_1 = str;
    $this.y6z_1 = error;
    $this.z6z_1 = errorInt;
    $this.a70_1 = gl;
    $this.b70_1 = debugName;
    $this.c70_1 = type;
    $this.d70_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.g73_1 = index;
    this.h73_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.i73_1 = -1;
    this.j73_1 = -1;
    this.k73_1 = -1;
    this.l73_1 = -1;
  }
  c2q() {
    this.h73_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.i73_1 = -1;
    this.j73_1 = -1;
    this.k73_1 = -1;
    this.l73_1 = -1;
  }
}
class AGOpengl extends AG {
  static u75(gl, context) {
    context = context === VOID ? null : context;
    var $this = this.l6f();
    $this.k70_1 = gl;
    $this.l70_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.m70_1 = LinkedHashSet.j1();
    $this.n70_1 = new GLGlobalState($this.k70_1, $this);
    $this.o70_1 = HashMap.i8();
    $this.p70_1 = null;
    var tmp_0 = $this;
    tmp_0.q70_1 = lazy(AGOpengl$glslConfig$delegate$lambda($this));
    $this.r70_1 = null;
    $this.s70_1 = Companion_getInstance_43().o6g_1;
    $this.t70_1 = Companion_getInstance_50().n6h_1;
    $this.u70_1 = Companion_getInstance_47().z6g_1;
    $this.v70_1 = Companion_getInstance_46().x6g_1;
    $this.w70_1 = Companion_getInstance_48().b6h_1;
    $this.x70_1 = Companion_getInstance_49().h6h_1;
    $this.y70_1 = null;
    $this.z70_1 = AGTextureUnits.n6j();
    $this.a71_1 = new Int32Array($this.z70_1.e1());
    $this.b71_1 = 0;
    $this.c71_1 = Companion_getInstance_44().l6h_1;
    $this.d71_1 = -1;
    $this.e71_1 = -1;
    $this.f71_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    $this.g71_1 = Ref();
    $this.h71_1 = Buffer.e12(36);
    var tmp_1 = $this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.i71_1 = tmp_3;
    $this.j71_1 = allocDirect(Companion_instance_4, 0);
    $this.k71_1 = 7;
    $this.l71_1 = 0;
    $this.m71_1 = Companion_instance_48.n6t();
    $this.n71_1 = -1;
    $this.o71_1 = new Long(-1, -1);
    $this.p71_1 = null;
    return $this;
  }
  static v75(context) {
    return this.u75(context.x75_1, context);
  }
  h6g() {
    return this.k70_1;
  }
  b6g() {
    var gl = this.k70_1;
    super.b6g();
    gl.z75();
    gl.a76();
    this.o70_1.h3();
    resetObjects(this);
    this.d71_1 = -1;
    this.e71_1 = -1;
    this.f71_1 = true;
  }
  f6g(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.k70_1;
    this.b76(frameBuffer, frameBufferInfo);
    this.c76(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.d76(Companion_getInstance_48().e6h_1);
      gl.e76(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.f76(true);
      gl.g76(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.u70_1 = Companion_getInstance_47().z6g_1;
      gl.h76(-1);
      gl.i76(stencil);
      mask = mask | 1024;
    }
    gl.j76(mask);
  }
  g6g(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.k70_1;
    this.b76(frameBuffer, frameBufferInfo);
    this.c76(scissor, frameBuffer, frameBufferInfo);
    var tmp1_safe_receiver = this.r70_1;
    if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.v6o_1, vertexData.v6o_1)) {
      var tmp0_safe_receiver = this.r70_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.k76(tmp0_safe_receiver);
      }
      this.r70_1 = vertexData;
      this.l76(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.v6o_1.ly_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.j6p_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.m76(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.s70_1 === blending)) {
      this.s70_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.p76(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.n76(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.o76(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.q76(depthAndFrontFace);
    this.d76(colorMask);
    if (!(this.t70_1 === cullFace)) {
      this.t70_1 = cullFace;
      this.r76(cullFace);
    }
    if (!(this.u70_1 === stencilOpFunc) || !equals(this.v70_1, stencilRef)) {
      this.u70_1 = stencilOpFunc;
      this.v70_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.t76(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.v76(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.u76(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.u76(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.x76(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.w76(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.w76(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.h76(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.y76(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.y76(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.s76(2960);
        gl.h76(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_42().k6g_1;
    if (!(indexType_0 === Companion_getInstance_42().k6g_1))
      if (!(instances === 1)) {
        gl.c77(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.b77(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.a77(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.z76(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  v71() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q70_1;
    glslConfig$factory();
    return this_0.r1();
  }
  e6g() {
    var gl = this.k70_1;
    var tmp0_safe_receiver = this.l70_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.d77();
    }
    gl.e77(this.j6f_1);
    resetObjects(this);
    this.b71_1 = getIntegerv(gl, 36006);
    gl.f75(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.g75())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.e75(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.e75(3553, 33085, 0);
    }
  }
  n6b() {
    var tmp0_safe_receiver = this.r70_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.k76(tmp0_safe_receiver);
    }
    this.r70_1 = null;
    this.b76(this.a6g().m6f_1, this.a6g().s6h());
    var tmp1_safe_receiver = this.l70_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.f77();
    }
  }
  c6g() {
    var tmp0_safe_receiver = this.r70_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.k76(tmp0_safe_receiver);
    }
    this.r70_1 = null;
    this.k70_1.lc();
    deletePendingObjects(this);
  }
  r76(face) {
    if (this.k70_1.p76(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_50().o6h_1))) {
      this.k70_1.g77(toGl_5(face));
    }
  }
  f74(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.c6j_1 === _this__u8e3s4.d6j_1)) {
      _this__u8e3s4.c6j_1 = _this__u8e3s4.d6j_1;
      block(_this__u8e3s4);
    }
  }
  k76(vao) {
    if (this.f71_1 && this.k70_1.j6g()) {
      this.k70_1.j77(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.v6o_1.ly_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[_unary__edvuaz].i6p_1.z6o_1;
        var n_0 = 0;
        while (n_0 < this_0.e1()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.d1(_unary__edvuaz_0);
          if (att.v6v_1) {
            var loc = att.x6v_1;
            if (loc >= 0) {
              if (!(att.w6v_1 === 0)) {
                this.k70_1.h77(loc, 0);
              }
              this.k70_1.i77(loc);
            }
          }
        }
      }
    }
  }
  l76(vao) {
    var gl = this.k70_1;
    if (this.f71_1 && gl.j6g()) {
      var vaoGl = get_gl(vao);
      if (vao.w6o_1) {
        if (!(this.e71_1 === this.j6f_1)) {
          this.d71_1 = genVertexArray(gl);
          this.e71_1 = this.j6f_1;
          if (this.d71_1 <= 0)
            this.f71_1 = false;
        }
        gl.j77(this.d71_1);
        this.k77(vao);
      } else {
        if (!(vaoGl.u6z_1 === this.j6f_1)) {
          vaoGl.u6z_1 = this.j6f_1;
          vaoGl.t6z_1 = genVertexArray(gl);
          if (vaoGl.t6z_1 <= 0)
            this.f71_1 = false;
          gl.j77(vaoGl.t6z_1);
          this.k77(vao);
        }
        gl.j77(vaoGl.t6z_1);
        this.l77(vao, this.f71_1);
      }
    } else {
      this.k77(vao);
    }
  }
  l77(vao, updateBuffersOnly) {
    var gl = this.k70_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.v6o_1.ly_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.j6p_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.g71_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.v6o_1.ly_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.j6p_1;
      var vertexLayout = entry_0.i6p_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.z6o_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.e6p_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.g71_1);
      var totalSize = vertexLayout.g6p_1;
      var inductionVariable = 0;
      var last = vattrspos.e1() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.d1(n_1);
          if (!att.v6v_1)
            continue $l$loop;
          var off = vattrspos.d1(n_1);
          var loc = att.x6v_1;
          var glElementType = toGl_7(att.n29());
          var elementCount = att.n29().q74_1;
          if (loc >= 0) {
            gl.m77(loc);
            gl.n77(loc, elementCount, glElementType, att.u6v_1, totalSize, numberToLong(entry_0.k6p_1).u3(toLong(off)));
            if (!(att.w6v_1 === 0)) {
              gl.h77(loc, att.w6v_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  k77(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.l77(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.l77.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  m76(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.y70_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.l6j_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.m6j_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.q6k_1, tex_0)) {
          tex_0 = null;
        }
        var tmp0_safe_receiver = tex_0;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d6j_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if (!(this.z70_1.l6j_1[n] === tex_0) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.z70_1.m6j_1, n) === info) || !(this.a71_1[n] === texVersion)) {
          this.z70_1.p6j(n, tex_0, info);
          this.a71_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.o77(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.s6l(), wrap, this.p77(tex_0, linear, trilinear), this.q77(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.s6l()));
          } else {
            this.o77(null, Companion_getInstance_51().o6l_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.a72_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.e1();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_0 = uniformBlocks.r77_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.s77_1[n_0];
          var valueIndex = uniformBlocks.t77_1[n_0];
          if (glProgram.a72_1.g72_1.f73()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_0 = buffer_0 == null ? null : buffer_0.c74_1;
            this.k70_1.u77(35345, block.u6m_1.o6o_1, tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0, imul(valueIndex, block.x6m_1), block.x6m_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.j72_1[block.u6m_1.o6o_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.u6m_1.o6o_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.w4(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).z6i_1);
          var currentMem = ref.w77_1;
          var ublock = ref.v77_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.v6u())) {
              arraycopy_0(bufferMem, imul(ublock.v6u(), valueIndex), currentMem, 0, ublock.v6u());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.t6u();
              var n_1 = 0;
              while (n_1 < this_0.e1()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.d1(_unary__edvuaz);
                writeUniform(this, uniform.n6o_1, glProgramInfo, sliceBuffer(currentMem, uniform.k6o_1, uniform.k6o_1 + uniform.m74_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.u6m_1.toString() + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  p77(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.i6l_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  q77(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  z77(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_44().m6h_1) || scissor.equals(Companion_getInstance_44().k6h_1) ? scissor : frameBuffer.p6k_1 ? Companion_getInstance_44().y2d(scissor.v25(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.y25() | 0, scissor.w25(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.x25() | 0) : scissor;
  }
  o77(tex, target) {
    var gl = this.k70_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.q75_1;
    gl.a78(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.h6l_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.r75_1 === texBitmap.u3x_1) || !(glTex.s75_1 === this.j6f_1)) {
        glTex.r75_1 = texBitmap.u3x_1;
        glTex.s75_1 = this.j6f_1;
        tex.k6j();
      }
      this.f74(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  b76(frameBuffer, info) {
    var gl = this.k70_1;
    if (!(this.m71_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.b78(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.p6k_1) {
      if (!(this.n71_1 === this.b71_1)) {
        this.n71_1 = this.b71_1;
        gl.c78(36160, this.b71_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.f78_1.q6k_1;
    var doMsaa = false;
    if (!equals(fb.i78_1, info)) {
      fb.i78_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.h6l_1 = NullBitmap.o4c(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.k71_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.o77(tex, Companion_getInstance_51().o6l_1);
        textureUnitParameters(this, Companion_getInstance_51().o6l_1, Companion_getInstance_52().n6m_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.o77(null, Companion_getInstance_51().o6l_1);
        }
        selectTextureUnit(this, old);
      }
      gl.j78(36161, fb.g78_1);
      if (!(internalFormat === 0)) {
        gl.k78(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.j78(36161, 0);
      gl.c78(36160, fb.h78_1);
      gl.l78(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.f78_1.q6k_1, this).q75_1, 0);
      if (!(internalFormat === 0)) {
        gl.m78(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.g78_1);
      } else {
        gl.m78(36160, 36128, 36161, 0);
        gl.m78(36160, 36096, 36161, 0);
      }
    }
    if (!(this.n71_1 === fb.h78_1)) {
      this.n71_1 = fb.h78_1;
      gl.c78(36160, fb.h78_1);
    }
  }
  q76(renderState) {
    var gl = this.k70_1;
    if (!(this.x70_1 === renderState)) {
      this.x70_1 = renderState;
      gl.n78(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.f76(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.o78(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_57().q6r_1);
      if (gl.p76(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.p78(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  d76(colorMask) {
    var gl = this.k70_1;
    if (!(this.w70_1 === colorMask)) {
      this.w70_1 = colorMask;
      gl.q78(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  c76(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.k70_1;
    var scissor_0 = this.z77(scissor, frameBuffer, frameBufferInfo);
    if (!this.c71_1.equals(scissor_0)) {
      this.c71_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_44().m6h_1);
      if (gl.p76(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.r78(scissor_0.t6a(), scissor_0.u6a(), scissor_0.m2i(), scissor_0.n2i());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.m73_1 = gl;
    this.n73_1 = ag;
    this.o73_1 = atomic$int$1(0);
    this.p73_1 = atomic$int$1(0);
    this.q73_1 = atomic$ref$1(0.0);
    this.r73_1 = atomic$int$1(0);
    this.s73_1 = atomic$int$1(0);
    this.t73_1 = atomic$ref$1(0.0);
    this.u73_1 = new Lock();
    this.v73_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.w73_1 = globalState;
    this.x73_1 = this.w73_1.m73_1;
  }
  y73() {
  }
  l6m() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.w73_1.u73_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.d1v();
      try {
        this.w73_1.v73_1.h(this);
        break $l$block;
      }finally {
        this_0.f1v();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.a72_1 = programInfo;
  }
  y73() {
    this.a72_1.s78(this.x73_1);
  }
  b72() {
    this.a72_1.t78(this.x73_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.c74_1 = genBuffer(this.x73_1);
    this.d74_1 = -1;
    this.e74_1 = 0.0;
    this.w73_1.r73_1.atomicfu$incrementAndGet();
  }
  h75(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.w73_1.t73_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLBuffer.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.e74_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.e74_1 = value;
  }
  y73() {
    this.w73_1.s73_1.atomicfu$incrementAndGet();
    deleteBuffer(this.x73_1, this.c74_1);
    this.c74_1 = -1;
    this.d74_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.c74_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.q75_1 = genTexture(this.x73_1);
    this.r75_1 = -2;
    this.s75_1 = -2;
    this.t75_1 = 0.0;
    this.w73_1.o73_1.atomicfu$incrementAndGet();
  }
  h75(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.w73_1.q73_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLTexture.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.t75_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.t75_1 = value;
  }
  y73() {
    this.w73_1.p73_1.atomicfu$incrementAndGet();
    deleteTexture(this.x73_1, this.q75_1);
    this.q75_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.f78_1 = ag;
    this.g78_1 = genRenderbuffer(this.x73_1);
    this.h78_1 = genFramebuffer(this.x73_1);
    this.i78_1 = Companion_getInstance_45().d6r_1;
  }
  y73() {
    deleteRenderbuffer(this.x73_1, this.g78_1);
    deleteFramebuffer(this.x73_1, this.h78_1);
    this.g78_1 = -1;
    this.h78_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.c72_1 = programId;
    this.d72_1 = vertexId;
    this.e72_1 = fragmentId;
    this.f72_1 = blocks;
    this.g72_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.f72_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.o6o_1;
      destination.e3(tmp$ret$0, element);
    }
    tmp.h72_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.f72_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.c1().o6o_1;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.c1().o6o_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.i72_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.i72_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.h72_1.c3(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef.u78(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.j72_1 = tmp_4;
    this.k72_1 = FastStringMap();
    this.l72_1 = FastStringMap();
  }
  x72(gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.l72_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.v78(this.c72_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  t78(gl) {
    gl.w78(this.c72_1);
  }
  s78(gl) {
    if (!(this.d72_1 === 0)) {
      gl.x78(this.d72_1);
    }
    if (!(this.e72_1 === 0)) {
      gl.x78(this.e72_1);
    }
    if (!(this.c72_1 === 0)) {
      gl.y78(this.c72_1);
    }
    this.d72_1 = 0;
    this.e72_1 = 0;
    this.c72_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.c72_1 + ', vertexId=' + this.d72_1 + ', fragmentId=' + this.e72_1 + ', blocks=' + toString(this.f72_1) + ', config=' + this.g72_1.toString() + ')';
  }
  hashCode() {
    var result = this.c72_1;
    result = imul(result, 31) + this.d72_1 | 0;
    result = imul(result, 31) + this.e72_1 | 0;
    result = imul(result, 31) + hashCode(this.f72_1) | 0;
    result = imul(result, 31) + this.g72_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.c72_1 === tmp0_other_with_cast.c72_1))
      return false;
    if (!(this.d72_1 === tmp0_other_with_cast.d72_1))
      return false;
    if (!(this.e72_1 === tmp0_other_with_cast.e72_1))
      return false;
    if (!equals(this.f72_1, tmp0_other_with_cast.f72_1))
      return false;
    if (!this.g72_1.equals(tmp0_other_with_cast.g72_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.w71_1 = Companion_getInstance_1().mw('GLShaderCompiler');
  }
  x71(gl, config, program, debugName) {
    var id = gl.d79();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_62().f79();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_62().g79()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.w71_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.j2t(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_62().f79() + '. used=' + usedGlSlVersion;
        this_0.k2t(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.h79(VOID, VOID, usedGlSlVersion, item);
      destination.h(tmp$ret$2);
    }
    var _destruct__k2r9zo = this.i79(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.fl();
    var vertexShaderId = _destruct__k2r9zo.gl();
    var finalConfig = _destruct__k2r9zo.pr();
    var _iterator__ex2g4s = program.w6n_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var attr = _iterator__ex2g4s.c1();
      var location = attr.x6v_1;
      gl.j79(id, location, attr.s72_1);
    }
    gl.k79(id, fragmentShaderId);
    gl.k79(id, vertexShaderId);
    gl.l79(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.t6n_1, finalConfig);
  }
  i79(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.h1();
    var _iterator__ex2g4s = configs.a1();
    $l$loop: while (_iterator__ex2g4s.b1()) {
      var config = _iterator__ex2g4s.c1();
      try {
        var fragmentString = toNewGlslString(program.p6n_1, config);
        var vertexString = toNewGlslString(program.o6n_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.w71_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.j2t(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          this_0.k2t(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.w71_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.j2t(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.k2t(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.h(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator = errors.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.h(tmp$ret$5);
    }
    throw Exception.td('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  static q79(size) {
    size = size === VOID ? Size2D.l26(640, 480) : size;
    var $this = this.l6f();
    $this.a6g().u6k(numberToInt(size.j26_1), numberToInt(size.k26_1));
    return $this;
  }
}
class AGBaseLog extends AGDummy {
  static k7a(size) {
    size = size === VOID ? Size2D.l26(640, 480) : size;
    var $this = this.q79(size);
    $this.f7a_1 = 0;
    $this.g7a_1 = 0;
    $this.h7a_1 = 0;
    $this.i7a_1 = 0;
    $this.j7a_1 = linkedHashMapOf([]);
    return $this;
  }
  l7a(str, kind) {
  }
  d6g(command) {
    this.l7a(toString(command), Kind_COMMAND_getInstance());
  }
  c6g() {
    return this.l7a('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  static a7a(size) {
    size = size === VOID ? Size2D.l26(640, 480) : size;
    return this.k7a(size);
  }
  l7a(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.u6g_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_59();
    this.r77_1 = blocks;
    this.s77_1 = buffers;
    this.t77_1 = valueIndices;
  }
  e1() {
    return this.r77_1.length;
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.h6u_1 = block;
    this.i6u_1 = name;
    this.j6u_1 = voffset;
    this.k6u_1 = vindex;
    this.l6u_1 = type;
    this.m6u_1 = arrayCount;
    this.n6u_1 = size;
    this.o6u_1 = align;
    var tmp = this;
    tmp.p6u_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  n7a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p6u_1;
    uniform$factory();
    return this_0.r1();
  }
  q6u(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.i6u_1;
    tmp.i6u_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.n7a();
  }
  toString() {
    return 'Gen(block=' + this.h6u_1.toString() + ', name=' + this.i6u_1 + ', voffset=' + this.j6u_1 + ', vindex=' + this.k6u_1 + ', type=' + this.l6u_1.toString() + ', arrayCount=' + this.m6u_1 + ', size=' + this.n6u_1 + ', align=' + this.o6u_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.h6u_1);
    result = imul(result, 31) + (this.i6u_1 == null ? 0 : getStringHashCode(this.i6u_1)) | 0;
    result = imul(result, 31) + this.j6u_1 | 0;
    result = imul(result, 31) + this.k6u_1 | 0;
    result = imul(result, 31) + this.l6u_1.hashCode() | 0;
    result = imul(result, 31) + this.m6u_1 | 0;
    result = imul(result, 31) + this.n6u_1 | 0;
    result = imul(result, 31) + this.o6u_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.h6u_1, tmp0_other_with_cast.h6u_1))
      return false;
    if (!(this.i6u_1 == tmp0_other_with_cast.i6u_1))
      return false;
    if (!(this.j6u_1 === tmp0_other_with_cast.j6u_1))
      return false;
    if (!(this.k6u_1 === tmp0_other_with_cast.k6u_1))
      return false;
    if (!this.l6u_1.equals(tmp0_other_with_cast.l6u_1))
      return false;
    if (!(this.m6u_1 === tmp0_other_with_cast.m6u_1))
      return false;
    if (!(this.n6u_1 === tmp0_other_with_cast.n6u_1))
      return false;
    if (!(this.o6u_1 === tmp0_other_with_cast.o6u_1))
      return false;
    return true;
  }
}
class Operand {
  static z7j(type) {
    var $this = createThis(this);
    $this.g74_1 = type;
    return $this;
  }
  n29() {
    return this.g74_1;
  }
}
class OperandWithArray extends Operand {
  static w7l(type, arrayCount) {
    var $this = this.z7j(type);
    $this.i74_1 = arrayCount;
    $this.j74_1 = type.p74_1;
    $this.k74_1 = type.q74_1;
    $this.l74_1 = imul($this.k74_1, $this.i74_1);
    $this.m74_1 = imul(type.s74_1, $this.i74_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static x7k(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.w7l(type, arrayCount);
    $this.s72_1 = name;
    $this.t72_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.s72_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.u72_1 = tmp_1;
    $this.v72_1 = 0;
    $this.w72_1 = null;
    return $this;
  }
  static o7l(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7k(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.v72_1 === other.v72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.n29().equals(other.n29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i74_1 === other.i74_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s72_1 === other.s72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static e7b(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.x7k(name, type, arrayCount, precision);
    $this.d7b_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  static m7a(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.e7b(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.k6o_1 = voffset;
    $this.l6o_1 = vindex;
    $this.m6o_1 = block;
    $this.n6o_1 = Uniform.s7b(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  ko(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.s72_1 + "', offset=" + this.k6o_1 + ', type=' + this.n29().toString() + ')';
  }
}
class Companion_44 {}
class UniformBlockBuffer {
  constructor(block) {
    this.u6m_1 = block;
    this.v6m_1 = new AGBuffer();
    this.w6m_1 = this.u6m_1.u6u();
    this.x6m_1 = this.u6m_1.v6u();
    this.y6m_1 = this.u6m_1.t6u().e1();
    this.z6m_1 = Buffer.e12(imul(this.x6m_1, 1));
    this.a6n_1 = UniformsRef.t7b(this.u6m_1, this.z6m_1, -1);
    this.b6n_1 = Buffer.e12(this.u6m_1.v6u());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.u6m_1) + ')';
  }
  u7b(value) {
    this.a6n_1.x77_1 = value;
  }
  t6o() {
    return this.a6n_1.x77_1;
  }
  v7b(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.z6m_1 = copyOf(this.z6m_1, imul(this.x6m_1, newCapacity));
      this.a6n_1.w77_1 = this.z6m_1;
    }
  }
  c2q() {
    this.u7b(-1);
  }
  d6n() {
    var tmp = this.z6m_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.t6o() + 1 | 0, this.u6m_1.v6u());
    var tmp$ret$0 = Math.max(0, b);
    this.v6m_1.i6j(tmp, 0, tmp$ret$0);
    return this;
  }
  w7b() {
    var _unary__edvuaz = this.t6o();
    this.u7b(_unary__edvuaz - 1 | 0);
  }
}
class UBLayoutBuilder {
  constructor() {
    this.o7a_1 = 0;
    this.p7a_1 = 4;
    var tmp = this;
    tmp.q7a_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  e1() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q7a_1;
    size$factory();
    return this_0.r1();
  }
  r7a(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).o7a_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.o7a_1 = this.o7a_1 + size | 0;
    return this_0;
  }
}
class UniformsRef {
  static t7b(block, buffer, index) {
    var $this = createThis(this);
    $this.v77_1 = block;
    $this.w77_1 = buffer;
    $this.x77_1 = index;
    $this.y77_1 = $this.v77_1.v6u();
    return $this;
  }
  static u78(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.t7b(block, Buffer.e12(imul(block.v6u(), size)), index);
  }
  x7b(uniform) {
    return imul(this.x77_1, this.y77_1) + uniform.k6o_1 | 0;
  }
  y7b(ref) {
    arraycopy_0(ref.z6m_1, 0, this.w77_1, imul(this.x77_1, this.y77_1), this.y77_1);
  }
  z7b(uniform, value) {
    return this.a7c(uniform, value);
  }
  b7c(uniform, value) {
    return this.c7c(uniform, value.c2i_1, value.d2i_1);
  }
  d7c(uniform, value) {
    return this.c7c(uniform, value.e25_1, value.f25_1);
  }
  e7c(uniform, value) {
    return this.f7c(uniform, _RGBA___get_rf__impl__kvz75k(value), _RGBA___get_gf__impl__5gcu1f(value), _RGBA___get_bf__impl__1xz5yg(value), _RGBA___get_af__impl__vu36qv(value));
  }
  g7c(uniform, value) {
    return this.f7c(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  }
  h7c(uniform, value) {
    return this.f7c(uniform, value.e2h_1, value.f2h_1, value.g2h_1, value.h2h_1);
  }
  i7c(uniform, value) {
    return this.f7c(uniform, value.r2d_1, value.q2d_1, value.s2d_1, value.p2d_1);
  }
  j7c(uniform, value) {
    switch (uniform.n29().n3_1) {
      case 3:
        this.k7c(uniform, value, Companion_getInstance_6().z2b_1);
        break;
      case 2:
        this.l7c(uniform, value, Companion_getInstance_6().z2b_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.od();
    }
  }
  l7c(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.x7b(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.w77_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.d2d(it);
        var tmp;
        if (true) {
          this_1.i12(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.h12(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  k7c(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.l7c(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.l7c.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
  a7c(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.x7b(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.w77_1;
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      this_1.i12(byteOffset, value);
      tmp = Unit_instance;
    } else {
      this_1.h12(byteOffset, value);
      tmp = Unit_instance;
    }
  }
  c7c(uniform, x, y) {
    // Inline function 'kotlin.also' call
    var this_0 = this.x7b(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.m7c(this_0, x, y);
  }
  f7c(uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.x7b(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.n7c(this_0, x, y, z, w);
  }
  m7c(index, x, y) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.w77_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.i12(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.h12(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.w77_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.i12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.h12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
  }
  n7c(index, x, y, z, w) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.w77_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.i12(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.h12(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.w77_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.i12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.h12(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_2 = this.w77_1;
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      this_2.i12(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      this_2.h12(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_3 = this.w77_1;
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      this_3.i12(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      this_3.h12(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  }
}
class Companion_45 {
  o7c(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.n3_1, 16));
  }
  p7c(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.o7c(isES, isWebGL, isCore, version, os) : $super.o7c.call(this, isES, isWebGL, isCore, version, os).q7c_1;
  }
  r7c() {
    return Companion_instance_54.p7c(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  s7c(version) {
    return Companion_instance_54.p7c(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.q7c_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.q7c_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.q7c_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.q7c_1, other);
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.l7e_1 = default_0;
  }
  m7e(func) {
    this.n7e(func.e7g_1);
  }
  x7j(stms) {
    var _iterator__ex2g4s = stms.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.n7e(stm);
    }
  }
  n7e(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.o7e(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.r7e(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.p7e(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.q7e(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.s7e(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.u7e(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.t7e(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.v7e(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.w7e(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  o7e(stms) {
    var _iterator__ex2g4s = stms.s7g_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.n7e(stm);
    }
  }
  p7e(stm) {
    this.x7e(stm.m7h_1);
    this.n7e(stm.n7h_1);
    this.n7e(stm.o7h_1);
  }
  q7e(stm) {
    this.a7f(stm.p7h_1);
    this.x7e(stm.q7h_1);
    this.n7e(stm.s7h_1);
  }
  r7e(stm) {
    this.x7e(stm.u7g_1);
    this.x7e(stm.t7g_1);
  }
  s7e(stm) {
  }
  t7e(stm) {
  }
  u7e(stm) {
  }
  v7e(stm) {
    this.n7e(stm.o7g_1);
  }
  w7e(stm) {
    var tmp0_safe_receiver = stm.v7g_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.x7e(tmp0_safe_receiver);
    }
  }
  x7e(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.a7f(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.e7f(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.f7f(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.g7f(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.m7f(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.k7f(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.l7f(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.j7f(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.h7f(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.i7f(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.y7e(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  y7e(func) {
    var _iterator__ex2g4s = func.h7h().a1();
    while (_iterator__ex2g4s.b1()) {
      var op = _iterator__ex2g4s.c1();
      this.x7e(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.z7e(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.k7e(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  z7e(func) {
    return this.l7e_1;
  }
  k7e(func) {
    return this.l7e_1;
  }
  a7f(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.w7d(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.y7d(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.e7e(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.a7e(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.c7e(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.d7f(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.b7f(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.c7f(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  b7f(temp) {
    return this.l7e_1;
  }
  c7f(arg) {
    return this.l7e_1;
  }
  w7d(attribute) {
    return this.l7e_1;
  }
  y7d(varying) {
    return this.l7e_1;
  }
  a7e(uniform) {
    return this.l7e_1;
  }
  e7e(sampler) {
    return this.l7e_1;
  }
  c7e(typedUniform) {
    return this.a7e(typedUniform.n6o_1);
  }
  d7f(output) {
    return this.l7e_1;
  }
  e7f(operand) {
    this.x7e(operand.b7h_1);
    return this.l7e_1;
  }
  f7f(operand) {
    this.x7e(operand.d7h_1);
    this.x7e(operand.f7h_1);
    return this.l7e_1;
  }
  g7f(operand) {
    this.x7e(operand.j7h_1);
    this.x7e(operand.k7h_1);
    this.x7e(operand.l7h_1);
    return this.l7e_1;
  }
  h7f(operand) {
    this.x7e(operand.a7i_1);
    return this.l7e_1;
  }
  i7f(operand) {
    this.x7e(operand.d7i_1);
    this.x7e(operand.e7i_1);
    return this.l7e_1;
  }
  j7f(operand) {
    var indexedObject = operand.y7g_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.x7e(op);
    }
    return this.l7e_1;
  }
  k7f(operand) {
    return this.l7e_1;
  }
  l7f(operand) {
    return this.l7e_1;
  }
  m7f(operand) {
    return this.l7e_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.o7d_1 = LinkedHashSet.j1();
    this.p7d_1 = LinkedHashSet.j1();
    this.q7d_1 = LinkedHashSet.j1();
    this.r7d_1 = LinkedHashSet.j1();
    this.s7d_1 = LinkedHashSet.j1();
    this.t7d_1 = LinkedHashSet.j1();
    this.u7d_1 = LinkedHashSet.j1();
  }
  v7d(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.o7d_1.h(attribute);
  }
  w7d(attribute) {
    this.v7d(attribute);
    return Unit_instance;
  }
  x7d(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.p7d_1.h(varying);
  }
  y7d(varying) {
    this.x7d(varying);
    return Unit_instance;
  }
  z7d(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.q7d_1.h(uniform);
    var tmp0_safe_receiver = uniform.r7b_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.r7d_1.h(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.s7d_1;
    var element = uniform.r7b_1.m6o_1;
    this_0.h(element);
  }
  a7e(uniform) {
    this.z7d(uniform);
    return Unit_instance;
  }
  b7e(typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.q7d_1;
    var element = typedUniform.n6o_1;
    this_0.h(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.r7d_1.h(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.s7d_1;
    var element_0 = typedUniform.m6o_1;
    this_1.h(element_0);
  }
  c7e(typedUniform) {
    this.b7e(typedUniform);
    return Unit_instance;
  }
  d7e(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.t7d_1.h(sampler);
  }
  e7e(sampler) {
    this.d7e(sampler);
    return Unit_instance;
  }
  f7e(func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.u7d_1;
    var element = func.j7e().o3();
    this_0.h(element);
  }
  k7e(func) {
    this.f7e(func);
    return Unit_instance;
  }
}
class Companion_46 {
  constructor() {
    Companion_instance_55 = this;
    this.e79_1 = Companion_getInstance_1().mw('GlslGenerator');
  }
  f79() {
    return Companion_getInstance_63().f79();
  }
  g79() {
    return Companion_getInstance_63().g79();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.t7c_1 = generator;
    this.u7c_1 = result;
    this.v7c_1 = attributes;
    this.w7c_1 = uniforms;
    this.x7c_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.t7c_1) + ', result=' + this.u7c_1 + ', attributes=' + toString(this.v7c_1) + ', uniforms=' + toString(this.w7c_1) + ', varyings=' + toString(this.x7c_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.t7c_1);
    result = imul(result, 31) + getStringHashCode(this.u7c_1) | 0;
    result = imul(result, 31) + hashCode(this.v7c_1) | 0;
    result = imul(result, 31) + hashCode(this.w7c_1) | 0;
    result = imul(result, 31) + hashCode(this.x7c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.t7c_1, tmp0_other_with_cast.t7c_1))
      return false;
    if (!(this.u7c_1 === tmp0_other_with_cast.u7c_1))
      return false;
    if (!equals(this.v7c_1, tmp0_other_with_cast.v7c_1))
      return false;
    if (!equals(this.w7c_1, tmp0_other_with_cast.w7c_1))
      return false;
    if (!equals(this.x7c_1, tmp0_other_with_cast.x7c_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.s7f_1 = function_0;
  }
  ui(a, b) {
    return this.s7f_1(a, b);
  }
  compare(a, b) {
    return this.ui(a, b);
  }
  k4() {
    return this.s7f_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.l7g().b73_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.n3_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.n3_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.p74_1.n3_1) {
        case 0:
          var tmp_1;
          switch (type.q74_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.q74_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.q74_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.i74_1 === 1) ? '[' + _this__u8e3s4.i74_1 + ']' : '';
}
function get_IN() {
  return this.l7g().u7f();
}
function get_OUT() {
  return this.l7g().z7f();
}
function get_UNIFORM() {
  return this.l7g().y7f();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_62();
    this.k7d_1 = kind;
    this.l7d_1 = config;
  }
  l7g() {
    return this.l7d_1;
  }
  m7d(shader) {
    return this.m7g(shader.z7c_1, shader.a7d_1);
  }
  m7g(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.k7d_1.equals(ShaderType_FRAGMENT_getInstance()) && this.l7d_1.t7f()) {
      types.p7d_1.h(Varying.k6w(this.l7d_1.a7g(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.m7e(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.h1();
    var tmp0_iterator = funcs.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.u7d_1.w2(element.f7g_1.o3())) {
        destination.h(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet.da();
    var list = ArrayList.h1();
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var e = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.f7g_1.o3();
      if (set.h(key)) {
        list.h(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s = funcs.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      types.m7e(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_12();
    var this_1 = tmp_0.w33(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_63().g79()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_62().e79_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.j2t(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.l7d_1.d73_1;
        this_2.k2t(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_62().e79_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.j2t(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.k2t(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.p7g(Companion_getInstance_63().o7f_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.o7d_1), toList(types.q7d_1), toList(types.p7d_1));
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.n7f_1 = new GlslConfig(Companion_instance_54.r7c(), new Immutable(VOID, VOID, VOID, true));
    this.o7f_1 = 'GLSL';
    this.p7f_1 = 100;
    this.q7f_1 = 'fragColor';
    this.r7f_1 = 'gl_FragColor';
  }
  f79() {
    var tmp0_safe_receiver = Companion_instance_1.bi('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  }
  g79() {
    return Companion_instance_1.bi('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_63();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.b73_1 = variant;
    this.c73_1 = features;
    this.d73_1 = glslVersion;
    this.e73_1 = compatibility;
  }
  q7g(name) {
    if (this.e73_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  t7f() {
    if (_GLVariant___get_isES__impl__yezzg8(this.b73_1))
      return this.d73_1 >= 300;
    return !this.e73_1;
  }
  f73() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.t7f() && this.c73_1.i6g();
  }
  u7f() {
    return this.t7f() ? 'in' : 'attribute';
  }
  z7f() {
    return this.t7f() ? 'out' : 'varying';
  }
  y7f() {
    return 'uniform';
  }
  a7g() {
    return this.t7f() ? Companion_getInstance_63().q7f_1 : Companion_getInstance_63().r7f_1;
  }
  r7g(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  h79(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.b73_1 : variant;
    features = features === VOID ? this.c73_1 : features;
    glslVersion = glslVersion === VOID ? this.d73_1 : glslVersion;
    compatibility = compatibility === VOID ? this.e73_1 : compatibility;
    return $super === VOID ? this.r7g(variant, features, glslVersion, compatibility) : $super.r7g.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.b73_1) + ', features=' + toString(this.c73_1) + ', glslVersion=' + this.d73_1 + ', compatibility=' + this.e73_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.b73_1);
    result = imul(result, 31) + hashCode(this.c73_1) | 0;
    result = imul(result, 31) + this.d73_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e73_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.b73_1 === tmp0_other_with_cast.b73_1))
      return false;
    if (!equals(this.c73_1, tmp0_other_with_cast.c73_1))
      return false;
    if (!(this.d73_1 === tmp0_other_with_cast.d73_1))
      return false;
    if (!(this.e73_1 === tmp0_other_with_cast.e73_1))
      return false;
    return true;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.h7g_1 = kind;
    this.i7g_1 = config;
    this.j7g_1 = LinkedHashSet.j1();
    this.k7g_1 = new Indenter();
  }
  l7g() {
    return this.i7g_1;
  }
  o7e(stms) {
    var _iterator__ex2g4s = stms.s7g_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.n7e(stm);
    }
  }
  r7e(stm) {
    this.k7g_1.p34(this.x7e(stm.t7g_1) + ' = ' + this.x7e(stm.u7g_1) + ';');
  }
  s7e(stm) {
    this.k7g_1.p34('discard;');
  }
  t7e(stm) {
    this.k7g_1.p34('break;');
  }
  u7e(stm) {
    this.k7g_1.p34('continue;');
  }
  w7e(stm) {
    var result = stm.v7g_1;
    if (!(result == null)) {
      this.k7g_1.p34('return ' + this.x7e(result) + ';');
    } else {
      this.k7g_1.p34('return;');
    }
  }
  j7f(operand) {
    var tmp = this.w7f(operand.x7g_1) + '(';
    return tmp + joinToString_0(operand.y7g_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  e7f(operand) {
    return '(' + operand.a7h_1 + '(' + this.x7e(operand.b7h_1) + ')' + ')';
  }
  f7f(operand) {
    return '(' + this.x7e(operand.d7h_1) + ' ' + operand.e7h_1 + ' ' + this.x7e(operand.f7h_1) + ')';
  }
  y7e(func) {
    var tmp = this.i7g_1.q7g(func.o3()) + '(';
    var tmp_0 = func.h7h();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  g7f(ternary) {
    return '((' + this.x7e(ternary.j7h_1) + ') ? (' + this.x7e(ternary.k7h_1) + ') : (' + this.x7e(ternary.l7h_1) + '))';
  }
  p7e(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.k7g_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.x7e(stm.m7h_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.p34(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.q34();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.n7e(stm.n7h_1);
    }finally {
      this_0.r34();
    }
    this_0.p34('}');
    if (!(stm.o7h_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.p34(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.q34();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.n7e(ensureNotNull(stm.o7h_1));
      }finally {
        this_0.r34();
      }
      this_0.p34('}');
    }
  }
  q7e(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.k7g_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.w7f(stm.p7h_1.n29());
    var loopVar = this.a7f(stm.p7h_1);
    var min = this.x7e(stm.q7h_1);
    var maxExclusive = this.x7e(stm.r7h_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.p34(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.q34();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.n7e(stm.s7h_1);
    }finally {
      this_0.r34();
    }
    this_0.p34('}');
  }
  v7e(stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.k7g_1.p34(stm.p7g(Companion_getInstance_63().o7f_1));
  }
  a7f(operand) {
    super.a7f(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.h7g_1.n3_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.i7g_1.a7g();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.s72_1;
    }
    return tmp;
  }
  b7f(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.j7g_1.h(temp);
    return super.b7f(temp);
  }
  d7f(output) {
    return super.d7f(output);
  }
  k7f(operand) {
    return '' + operand.u7h_1;
  }
  l7f(operand) {
    var str = '' + operand.w7h_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  m7f(operand) {
    return '' + operand.y7h_1;
  }
  h7f(operand) {
    return this.x7e(operand.a7i_1) + '.' + operand.b7i_1;
  }
  i7f(operand) {
    return this.x7e(operand.d7i_1) + '[' + this.x7e(operand.e7i_1) + ']';
  }
}
class ProgramLayout {
  static f7i(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.z6o_1 = items;
    $this.a6p_1 = layoutSize;
    $this.b6p_1 = fixedLocation;
    $this.c6p_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.z6o_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.n2j();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s = this_0.a1();
    while (_iterator__ex2g4s.b1()) {
      var v = _iterator__ex2g4s.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.n29().p74_1.i7i_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.t2j(tmp$ret$0);
    }
    tmp.d6p_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.z6o_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.n2j();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s_0 = this_2.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var v_0 = _iterator__ex2g4s_0.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      $this.c6p_1 = !(v_0.d7b_1 == null) ? v_0.d7b_1 : nextAlignedTo($this.c6p_1, v_0.n29().p74_1.i7i_1);
      var out = $this.c6p_1;
      $this.c6p_1 = $this.c6p_1 + v_0.n29().s74_1 | 0;
      this_3.t2j(out);
    }
    tmp_0.e6p_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.d6p_1);
    tmp_1.f6p_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.a6p_1;
    tmp_2.g6p_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.c6p_1, $this.f6p_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  static h6p(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.f7i(toFastList_0(variables), layoutSize);
  }
  j7i() {
    return joinToString(this.z6o_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.j7i() + ', fixedLocation=' + this.b6p_1 + ']';
  }
  a1() {
    return this.z6o_1.a1();
  }
}
class Attribute extends VariableWithOffset {
  static k7i(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.e7b(name, type, 1, precision, offset);
    $this.u6v_1 = normalized;
    $this.v6v_1 = active;
    $this.w6v_1 = divisor;
    $this.x6v_1 = fixedLocation;
    return $this;
  }
  static y6v(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.k7i(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  toString() {
    return 'Attribute(' + this.s72_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.v72_1 === other.v72_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.n29().equals(other.n29());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.i74_1 === other.i74_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.s72_1 === other.s72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.u6v_1 === (other instanceof Attribute ? other : THROW_CCE()).u6v_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.d7b_1 == other.d7b_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.v6v_1 === other.v6v_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.u6v_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.d7b_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.v6v_1) | 0;
    return out;
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.s7g_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.s7g_1) + ')';
  }
  hashCode() {
    return hashCode(this.s7g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.s7g_1, tmp0_other_with_cast.s7g_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.t7g_1 = to;
    this.u7g_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.t7g_1) + ', from=' + toString(this.u7g_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.t7g_1);
    result = imul(result, 31) + hashCode(this.u7g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.t7g_1, tmp0_other_with_cast.t7g_1))
      return false;
    if (!equals(this.u7g_1, tmp0_other_with_cast.u7g_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.v7g_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.v7g_1) + ')';
  }
  hashCode() {
    return this.v7g_1 == null ? 0 : hashCode(this.v7g_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.v7g_1, tmp0_other_with_cast.v7g_1))
      return false;
    return true;
  }
}
class Break extends Stm {}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.m7h_1 = cond;
    this.n7h_1 = tbody;
    this.o7h_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.m7h_1) + ', tbody=' + toString(this.n7h_1) + ', fbody=' + toString_1(this.o7h_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.m7h_1);
    result = imul(result, 31) + hashCode(this.n7h_1) | 0;
    result = imul(result, 31) + (this.o7h_1 == null ? 0 : hashCode(this.o7h_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.m7h_1, tmp0_other_with_cast.m7h_1))
      return false;
    if (!equals(this.n7h_1, tmp0_other_with_cast.n7h_1))
      return false;
    if (!equals(this.o7h_1, tmp0_other_with_cast.o7h_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {}
class Raw extends Stm {
  l7i(name) {
    return this.n7g_1.c3(name);
  }
  m7i(name, default_0) {
    var tmp0_elvis_lhs = this.l7i(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  p7g(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.m7i(name, default_0) : $super.m7i.call(this, name, default_0);
  }
}
class Program$ExpressionBuilder$Companion$INSTANCE$1 {}
class Companion_48 {
  constructor() {
    Companion_instance_57 = this;
    var tmp = this;
    tmp.n7i_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
}
class FuncBuilder extends Builder {
  static w7i(parent) {
    var $this = this.x7i(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.u7i_1 = ArrayList.h1();
    return $this;
  }
  v7i(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.j7j(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.u7i_1.h(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.u7j_1 = decl;
  }
  ko(thisRef, property) {
    var tmp = this.u7j_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.o7i_1 = rettype;
    this.p7i_1 = varTypes;
    this.q7i_1 = builder;
    this.r7i_1 = block;
  }
  h6v(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.q7i_1.z6x(tmp, this.o7i_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.w7j_1 = $funcs;
    super(Unit_instance, $box);
  }
  f7e(func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.w7j_1;
    var key = func.o3();
    var tmp = func.j7e();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.e3(key, value);
  }
  k7e(func) {
    this.f7e(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  static y7j(cond, otrue, ofalse) {
    var $this = this.z7j(otrue.n29());
    $this.j7h_1 = cond;
    $this.k7h_1 = otrue;
    $this.l7h_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.j7h_1) + ', otrue=' + toString(this.k7h_1) + ', ofalse=' + toString(this.l7h_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.j7h_1);
    result = imul(result, 31) + hashCode(this.k7h_1) | 0;
    result = imul(result, 31) + hashCode(this.l7h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.j7h_1, tmp0_other_with_cast.j7h_1))
      return false;
    if (!equals(this.k7h_1, tmp0_other_with_cast.k7h_1))
      return false;
    if (!equals(this.l7h_1, tmp0_other_with_cast.l7h_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  static a7k(op, right) {
    var $this = this.z7j(right.n29());
    $this.a7h_1 = op;
    $this.b7h_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.a7h_1 + ', right=' + toString(this.b7h_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a7h_1);
    result = imul(result, 31) + hashCode(this.b7h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.a7h_1 === tmp0_other_with_cast.a7h_1))
      return false;
    if (!equals(this.b7h_1, tmp0_other_with_cast.b7h_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  static b7k(left, op, right) {
    var $this = this.z7j(left.n29());
    $this.d7h_1 = left;
    $this.e7h_1 = op;
    $this.f7h_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.d7h_1) + ', op=' + this.e7h_1 + ', right=' + toString(this.f7h_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.d7h_1);
    result = imul(result, 31) + getStringHashCode(this.e7h_1) | 0;
    result = imul(result, 31) + hashCode(this.f7h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.d7h_1, tmp0_other_with_cast.d7h_1))
      return false;
    if (!(this.e7h_1 === tmp0_other_with_cast.e7h_1))
      return false;
    if (!equals(this.f7h_1, tmp0_other_with_cast.f7h_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {}
class FloatLiteral extends Operand {
  static c7k(value) {
    var $this = this.z7j(VarType_Float1_getInstance());
    $this.w7h_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.w7h_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.w7h_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.w7h_1, tmp0_other_with_cast.w7h_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  static d7k(type, ops) {
    var $this = this.z7j(type);
    $this.x7g_1 = type;
    $this.y7g_1 = ops;
    return $this;
  }
  n29() {
    return this.x7g_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.x7g_1.equals(other.x7g_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.y7g_1, other.y7g_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.x7g_1.hashCode(), 7) + contentHashCode(this.y7g_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.x7g_1.toString() + ', ops=' + toString(this.y7g_1) + ')';
  }
}
class Swizzle extends Operand {
  static e7k(left, swizzle) {
    var $this = this.z7j(left.n29().f7k(swizzle.length));
    $this.a7i_1 = left;
    $this.b7i_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.a7i_1) + ', swizzle=' + this.b7i_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a7i_1);
    result = imul(result, 31) + getStringHashCode(this.b7i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.a7i_1, tmp0_other_with_cast.a7i_1))
      return false;
    if (!(this.b7i_1 === tmp0_other_with_cast.b7i_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {}
class BaseFunc extends Operand {
  static g7k(type) {
    return this.z7j(type);
  }
}
class Func extends BaseFunc {
  static l7k(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.g7k(type);
    $this.i7k_1 = name;
    $this.j7k_1 = ops;
    $this.k7k_1 = type;
    return $this;
  }
  o3() {
    return this.i7k_1;
  }
  h7h() {
    return this.j7k_1;
  }
  n29() {
    return this.k7k_1;
  }
  static m7k(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.l7k(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.i7k_1 + ', ops=' + toString(this.j7k_1) + ', type=' + this.k7k_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.i7k_1);
    result = imul(result, 31) + hashCode(this.j7k_1) | 0;
    result = imul(result, 31) + this.k7k_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.i7k_1 === tmp0_other_with_cast.i7k_1))
      return false;
    if (!equals(this.j7k_1, tmp0_other_with_cast.j7k_1))
      return false;
    if (!this.k7k_1.equals(tmp0_other_with_cast.k7k_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  static n7k(ref, ops) {
    var $this = this.g7k(ref.o7k());
    $this.h7e_1 = ref;
    $this.i7e_1 = ops;
    return $this;
  }
  j7e() {
    return this.h7e_1;
  }
  h7h() {
    return this.i7e_1;
  }
  o3() {
    return this.j7e().o3();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.p7k_1 = ArrayList.h1();
    this.q7k_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.b7d_1 + '-' + fragment.b7d_1 : name;
    this.o6n_1 = vertex;
    this.p6n_1 = fragment;
    this.q6n_1 = name;
    this.r6n_1 = plus_0(this.o6n_1.g7d_1, this.p6n_1.g7d_1);
    this.s6n_1 = plus_0(this.o6n_1.h7d_1, this.p6n_1.h7d_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.s6n_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.m6o_1;
      destination.h(tmp$ret$0);
    }
    tmp.t6n_1 = distinct(destination);
    this.u6n_1 = plus_0(this.o6n_1.j7d_1, this.p6n_1.j7d_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.r6n_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.cc(capacity);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.zk_1, new UniformInProgram(element.zk_1, element.yk_1));
      destination_0.e3(pair.dl_1, pair.el_1);
    }
    tmp_0.v6n_1 = destination_0;
    this.w6n_1 = plus_0(this.o6n_1.i7d_1, this.p6n_1.i7d_1);
    this.x6n_1 = (imul(this.o6n_1.hashCode(), 11) + imul(this.p6n_1.hashCode(), 7) | 0) + getStringHashCode(this.q6n_1) | 0;
  }
  hashCode() {
    return this.x6n_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.o6n_1.equals(other.o6n_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.p6n_1.equals(other.p6n_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.q6n_1 === other.q6n_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  c6() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.w6n_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.s72_1;
      destination.h(tmp$ret$0);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.r6n_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.s72_1;
      destination_0.h(tmp$ret$3);
    }
    return 'Program(name=' + this.q6n_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  u7k(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  v7k(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.o6n_1 : vertex;
    fragment = fragment === VOID ? this.p6n_1 : fragment;
    name = name === VOID ? this.q6n_1 : name;
    return $super === VOID ? this.u7k(vertex, fragment, name) : $super.u7k.call(this, vertex, fragment, name);
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.y7c_1 = type;
    this.z7c_1 = stm;
    this.a7d_1 = functions;
    this.b7d_1 = name;
    this.c7d_1 = hashCode(this.z7c_1);
    this.d7d_1 = hashCode(this.a7d_1);
    this.e7d_1 = (imul(this.y7c_1.hashCode(), 17) + this.c7d_1 | 0) + imul(this.d7d_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.n7e(this.z7c_1);
    tmp.f7d_1 = this_0;
    this.g7d_1 = this.f7d_1.q7d_1;
    this.h7d_1 = this.f7d_1.r7d_1;
    this.i7d_1 = this.f7d_1.o7d_1;
    this.j7d_1 = this.f7d_1.t7d_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.y7c_1.equals(other.y7c_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.e7d_1 === other.e7d_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.z7c_1, other.z7c_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.a7d_1, other.a7d_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.e7d_1;
  }
  toString() {
    return 'Shader(type=' + this.y7c_1.toString() + ', stm=' + toString(this.z7c_1) + ', functions=' + toString(this.a7d_1) + ', name=' + this.b7d_1 + ')';
  }
}
class Varying extends Variable {
  static w7k(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7k(name, type, arrayCount, precision);
  }
  static k6w(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.w7k(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.s72_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.v72_1 === other.v72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.n29().equals(other.n29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i74_1 === other.i74_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s72_1 === other.s72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
  }
}
class Output extends Varying {
  static j7l() {
    Output_instance = null;
    var $this = this.k6w('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.v72_1 === other.v72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.n29().equals(other.n29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i74_1 === other.i74_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s72_1 === other.s72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
  }
}
class Provider {
  constructor(index, stype) {
    this.f6v_1 = index;
    this.g6v_1 = stype;
  }
  h6v(thisRef, property) {
    return Sampler.k7l(property.callableName, this.f6v_1, this.g6v_1);
  }
}
class Sampler extends Variable {
  static k7l(name, index, stype) {
    var $this = this.o7l(name, stype.n7l_1);
    $this.c6k_1 = index;
    $this.d6k_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.s72_1 + ', ' + this.c6k_1 + ', ' + this.d6k_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.v72_1 === other.v72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.n29().equals(other.n29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i74_1 === other.i74_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s72_1 === other.s72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
  }
  ko(thisRef, property) {
    return this;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.n7l_1 = vtype;
  }
}
class Uniform extends VariableWithOffset {
  static s7b(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.e7b(name, type, arrayCount, precision, offset);
    $this.r7b_1 = typedUniform;
    if (type.p7l()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.w4(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.s72_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.v72_1 === other.v72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.n29().equals(other.n29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i74_1 === other.i74_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s72_1 === other.s72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
  }
}
class Companion_49 {
  q7l(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  r7l(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  s7l(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  t7l(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  u7l(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  v7l(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.p74_1 = kind;
    this.q74_1 = elementCount;
    this.r74_1 = isMatrix;
    this.s74_1 = imul(this.p74_1.i7i_1, this.q74_1);
  }
  f7k(length) {
    var tmp;
    switch (this.p74_1.n3_1) {
      case 1:
        tmp = Companion_instance_58.q7l(length);
        break;
      case 2:
        tmp = Companion_instance_58.r7l(length);
        break;
      case 3:
        tmp = Companion_instance_58.s7l(length);
        break;
      case 4:
        tmp = Companion_instance_58.t7l(length);
        break;
      case 5:
        tmp = Companion_instance_58.u7l(length);
        break;
      case 6:
        tmp = Companion_instance_58.v7l(length);
        break;
      default:
        throw NotImplementedError.od();
    }
    return tmp;
  }
  p7l() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Precision extends Enum {}
class Temp extends Variable {
  static r7k(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7k('temp' + id, type, arrayCount, precision);
  }
  static w6w(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.r7k(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.s72_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.v72_1 === other.v72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.n29().equals(other.n29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i74_1 === other.i74_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s72_1 === other.s72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.b7g_1 = name;
    this.c7g_1 = rettype;
    this.d7g_1 = args;
    this.e7g_1 = stm;
    this.f7g_1 = this;
  }
  o3() {
    return this.b7g_1;
  }
  o7k() {
    return this.c7g_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.b7g_1 + ', rettype=' + this.c7g_1.toString() + ', args=' + toString(this.d7g_1) + ', stm=' + toString(this.e7g_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.b7g_1);
    result = imul(result, 31) + this.c7g_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.d7g_1) | 0;
    result = imul(result, 31) + hashCode(this.e7g_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.b7g_1 === tmp0_other_with_cast.b7g_1))
      return false;
    if (!this.c7g_1.equals(tmp0_other_with_cast.c7g_1))
      return false;
    if (!equals(this.d7g_1, tmp0_other_with_cast.d7g_1))
      return false;
    if (!equals(this.e7g_1, tmp0_other_with_cast.e7g_1))
      return false;
    return true;
  }
}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.i7i_1 = bytesSize;
  }
}
class UniformInProgram {
  constructor(uniform, index) {
    this.x7l_1 = uniform;
    this.y7l_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.x7l_1.toString() + ', index=' + this.y7l_1 + ')';
  }
  hashCode() {
    var result = this.x7l_1.hashCode();
    result = imul(result, 31) + this.y7l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.x7l_1.equals(tmp0_other_with_cast.x7l_1))
      return false;
    if (!(this.y7l_1 === tmp0_other_with_cast.y7l_1))
      return false;
    return true;
  }
}
class Arg extends Variable {
  static j7j(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7k(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.s72_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.v72_1 === other.v72_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.n29().equals(other.n29());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.i74_1 === other.i74_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.s72_1 === other.s72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.v72_1 + imul(this.n29().hashCode(), 7) | 0) + imul(getStringHashCode(this.s72_1), 11) | 0;
  }
}
class ShaderType extends Enum {}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.z7l_1 = function_0;
  }
  d18() {
    return this.z7l_1();
  }
  k4() {
    return this.z7l_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.a7m_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.a7m_1());
  }
}
class Companion_50 {
  constructor() {
    this.b7m_1 = 33309;
    this.c7m_1 = 33084;
    this.d7m_1 = 33085;
    this.e7m_1 = 256;
    this.f7m_1 = 1024;
    this.g7m_1 = 16384;
    this.h7m_1 = 0;
    this.i7m_1 = 1;
    this.j7m_1 = 0;
    this.k7m_1 = 1;
    this.l7m_1 = 2;
    this.m7m_1 = 3;
    this.n7m_1 = 4;
    this.o7m_1 = 5;
    this.p7m_1 = 6;
    this.q7m_1 = 0;
    this.r7m_1 = 1;
    this.s7m_1 = 768;
    this.t7m_1 = 769;
    this.u7m_1 = 770;
    this.v7m_1 = 771;
    this.w7m_1 = 772;
    this.x7m_1 = 773;
    this.y7m_1 = 774;
    this.z7m_1 = 775;
    this.a7n_1 = 776;
    this.b7n_1 = 32774;
    this.c7n_1 = 32777;
    this.d7n_1 = 32777;
    this.e7n_1 = 34877;
    this.f7n_1 = 32778;
    this.g7n_1 = 32779;
    this.h7n_1 = 32968;
    this.i7n_1 = 32969;
    this.j7n_1 = 32970;
    this.k7n_1 = 32971;
    this.l7n_1 = 32769;
    this.m7n_1 = 32770;
    this.n7n_1 = 32771;
    this.o7n_1 = 32772;
    this.p7n_1 = 32773;
    this.q7n_1 = 34962;
    this.r7n_1 = 34963;
    this.s7n_1 = 34964;
    this.t7n_1 = 34965;
    this.u7n_1 = 35040;
    this.v7n_1 = 35044;
    this.w7n_1 = 35048;
    this.x7n_1 = 34660;
    this.y7n_1 = 34661;
    this.z7n_1 = 34342;
    this.a7o_1 = 1028;
    this.b7o_1 = 1029;
    this.c7o_1 = 1032;
    this.d7o_1 = 3553;
    this.e7o_1 = 32879;
    this.f7o_1 = 2884;
    this.g7o_1 = 3042;
    this.h7o_1 = 3024;
    this.i7o_1 = 2960;
    this.j7o_1 = 2929;
    this.k7o_1 = 3089;
    this.l7o_1 = 32823;
    this.m7o_1 = 32926;
    this.n7o_1 = 32928;
    this.o7o_1 = 0;
    this.p7o_1 = 1280;
    this.q7o_1 = 1281;
    this.r7o_1 = 1282;
    this.s7o_1 = 1285;
    this.t7o_1 = 2304;
    this.u7o_1 = 2305;
    this.v7o_1 = 2849;
    this.w7o_1 = 33901;
    this.x7o_1 = 33902;
    this.y7o_1 = 2885;
    this.z7o_1 = 2886;
    this.a7p_1 = 2928;
    this.b7p_1 = 2930;
    this.c7p_1 = 2931;
    this.d7p_1 = 2932;
    this.e7p_1 = 2961;
    this.f7p_1 = 2962;
    this.g7p_1 = 2964;
    this.h7p_1 = 2965;
    this.i7p_1 = 2966;
    this.j7p_1 = 2967;
    this.k7p_1 = 2963;
    this.l7p_1 = 2968;
    this.m7p_1 = 34816;
    this.n7p_1 = 34817;
    this.o7p_1 = 34818;
    this.p7p_1 = 34819;
    this.q7p_1 = 36003;
    this.r7p_1 = 36004;
    this.s7p_1 = 36005;
    this.t7p_1 = 2978;
    this.u7p_1 = 3088;
    this.v7p_1 = 3106;
    this.w7p_1 = 3107;
    this.x7p_1 = 3317;
    this.y7p_1 = 3333;
    this.z7p_1 = 3379;
    this.a7q_1 = 3386;
    this.b7q_1 = 3408;
    this.c7q_1 = 3410;
    this.d7q_1 = 3411;
    this.e7q_1 = 3412;
    this.f7q_1 = 3413;
    this.g7q_1 = 3414;
    this.h7q_1 = 3415;
    this.i7q_1 = 10752;
    this.j7q_1 = 32824;
    this.k7q_1 = 32873;
    this.l7q_1 = 32936;
    this.m7q_1 = 32937;
    this.n7q_1 = 32938;
    this.o7q_1 = 32939;
    this.p7q_1 = 34466;
    this.q7q_1 = 34467;
    this.r7q_1 = 4352;
    this.s7q_1 = 4353;
    this.t7q_1 = 4354;
    this.u7q_1 = 33170;
    this.v7q_1 = 5120;
    this.w7q_1 = 5121;
    this.x7q_1 = 5122;
    this.y7q_1 = 5123;
    this.z7q_1 = 5124;
    this.a7r_1 = 5125;
    this.b7r_1 = 5126;
    this.c7r_1 = 5132;
    this.d7r_1 = 6402;
    this.e7r_1 = 6406;
    this.f7r_1 = 6407;
    this.g7r_1 = 6408;
    this.h7r_1 = 6409;
    this.i7r_1 = 6410;
    this.j7r_1 = 32819;
    this.k7r_1 = 32820;
    this.l7r_1 = 33635;
    this.m7r_1 = 35632;
    this.n7r_1 = 35633;
    this.o7r_1 = 34921;
    this.p7r_1 = 36347;
    this.q7r_1 = 36348;
    this.r7r_1 = 35661;
    this.s7r_1 = 35660;
    this.t7r_1 = 34930;
    this.u7r_1 = 36349;
    this.v7r_1 = 35663;
    this.w7r_1 = 35712;
    this.x7r_1 = 35714;
    this.y7r_1 = 35715;
    this.z7r_1 = 35717;
    this.a7s_1 = 35718;
    this.b7s_1 = 35719;
    this.c7s_1 = 35721;
    this.d7s_1 = 35722;
    this.e7s_1 = 35724;
    this.f7s_1 = 35725;
    this.g7s_1 = 512;
    this.h7s_1 = 513;
    this.i7s_1 = 514;
    this.j7s_1 = 515;
    this.k7s_1 = 516;
    this.l7s_1 = 517;
    this.m7s_1 = 518;
    this.n7s_1 = 519;
    this.o7s_1 = 7680;
    this.p7s_1 = 7681;
    this.q7s_1 = 7682;
    this.r7s_1 = 7683;
    this.s7s_1 = 5386;
    this.t7s_1 = 34055;
    this.u7s_1 = 34056;
    this.v7s_1 = 7936;
    this.w7s_1 = 7937;
    this.x7s_1 = 7938;
    this.y7s_1 = 7939;
    this.z7s_1 = 9728;
    this.a7t_1 = 9729;
    this.b7t_1 = 9984;
    this.c7t_1 = 9985;
    this.d7t_1 = 9986;
    this.e7t_1 = 9987;
    this.f7t_1 = 10240;
    this.g7t_1 = 10241;
    this.h7t_1 = 10242;
    this.i7t_1 = 10243;
    this.j7t_1 = 32882;
    this.k7t_1 = 5890;
    this.l7t_1 = 34067;
    this.m7t_1 = 34068;
    this.n7t_1 = 34069;
    this.o7t_1 = 34070;
    this.p7t_1 = 34071;
    this.q7t_1 = 34072;
    this.r7t_1 = 34073;
    this.s7t_1 = 34074;
    this.t7t_1 = 34076;
    this.u7t_1 = 33984;
    this.v7t_1 = 33985;
    this.w7t_1 = 33986;
    this.x7t_1 = 33987;
    this.y7t_1 = 33988;
    this.z7t_1 = 33989;
    this.a7u_1 = 33990;
    this.b7u_1 = 33991;
    this.c7u_1 = 33992;
    this.d7u_1 = 33993;
    this.e7u_1 = 33994;
    this.f7u_1 = 33995;
    this.g7u_1 = 33996;
    this.h7u_1 = 33997;
    this.i7u_1 = 33998;
    this.j7u_1 = 33999;
    this.k7u_1 = 34000;
    this.l7u_1 = 34001;
    this.m7u_1 = 34002;
    this.n7u_1 = 34003;
    this.o7u_1 = 34004;
    this.p7u_1 = 34005;
    this.q7u_1 = 34006;
    this.r7u_1 = 34007;
    this.s7u_1 = 34008;
    this.t7u_1 = 34009;
    this.u7u_1 = 34010;
    this.v7u_1 = 34011;
    this.w7u_1 = 34012;
    this.x7u_1 = 34013;
    this.y7u_1 = 34014;
    this.z7u_1 = 34015;
    this.a7v_1 = 34016;
    this.b7v_1 = 10497;
    this.c7v_1 = 33071;
    this.d7v_1 = 33648;
    this.e7v_1 = 35664;
    this.f7v_1 = 35665;
    this.g7v_1 = 35666;
    this.h7v_1 = 35667;
    this.i7v_1 = 35668;
    this.j7v_1 = 35669;
    this.k7v_1 = 35670;
    this.l7v_1 = 35671;
    this.m7v_1 = 35672;
    this.n7v_1 = 35673;
    this.o7v_1 = 35674;
    this.p7v_1 = 35675;
    this.q7v_1 = 35676;
    this.r7v_1 = 35678;
    this.s7v_1 = 35680;
    this.t7v_1 = 34338;
    this.u7v_1 = 34339;
    this.v7v_1 = 34340;
    this.w7v_1 = 34341;
    this.x7v_1 = 34922;
    this.y7v_1 = 34373;
    this.z7v_1 = 34975;
    this.a7w_1 = 35738;
    this.b7w_1 = 35739;
    this.c7w_1 = 35713;
    this.d7w_1 = 35716;
    this.e7w_1 = 35720;
    this.f7w_1 = 36346;
    this.g7w_1 = 36344;
    this.h7w_1 = 36345;
    this.i7w_1 = 36336;
    this.j7w_1 = 36337;
    this.k7w_1 = 36338;
    this.l7w_1 = 36339;
    this.m7w_1 = 36340;
    this.n7w_1 = 36341;
    this.o7w_1 = 36160;
    this.p7w_1 = 36161;
    this.q7w_1 = 32854;
    this.r7w_1 = 32855;
    this.s7w_1 = 36194;
    this.t7w_1 = 33189;
    this.u7w_1 = 6401;
    this.v7w_1 = 36168;
    this.w7w_1 = 36162;
    this.x7w_1 = 36163;
    this.y7w_1 = 36164;
    this.z7w_1 = 36176;
    this.a7x_1 = 36177;
    this.b7x_1 = 36178;
    this.c7x_1 = 36179;
    this.d7x_1 = 36180;
    this.e7x_1 = 36181;
    this.f7x_1 = 36048;
    this.g7x_1 = 36049;
    this.h7x_1 = 36050;
    this.i7x_1 = 36051;
    this.j7x_1 = 36064;
    this.k7x_1 = 36096;
    this.l7x_1 = 33306;
    this.m7x_1 = 34041;
    this.n7x_1 = 36128;
    this.o7x_1 = 0;
    this.p7x_1 = 36053;
    this.q7x_1 = 36054;
    this.r7x_1 = 36055;
    this.s7x_1 = 36057;
    this.t7x_1 = 36061;
    this.u7x_1 = 36006;
    this.v7x_1 = 36007;
    this.w7x_1 = 34024;
    this.x7x_1 = 1286;
    this.y7x_1 = 37120;
    this.z7x_1 = 34836;
    this.a7y_1 = 3313;
    this.b7y_1 = 3314;
    this.c7y_1 = 3316;
    this.d7y_1 = 3315;
    this.e7y_1 = 3312;
    this.f7y_1 = 37441;
    this.g7y_1 = 36197;
    this.h7y_1 = 35345;
    this.i7y_1 = 35368;
    this.j7y_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.q71_1 = new Mixin();
    this.r71_1 = new ContextInfo();
    this.s71_1 = null;
    var tmp = this;
    tmp.t71_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  f75(texture) {
    throw NotImplementedError.od();
  }
  k79(program, shader) {
    throw NotImplementedError.od();
  }
  j79(program, index, name) {
    throw NotImplementedError.od();
  }
  z73(target, buffer) {
    throw NotImplementedError.od();
  }
  c78(target, framebuffer) {
    throw NotImplementedError.od();
  }
  j78(target, renderbuffer) {
    throw NotImplementedError.od();
  }
  a78(target, texture) {
    throw NotImplementedError.od();
  }
  n76(modeRGB, modeAlpha) {
    throw NotImplementedError.od();
  }
  o76(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw NotImplementedError.od();
  }
  j75(target, size, data, usage) {
    throw NotImplementedError.od();
  }
  i75(target, offset, size, data) {
    throw NotImplementedError.od();
  }
  j76(mask) {
    throw NotImplementedError.od();
  }
  e76(red, green, blue, alpha) {
    throw NotImplementedError.od();
  }
  g76(d) {
    throw NotImplementedError.od();
  }
  i76(s) {
    throw NotImplementedError.od();
  }
  q78(red, green, blue, alpha) {
    throw NotImplementedError.od();
  }
  b79(shader) {
    throw NotImplementedError.od();
  }
  d79() {
    throw NotImplementedError.od();
  }
  z78(type) {
    throw NotImplementedError.od();
  }
  g77(mode) {
    throw NotImplementedError.od();
  }
  l7y(n, items) {
    throw NotImplementedError.od();
  }
  m7y(n, items) {
    throw NotImplementedError.od();
  }
  y78(program) {
    throw NotImplementedError.od();
  }
  n7y(n, items) {
    throw NotImplementedError.od();
  }
  x78(shader) {
    throw NotImplementedError.od();
  }
  o7y(n, items) {
    throw NotImplementedError.od();
  }
  p78(func) {
    throw NotImplementedError.od();
  }
  f76(flag) {
    throw NotImplementedError.od();
  }
  o78(n, f) {
    throw NotImplementedError.od();
  }
  s76(cap) {
    throw NotImplementedError.od();
  }
  i77(index) {
    throw NotImplementedError.od();
  }
  z76(mode, first, count) {
    throw NotImplementedError.od();
  }
  b77(mode, count, type, indices) {
    throw NotImplementedError.od();
  }
  t76(cap) {
    throw NotImplementedError.od();
  }
  m77(index) {
    throw NotImplementedError.od();
  }
  lc() {
    throw NotImplementedError.od();
  }
  m78(target, attachment, renderbuffertarget, renderbuffer) {
    throw NotImplementedError.od();
  }
  l78(target, attachment, textarget, texture, level) {
    throw NotImplementedError.od();
  }
  n78(mode) {
    throw NotImplementedError.od();
  }
  p7y(n, buffers) {
    throw NotImplementedError.od();
  }
  n75(target) {
    throw NotImplementedError.od();
  }
  q7y(n, framebuffers) {
    throw NotImplementedError.od();
  }
  r7y(n, renderbuffers) {
    throw NotImplementedError.od();
  }
  s7y(n, textures) {
    throw NotImplementedError.od();
  }
  v78(program, name) {
    throw NotImplementedError.od();
  }
  c79() {
    throw NotImplementedError.od();
  }
  t7y(pname, data) {
    throw NotImplementedError.od();
  }
  u7y(program, pname, params) {
    throw NotImplementedError.od();
  }
  v7y(shader, pname, params) {
    throw NotImplementedError.od();
  }
  w7y(shader, bufSize, length, infoLog) {
    throw NotImplementedError.od();
  }
  u71(name) {
    throw NotImplementedError.od();
  }
  l79(program) {
    throw NotImplementedError.od();
  }
  k75(pname, param) {
    throw NotImplementedError.od();
  }
  k78(target, internalformat, width, height) {
    throw NotImplementedError.od();
  }
  r78(x, y, width, height) {
    throw NotImplementedError.od();
  }
  a79(shader, string) {
    throw NotImplementedError.od();
  }
  v76(func, ref, mask) {
    throw NotImplementedError.od();
  }
  u76(face, func, ref, mask) {
    throw NotImplementedError.od();
  }
  h76(mask) {
    throw NotImplementedError.od();
  }
  y76(face, mask) {
    throw NotImplementedError.od();
  }
  x76(fail, zfail, zpass) {
    throw NotImplementedError.od();
  }
  w76(face, sfail, dpfail, dppass) {
    throw NotImplementedError.od();
  }
  l75(target, level, internalformat, width, height, border, format, type, pixels) {
    throw NotImplementedError.od();
  }
  m75(target, level, internalformat, format, type, data) {
    var buffer = Buffer.e12(imul(imul(data.l3x_1, data.m3x_1), 4), true);
    setArrayLE(buffer, 0, data.i45().b3x_1);
    this.l75(target, level, internalformat, data.l3x_1, data.m3x_1, 0, format, type, buffer);
  }
  e75(target, pname, param) {
    throw NotImplementedError.od();
  }
  a75(location, count, value) {
    throw NotImplementedError.od();
  }
  y72(location, v0) {
    throw NotImplementedError.od();
  }
  t74(location, count, value) {
    throw NotImplementedError.od();
  }
  b75(location, count, value) {
    throw NotImplementedError.od();
  }
  u74(location, count, value) {
    throw NotImplementedError.od();
  }
  c75(location, count, value) {
    throw NotImplementedError.od();
  }
  v74(location, count, value) {
    throw NotImplementedError.od();
  }
  d75(location, count, value) {
    throw NotImplementedError.od();
  }
  w74(location, count, value) {
    throw NotImplementedError.od();
  }
  x74(location, count, transpose, value) {
    throw NotImplementedError.od();
  }
  y74(location, count, transpose, value) {
    throw NotImplementedError.od();
  }
  z74(location, count, transpose, value) {
    throw NotImplementedError.od();
  }
  w78(program) {
    throw NotImplementedError.od();
  }
  n77(index, size, type, normalized, stride, pointer) {
    throw NotImplementedError.od();
  }
  b78(x, y, width, height) {
    throw NotImplementedError.od();
  }
  p76(cap, enable) {
    if (enable) {
      this.t76(cap);
    } else {
      this.s76(cap);
    }
    return enable;
  }
  a77(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  c77(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  h77(index, divisor) {
    unsupported();
  }
  u77(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  z72(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  a73(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  x7y(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  j77(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  g75() {
    return Companion_instance_54.r7c();
  }
  z75() {
    return Unit_instance;
  }
  e77(contextVersion) {
    return Unit_instance;
  }
  y7y(name, index) {
    throw NotImplementedError.od();
  }
  k7y() {
    if (this.s71_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.od();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList.h1();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = this_0.a2_1;
        var last = this_0.b2_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
            var it = element;
            // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
            var tmp0_safe_receiver = this.y7y(7939, it);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              destination.h(tmp0_safe_receiver);
            }
          }
           while (!(element === last));
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.u71(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.s71_1 = tmp_0;
    }
    return ensureNotNull(this.s71_1);
  }
  a76() {
    return this.k7y();
  }
  vx(value) {
    this.q71_1.vx(value);
  }
  wx() {
    return this.q71_1.wx();
  }
}
class KmlGlContext {
  constructor(window_0, gl, parent, $box) {
    parent = parent === VOID ? null : parent;
    boxApply(this, $box);
    this.w75_1 = window_0;
    this.x75_1 = gl;
    this.y75_1 = parent;
  }
  d77() {
  }
  f77() {
  }
  c6() {
  }
}
class KorgeReloadInternalImpl {
  z7y(clazz, context) {
    return clazz;
  }
  a7z(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.b7z_1 = injector;
    this.c7z_1 = refreshedClasses;
    this.d7z_1 = rootFolders;
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.e7z_1 = null;
    this.f7z_1 = Companion_getInstance_1().mw('KorgeReload');
  }
  g7z(eventDispatcher) {
    if (!Companion_getInstance_2().fu().nu() || !(Companion_instance_1.bi('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.e7z_1 = eventDispatcher;
  }
  h7z() {
    if (!Companion_getInstance_2().fu().nu())
      return Unit_instance;
    if (!(this.e7z_1 == null))
      this.e7z_1 = null;
  }
}
class Companion_51 {}
class Companion_52 {
  constructor() {
    Companion_instance_61 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_43().r6g_1;
    tmp.i7z_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.j7z_1 = this.i7z_1.v82(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_43().i6q(Companion_getInstance_53().z6p_1, Companion_getInstance_53().g6q_1);
    tmp_0.k7z_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_43().t6g_1;
    tmp_1.l7z_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_43().i6q(Companion_getInstance_53().y6p_1, Companion_getInstance_53().c6q_1);
    tmp_2.m7z_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_43().i6q(Companion_getInstance_53().z6p_1, Companion_getInstance_53().d6q_1);
    tmp_3.n7z_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_43().i6q(Companion_getInstance_53().g6q_1, Companion_getInstance_53().c6q_1);
    tmp_4.o7z_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_43().i6q(Companion_getInstance_53().g6q_1, Companion_getInstance_53().e6q_1);
    tmp_5.p7z_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_43().i6q(Companion_getInstance_53().a6q_1, Companion_getInstance_53().x6p_1);
    tmp_6.q7z_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().x6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_54().m6q_1);
    tmp_7.r7z_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_43().h6q(Companion_getInstance_53().b6q_1, Companion_getInstance_53().g6q_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
    tmp_8.s7z_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().x6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
    tmp_9.t7z_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().x6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
    tmp_10.u7z_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().x6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
    tmp_11.v7z_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().x6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
    tmp_12.w7z_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_43().h6q(Companion_getInstance_53().e6q_1, Companion_getInstance_53().x6p_1, Companion_getInstance_53().z6p_1, Companion_getInstance_53().z6p_1);
    tmp_13.x7z_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.y7z_1 = [this.j7z_1, this.k7z_1, this.i7z_1, this.l7z_1, this.m7z_1, this.n7z_1, this.o7z_1, this.p7z_1, this.q7z_1, this.r7z_1, this.s7z_1, this.t7z_1, this.u7z_1, this.v7z_1, this.w7z_1, this.x7z_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.y7z_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.cc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.blend.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.t82_1);
      destination.e3(tmp$ret$3, element);
    }
    tmp_15.z7z_1 = destination;
    this.a80_1 = toList_0(this.y7z_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.y7z_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.cc(capacity_0);
    var inductionVariable_0 = this_1.a2_1;
    var last_0 = this_1.b2_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'korlibs.korge.blend.Companion.TO_ORDINAL.<anonymous>' call
        var it = element_0;
        var tmp$ret$6 = Companion_getInstance_68().y7z_1[it];
        destination_0.e3(tmp$ret$6, element_0);
      }
       while (!(element_0 === last_0));
    tmp_16.b80_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_68();
    name = name === VOID ? null : name;
    this.s82_1 = factors;
    this.t82_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.s82_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.t82_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.u82_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.u82_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.s82_1 === other.s82_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.t82_1 == other.t82_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.t82_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  w82(factors, name) {
    return new BlendMode(factors, name);
  }
  v82(factors, name, $super) {
    factors = factors === VOID ? this.s82_1 : factors;
    name = name === VOID ? this.t82_1 : name;
    return $super === VOID ? this.w82(factors, name) : $super.w82.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.x82_1 = booleanArray(Companion_getInstance_35().r6d_1);
    this.y82_1 = booleanArray(Companion_getInstance_35().r6d_1);
    this.z82_1 = false;
    this.a83_1 = false;
    this.b83_1 = false;
    this.c83_1 = false;
  }
  d83(key) {
    return this.e83(key);
  }
  e83(key) {
    return this.x82_1[key.n3_1];
  }
  f83(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.x82_1[key.n3_1] = false;
        break;
      case false:
        this.x82_1[key.n3_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.z82_1 = shift || this.d83(Companion_getInstance_35().f6e()) || this.d83(Companion_getInstance_35().g6e());
    this.a83_1 = ctrl || this.d83(Companion_getInstance_35().d6e()) || this.d83(Companion_getInstance_35().e6e());
    this.b83_1 = alt || this.d83(Companion_getInstance_35().h6e()) || this.d83(Companion_getInstance_35().i6e());
    this.c83_1 = meta || this.d83(Key_META_getInstance());
  }
  g83(e) {
    switch (e.g68_1.n3_1) {
      case 0:
      case 1:
        this.f83(e.i68_1, e.g68_1.equals(Type_UP_getInstance()), this.z82_1, this.a83_1, this.b83_1, this.c83_1);
        break;
      default:
        break;
    }
  }
  h83(delta) {
  }
  i83(delta) {
    arraycopy_4(this.x82_1, 0, this.y82_1, 0, this.x82_1.length);
  }
}
class Companion_53 {
  constructor() {
    this.j83_1 = 256;
  }
}
class Input {
  constructor() {
    this.k83_1 = new Mixin();
    this.l83_1 = Companion_getInstance_28().k6a_1;
    this.m83_1 = new TouchEvent();
    var tmp = this;
    tmp.n83_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.o83_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.p83_1 = 20.0;
    this.q83_1 = Vector2D.n27(-1000.0, -1000.0);
    this.r83_1 = Vector2D.n27(-1000.0, -1000.0);
    this.s83_1 = 0;
    this.t83_1 = false;
    this.u83_1 = true;
    this.v83_1 = false;
    this.w83_1 = new InputKeys();
    this.x83_1 = booleanArray(256);
    this.y83_1 = booleanArray(256);
    this.z83_1 = new Float64Array(256);
    this.a84_1 = new Float64Array(256);
    this.b84_1 = booleanArray(256);
    this.c84_1 = booleanArray(256);
    this.d84_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
        var it = item;
        var tmp$ret$2 = new GamepadInfo(it);
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    tmp_1.e84_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.f84_1 = ArrayList.h1();
  }
  h84(touchEvent) {
    this.m83_1.t6b(touchEvent);
  }
  i84() {
    return this.q83_1;
  }
  j84(p, down) {
    if (down)
      this.r83_1 = p;
    else
      this.q83_1 = p;
  }
  k84(button, down) {
    this.s83_1 = setBits(this.s83_1, button.t6e_1, down);
  }
  l84() {
    this.f84_1.h3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.e84_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.o6c_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.f84_1.h(gamepad);
      }
    }
  }
  m84(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.x83_1.length - 1 | 0) : false) {
      this.x83_1[pKeyCode] = b;
    }
  }
  n84(delta) {
    var tmp0_safe_receiver = this.wx();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.h3();
    }
    this.w83_1.h83(delta);
  }
  o84(delta) {
    this.v83_1 = false;
    this.w83_1.i83(delta);
    endFrameOldKeys(this, delta);
  }
  p84(e) {
    switch (e.g68_1.n3_1) {
      case 1:
        this.m84(e.j68_1, true);
        break;
      case 0:
        this.m84(e.j68_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  vx(value) {
    this.k83_1.vx(value);
  }
  wx() {
    return this.k83_1.wx();
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.q84_1 = 1280;
    this.r84_1 = 720;
    this.s84_1 = Size2D.l26(1280, 720);
  }
}
class Companion_54 {
  t84(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.v84(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.bc() : props;
    this.u84_1 = props;
  }
  w84(str) {
    var _iterator__ex2g4s = split(str, ['\n']).a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.d1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= 1 ? 1 < parts.e1() : false) {
        tmp = parts.d1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.u84_1.e3(key, value);
    }
  }
  v84(str) {
    this.h3();
    this.w84(str);
  }
  h3() {
    this.u84_1.h3();
  }
  x84(key, value) {
    return this.u84_1.e3(key, value);
  }
  e3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.x84(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  hy(key) {
    return this.u84_1.f3(key);
  }
  f3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.hy((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  p1() {
    return this.u84_1.p1();
  }
  d3() {
    return this.u84_1.d3();
  }
  i3() {
    return this.u84_1.i3();
  }
  jy(key) {
    return this.u84_1.a3(key);
  }
  a3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.jy((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  bi(key) {
    return this.u84_1.c3(key);
  }
  c3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.bi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  g1() {
    return this.u84_1.g1();
  }
  e1() {
    return this.u84_1.e1();
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.y84_1 = closeable;
  }
  z84() {
    var tmp0_safe_receiver = this.y84_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c6();
    }
    this.y84_1 = null;
  }
  c2q() {
    this.y84_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.a85_1 = Pool.j2p(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.b85_1 = FastIdentityMap();
    this.c85_1 = fastArrayListOf([]);
    this.d85_1 = 0;
    this.e85_1 = 60;
  }
  f85(closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.b85_1;
      var res = get_0(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.a85_1.m2p();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.y84_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  }
  g85() {
    this.d85_1 = this.d85_1 + 1 | 0;
    if (this.d85_1 >= this.e85_1) {
      this.d85_1 = 0;
      this.h85();
    }
  }
  h85() {
    var _iterator__ex2g4s = this.c85_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var entry = _iterator__ex2g4s.c1();
      if (!contains_1(this.b85_1, entry.y84_1)) {
        var tmp0_safe_receiver = entry.y84_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.c6();
        }
        this.a85_1.n2p(entry);
      }
    }
    this.c85_1.h3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.b85_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.c85_1.h(it_0);
    }
    clear(this.b85_1);
  }
  c6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.c85_1.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].z84();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.b85_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).z84();
    }
    this.c85_1.h3();
    this.a85_1.h3();
    clear(this.b85_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.i85_1 = 0;
    this.j85_1 = TextureBase.o85(null, 0, 0);
    this.k85_1 = FastIdentityMap();
  }
  c2q() {
    this.i85_1 = 0;
    this.j85_1.l85_1 = null;
    this.j85_1.n85_1 = -1;
    this.j85_1.p85(0);
    this.j85_1.q85(0);
    clear(this.k85_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.j85_1.toString() + ', usedMemory=' + this.i85_1 + ', slices=' + get_size(this.k85_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.r85_1 = ag;
    this.s85_1 = new Long(0, 0);
    this.t85_1 = FastSmallSet.s2m();
    this.u85_1 = FastSmallSet.s2m();
    this.v85_1 = FastArrayList.ny();
    this.w85_1 = 60;
    this.x85_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.y85_1 = Pool.j2p(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.z85_1 = FastIdentityMap();
    this.a86_1 = null;
    this.b86_1 = null;
    this.c86_1 = null;
    this.d86_1 = null;
    this.e86_1 = null;
    this.f86_1 = null;
    this.g86_1 = null;
    this.h86_1 = null;
    this.i86_1 = 0;
  }
  k86() {
    return this.t85_1.e1();
  }
  l86() {
    return this.u85_1.e1();
  }
  m86() {
    return this.v85_1.e1();
  }
  toString() {
    return this.n86();
  }
  n86() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.k86() + ', numReferencedBitmapsSinceGC=' + this.l86() + ', numReferencedBitmaps=' + this.m86() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().j14(this.s85_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().j14(this.x85_1)) + ')';
  }
  o86(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).j85_1);
  }
  p86(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  q86(slice) {
    return _getTexture(this, slice);
  }
  r86() {
    clearFastCacheAccess(this);
    this.i86_1 = this.i86_1 + 1 | 0;
    if (this.i86_1 >= this.w85_1) {
      this.i86_1 = 0;
      this.h85();
    }
  }
  h85() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.v85_1.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.u85_1.wk(bmp))
        if (this.s85_1.w1(this.x85_1) < 0 || this.x85_1.w1(new Long(0, 0)) < 0) {
          this.s86(bmp, 'GC');
        } else
          this.t85_1.t2m(bmp);
    }
    this.v85_1.h3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.u85_1.o2m_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.v85_1.h(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.t85_1.o2m_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.v85_1.h(element_0);
    }
    this.u85_1.h3();
  }
  s86(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.z85_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.x85_1;
    var other = info.i85_1;
    tmp_0.x85_1 = this_0.x1(toLong(other));
    this.u85_1.u2m(bmp);
    if (this.b86_1 === info || this.d86_1 === info) {
      clearFastCacheAccess(this);
    }
    info.j85_1.c6();
    this.y85_1.n2p(info);
    this.t85_1.u2m(bmp);
  }
  c6() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.z85_1)).a1();
    while (_iterator__ex2g4s.b1()) {
      var bmp = _iterator__ex2g4s.c1();
      this.s86(bmp, 'close');
    }
    clear(this.z85_1);
    this.v85_1.h3();
    this.u85_1.h3();
    this.t85_1.h3();
    this.y85_1.h3();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.t86_1 = ag;
    this.u86_1 = FastIdentityMap();
    this.v86_1 = FastSmallSet.s2m();
    var tmp = this;
    tmp.w86_1 = Pool.k2p(VOID, AgBufferManager$bufferPool$lambda);
    this.x86_1 = 0;
    this.y86_1 = 60;
    this.z86_1 = Buffer.e12(0);
  }
  a87(cached) {
    this.v86_1.t2m(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.u86_1;
      var res = get_0(this_0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.w86_1.m2p();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      this_1.j6j(cached.b87_1);
      var out = this_1;
      set(this_0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  g85() {
    removeCache(this);
    this.x86_1 = this.x86_1 + 1 | 0;
    if (this.x86_1 >= this.y86_1) {
      this.x86_1 = 0;
      this.h85();
    }
  }
  h85() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.v86_1.o2m_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.c87(element);
    }
    this.v86_1.h3();
  }
  d87(buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.e1()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = buffer.d1(_unary__edvuaz);
      this.c87(it);
    }
  }
  c87(buffer) {
    var buf = getAndRemove(this.u86_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.j6j(this.z86_1);
      this.w86_1.n2p(buf);
    }
  }
}
class AgCachedBuffer {
  constructor(data) {
    this.b87_1 = data;
  }
}
class BatchBuffers {
  constructor() {
    this.o87_1 = new AGBuffer();
    this.p87_1 = new AGBuffer();
    this.q87_1 = new AGBuffer();
    this.r87_1 = AGVertexArrayObject.y6o([new AGVertexData(Companion_getInstance_71().l87_1, this.o87_1), new AGVertexData(Companion_getInstance_71().m87_1, this.p87_1)], false);
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_64 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.k7l('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.e87_1 = tmp_2;
    this.f87_1 = 16383;
    this.g87_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_4;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.k2t(level, tmp$ret$2);
      tmp_4 = Unit_instance;
    }
    this.h87_1 = Attribute.y6v('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_5;
    if (this_1.j2t(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.k2t(level_0, tmp$ret$4);
      tmp_5 = Unit_instance;
    }
    this.i87_1 = Varying.k6w('v_Col2', VarType_Float4_getInstance());
    this.j87_1 = Attribute.y6v('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.k87_1 = Varying.k6w('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_2.j2t(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.k2t(level_1, tmp$ret$6);
      tmp_6 = Unit_instance;
    }
    this.l87_1 = ProgramLayout.h6p([DefaultShaders_getInstance().r6s_1, DefaultShaders_getInstance().s6s_1, this.s87(), this.h87_1]);
    this.m87_1 = ProgramLayout.h6p([this.j87_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.j2t(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.k2t(level_2, tmp$ret$8);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.e6x(this_4.a6x(), this_4.b6x());
    this_4.e6x(Companion_getInstance_71().k87_1, Companion_getInstance_71().j87_1);
    this_4.e6x(Companion_getInstance_71().t87(), this_4.l6x([this_4.i6x(this_4.n6x(Companion_getInstance_71().s87(), 'rgb'), this_4.n6x(Companion_getInstance_71().s87(), 'a')), this_4.n6x(Companion_getInstance_71().s87(), 'a')]));
    this_4.e6x(Companion_getInstance_71().i87_1, Companion_getInstance_71().h87_1);
    this_4.e6x(this_4.h6x(), this_4.i6x(this_4.i6x(this_4.r6u(), this_4.s6u()), this_4.l6x([this_4.j6x(), this_4.k6x(0.0), this_4.k6x(1.0)])));
    var tmp_9 = VertexShader(this_4.m6x());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = ProgramBuilderDefault.z6w();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_71().u87(this_5);
    this_5.e6x(this_5.h6x(), this_5.i6x(this_5.h6x(), Companion_getInstance_71().t87()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.n6z(this_5.n6x(this_5.h6x(), 'a'), this_5.k6x(0.0));
    var body = this_5.v6x();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.o6y();
    var stmIf = new If(cond, body.x6x());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.d6x_1.h(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.m6x());
    tmp_8.n87_1 = new Program(tmp_9, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_6.j2t(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.k2t(level_3, tmp$ret$15);
      tmp_10 = Unit_instance;
    }
  }
  s87() {
    return DefaultShaders_getInstance().t6s_1;
  }
  t87() {
    return DefaultShaders_getInstance().v6s_1;
  }
  u87(builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_71().k87_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.m6y(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_71();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_71().g87_1 : reqMaxQuads;
    this.k81_1 = ctx;
    this.l81_1 = reqMaxQuads;
    this.m81_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.l81_1;
    var b = Companion_getInstance_71().f87_1;
    tmp.n81_1 = Math.min(a, b);
    this.o81_1 = this.k81_1.w80_1;
    this.p81_1 = this.k81_1.d80_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.k2t(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.k81_1.y80_1.x1v(BatchBuilder2D$lambda(this));
    this.q81_1 = imul(this.n81_1, 4);
    this.r81_1 = imul(this.n81_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.j2t(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.k2t(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.s81_1 = Buffer.e12(imul(24, this.q81_1));
    this.t81_1 = new Int8Array(this.q81_1);
    this.u81_1 = Buffer.e12(imul(2, this.r81_1));
    this.v81_1 = get_u16(this.u81_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.j2t(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.k2t(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.w81_1 = 0;
    this.x81_1 = 0;
    this.y81_1 = 0;
    this.z81_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.m81_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.a82_1 = tmp_6;
    this.b82_1 = false;
    this.c82_1 = Companion_getInstance_68().i7z_1;
    this.d82_1 = Companion_getInstance_71().n87_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.j2t(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.k2t(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.e82_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.j2t(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.k2t(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.f82_1 = Companion_getInstance_46().y6g_1;
    this.g82_1 = Companion_getInstance_47().a6h_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.j2t(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.k2t(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.h82_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.j2t(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.k2t(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.i82_1 = Companion_getInstance_44().m6h_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.j2t(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.k2t(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.j2t(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.k2t(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.j82_1 = new Signal();
    this.k82_1 = new Signal();
    this.l82_1 = fastArrayListOf([]);
    this.m82_1 = 0;
    this.n82_1 = 0;
    this.o82_1 = 0;
  }
  x87() {
    return this.k81_1.r80_1;
  }
  y87(value) {
    this.w81_1 = value;
  }
  z87() {
    return this.w81_1;
  }
  a88() {
    var inductionVariable = 0;
    var last = this.m81_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.a82_1[n] = null;
      }
       while (inductionVariable < last);
    this.z81_1 = 0;
  }
  g85() {
    this.e82_1.c2q();
  }
  b88() {
    return this.i82_1;
  }
  c88(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.t81_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  d88(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.e88(6, 4);
    this.f88();
    var vp = this.x81_1;
    var vd = this.s81_1;
    vp = vp + this.c88(vd, vp, x0, y0, tex.m3h(), tex.n3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.c88(vd, vp, x1, y1, tex.o3h(), tex.p3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.c88(vd, vp, x2, y2, tex.q3h(), tex.r3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.c88(vd, vp, x3, y3, tex.s3h(), tex.t3h(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.x81_1 = vp;
    this.y87(this.z87() + 4 | 0);
  }
  g88(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.z81_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.d88(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.d88.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  h88(vc) {
    this.y81_1 = this.y81_1 + _addIndices(this, this.v81_1, this.y81_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  f88(vc, $super) {
    vc = vc === VOID ? this.z87() : vc;
    var tmp;
    if ($super === VOID) {
      this.h88(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.h88.call(this, vc);
    }
    return tmp;
  }
  i88(array, matrix, vcount, icount, texIndex) {
    this.e88(icount, vcount);
    var i16 = this.v81_1;
    var ip = this.y81_1;
    var vc = this.z87();
    var arrayIndices = array.j88_1;
    // Inline function 'kotlin.math.min' call
    var b = array.m88_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.x81_1;
    var src = get_i32(array.n88_1);
    var dst = get_i32(this.s81_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.x81_1 / 6 | 0;
    arrayfill(this.t81_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.u25()) {
      applyMatrix(this, matrix, this.x81_1, vcount);
    }
    this.w81_1 = this.w81_1 + vcount | 0;
    this.x81_1 = this.x81_1 + imul(vcount, 6) | 0;
    this.y81_1 = this.y81_1 + icount_0 | 0;
  }
  q88(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.l88_1 : vcount;
    icount = icount === VOID ? array.m88_1 : icount;
    texIndex = texIndex === VOID ? this.z81_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.i88(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.i88.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  e88(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.r88();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.w4(toString(message));
    }
    return doFlush;
  }
  s88(tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.l85_1;
      this.e88(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_71().n87_1 : program;
      if (this.t88(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.v87();
      if (!contains_0(this.a82_1, tex_0)) {
        this.z81_1 = 0;
        this.a82_1[0] = tex_0;
      }
      this.b82_1 = smoothing;
      this.c82_1 = blendMode;
      this.d82_1 = pprogram;
    }
  }
  u88(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a82_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  t88(tex, smoothing, blendMode, program) {
    var hasTex = this.u88(tex);
    if (!(this.a82_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.a82_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.a82_1[n] === null) {
            this.a82_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.a82_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.a82_1[n_0]) {
          this.z81_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.b82_1 === smoothing && this.c82_1 === blendMode && this.d82_1 === program;
  }
  v88(tex, smoothing, blendMode, program, icount, vcount) {
    this.s88(this.o81_1.o86(tex), smoothing, blendMode, program, icount, vcount);
  }
  w88(tex, smoothing, blendMode, program, icount, vcount) {
    this.s88(this.o81_1.p86(tex).s3f_1, smoothing, blendMode, program, icount, vcount);
  }
  x88(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.y88(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  r82(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.m2i() : width;
    height = height === VOID ? tex.n2i() : height;
    m = m === VOID ? Companion_getInstance_7().x28_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().s3y_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_68().i7z_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.x88(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.x88.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  y88(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.s88(tex.b3h(), filtering, blendMode, program, 6, 4);
    this.z88(x, y, width, height, m, tex, colorMul);
  }
  z88(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.g88(m.q29(x0, y0), m.r29(x0, y0), m.q29(x1, y0), m.r29(x1, y0), m.q29(x1, y1), m.r29(x1, y1), m.q29(x0, y1), m.r29(x0, y1), tex, colorMul);
  }
  a89() {
    this.e82_1.b2q_1.q87_1.i6j(this.u81_1, 0, imul(this.y81_1, 2));
  }
  b89() {
    this.k81_1.b89();
    var inductionVariable = 0;
    var last = this.m81_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_40().r6m(VOID, this.b82_1);
        this.k81_1.m80_1.q6j(Companion_getInstance_71().e87_1[n], this.a82_1[n], info);
      }
       while (inductionVariable < last);
  }
  v87() {
    if (this.m82_1 === this.y81_1)
      return Unit_instance;
    this.b89();
    this.n82_1 = this.n82_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.l82_1;
    var tmp0_frameBuffer = this.k81_1.g81_1.m6f_1;
    var tmp1_frameBufferInfo = this.k81_1.g81_1.s6h();
    var tmp2_vertexData = this.e82_1.b2q_1.r87_1;
    var tmp3_indices = this.e82_1.b2q_1.q87_1;
    var tmp4_program = this.d82_1;
    var tmp5_drawType = Companion_getInstance_41().p6p_1;
    var tmp6_blending = this.c82_1.s82_1;
    var tmp7_uniformBlocks = this.k81_1.c89(this.d82_1, false);
    var tmp8_textureUnits = this.k81_1.m80_1.sx();
    var tmp9_stencilOpFunc = this.g82_1;
    var tmp10_stencilRef = this.f82_1;
    var tmp11_colorMask = this.h82_1;
    var tmp12_scissor = this.i82_1;
    var tmp13_drawOffset = imul(this.m82_1, 2);
    var tmp14_vertexCount = this.y81_1 - this.m82_1 | 0;
    var element = new AGBatch(tmp0_frameBuffer, tmp1_frameBufferInfo, tmp2_vertexData, tmp3_indices, VOID, tmp4_program, tmp7_uniformBlocks, tmp8_textureUnits, tmp6_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp12_scissor, VOID, tmp5_drawType, tmp13_drawOffset, tmp14_vertexCount);
    this_0.h(element);
    this.m82_1 = this.y81_1;
  }
  d89(uploadVertices, uploadIndices) {
    this.e89(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.m81_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.a82_1[n] = null;
      }
       while (inductionVariable < last);
    this.z81_1 = 0;
  }
  w87(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.d89(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.d89.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  e89(uploadVertices, uploadIndices) {
    this.v87();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.l82_1.g1()) {
      if (uploadVertices) {
        this.e82_1.b2q_1.o87_1.i6j(this.s81_1, 0, imul(this.x81_1, 4));
        this.e82_1.b2q_1.p87_1.f6j(this.t81_1, 0, this.x81_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.a89();
      }
      this.k81_1.f89();
      draw_0(this.p81_1, new AGMultiBatch(toList(this.l82_1)));
      this.l82_1.h3();
      this.j82_1.z1v(this);
      this.o82_1 = this.o82_1 + 1 | 0;
      this.k81_1.g89();
      this.e82_1.c1();
    }
    this.y87(0);
    this.x81_1 = 0;
    this.m82_1 = 0;
    this.y81_1 = 0;
  }
  r88(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.e89(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.e89.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  h89(vertexCount) {
    var oldVertexCount = this.z87();
    this.y87(vertexCount);
    try {
      this.j82_1.z1v(this);
    }finally {
      this.y87(oldVertexCount);
    }
  }
}
class BoundsProvider {}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.q89()).i2b();
}
function get_globalToWindowScaleAvg() {
  return this.u89().i2b();
}
function windowToGlobalCoords(pos) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = this.o89();
    if (this_0.t25()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.n27(this_0.p29(pos.e25_1, pos.f25_1), this_0.s29(pos.e25_1, pos.f25_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.i89_1 = Companion_getInstance_7().a29();
    this.j89_1 = MatrixTransform.g2b();
    this.k89_1 = Companion_getInstance_7().a29();
    this.l89_1 = MatrixTransform.g2b();
    this.m89_1 = Companion_getInstance_5().u2d(0, 0, 1280, 720);
  }
  n89(_set____db54di) {
    this.i89_1 = _set____db54di;
  }
  o89() {
    return this.i89_1;
  }
  p89(_set____db54di) {
    this.j89_1 = _set____db54di;
  }
  q89() {
    return this.j89_1;
  }
  r89(_set____db54di) {
    this.k89_1 = _set____db54di;
  }
  s89() {
    return this.k89_1;
  }
  t89(_set____db54di) {
    this.l89_1 = _set____db54di;
  }
  u89() {
    return this.l89_1;
  }
  v89(_set____db54di) {
    this.m89_1 = _set____db54di;
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    this.z89_1 = ProgramLayout.h6p([DefaultShaders_getInstance().r6s_1, DefaultShaders_getInstance().t6s_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.e6x(builder.h6x(), builder.i6x(builder.i6x(this_0.r6u(), this_0.s6u()), builder.l6x([this_0.r6s_1, builder.k6x(0.0), builder.k6x(1.0)])));
    builder.e6x(this_0.v6s_1, this_0.t6s_1);
    tmp.a8a_1 = VertexShader(builder.m6x());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.z6w();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.e6x(builder_0.h6x(), this_1.v6s_1);
    tmp_0.b8a_1 = FragmentShader(builder_0.m6x());
    this.c8a_1 = new Program(this.a8a_1, this.b8a_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_72();
    this.d8a_1 = ctx;
    this.e8a_1 = new Signal();
    this.d8a_1.y80_1.x1v(LineRenderBatcher$lambda(this));
    this.f8a_1 = this.d8a_1.d80_1;
    this.g8a_1 = Colors_getInstance().i44_1;
    this.h8a_1 = new AGBuffer();
    this.i8a_1 = AGVertexArrayObject.y6o([new AGVertexData(Companion_getInstance_72().z89_1, this.h8a_1)], false);
    this.j8a_1 = 1024;
    this.k8a_1 = allocDirect(Companion_instance_4, imul(24, this.j8a_1));
    this.l8a_1 = Matrix4.f2c();
    this.m8a_1 = 0;
    this.n8a_1 = 0;
    this.o8a_1 = Companion_getInstance_68().i7z_1;
    this.p8a_1 = Companion_getInstance_7().a29();
  }
  q8a(p0, p1, color0, color1, m) {
    return this.r8a(p0.e25_1, p0.f25_1, p1.e25_1, p1.f25_1, this.g8a_1, color1, m);
  }
  s8a(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.g8a_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.p8a_1 : m;
    var tmp;
    if ($super === VOID) {
      this.q8a(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.q8a.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  t8a(x0, y0, x1, y1, color0, color1, m) {
    if (this.m8a_1 >= (this.j8a_1 - 2 | 0)) {
      this.lc();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  u8a(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.g8a_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.p8a_1 : m;
    var tmp;
    if ($super === VOID) {
      this.t8a(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.t8a.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  r8a(x0, y0, x1, y1, color0, color1, m) {
    return this.t8a(x0, y0, x1, y1, color0, color1, m);
  }
  v8a(path, m) {
    var lastPos = {_v: Vector2D.y27()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.y27();
    var l = Vector2D.y27();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.x3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.qx(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.n27(tmp, path.y3d_1.d1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!true) {
            this.s8a(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.n27(tmp_0, path.y3d_1.d1(_unary__edvuaz_3));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!false) {
            this.s8a(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.n27(tmp_1, path.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.n27(tmp_2, path.y3d_1.d1(_unary__edvuaz_7));
          var sum = Companion_getInstance_4().q2g(l, c) + Companion_getInstance_4().q2g(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.y27()};
          var prevPos = {_v: Vector2D.y27()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_10().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_13().u3b(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_13().u3b(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.s8a(lastPos._v, it_1, VOID, VOID, m);
              }
              lastPos._v = it_1;
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos_0._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.n27(tmp_3, path.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.n27(tmp_4, path.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.n27(tmp_5, path.y3d_1.d1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_4().q2g(l, c0) + Companion_getInstance_4().q2g(c0, c1) + Companion_getInstance_4().q2g(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.y27()};
          var prevPos_0 = {_v: Vector2D.y27()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_10().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_13().t3b(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_13().t3b(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.s8a(lastPos._v, it_2, VOID, VOID, m);
              }
              lastPos._v = it_2;
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_1._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          var p = i;
          if (!false) {
            this.s8a(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  }
  lc() {
    if (this.m8a_1 > 0) {
      this.e8a_1.z1v(this);
      this.h8a_1.i6j(this.k8a_1, 0, imul(this.n8a_1, 4));
      this.d8a_1.b89();
      var tmp0_$receiver = this.f8a_1;
      var tmp1_frameBuffer = this.d8a_1.g81_1;
      var tmp2_vertexData = this.i8a_1;
      var tmp3_program = Companion_getInstance_72().c8a_1;
      var tmp4_drawType = Companion_getInstance_41().o6p_1;
      var tmp5_vertexCount = this.m8a_1;
      var tmp6_uniformBlocks = this.d8a_1.w8a(Companion_getInstance_72().c8a_1);
      var tmp7_blending = this.o8a_1.s82_1;
      draw(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.m8a_1 = 0;
    this.n8a_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.p8b();
}
function get_pixelsPerLogicalInchRatio() {
  return this.q8b() / 96.0;
}
function get_computedPixelRatio() {
  return this.p8b() * this.r8b();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_71().g87_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.c80_1 = new Mixin();
    this.d80_1 = ag;
    this.e80_1 = bp;
    this.f80_1 = deviceDimensionsProvider;
    this.g80_1 = stats;
    this.h80_1 = coroutineContext;
    this.i80_1 = batchMaxQuads;
    this.j80_1 = windowConfig;
    this.k80_1 = new BufferCache();
    this.l80_1 = FastIdentityMap();
    this.m80_1 = AGTextureUnits.n6j();
    this.n80_1 = Companion_getInstance_7().a29();
    this.o80_1 = Companion_getInstance_7().a29();
    this.p80_1 = Matrix4.f2c();
    this.q80_1 = Matrix4.f2c();
    this.r80_1 = Companion_getInstance_7().a29();
    this.s80_1 = true;
    var tmp_0 = this;
    tmp_0.t80_1 = Pool.k2p(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.u80_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.v80_1 = new AgAutoFreeManager();
    this.w80_1 = new AgBitmapTextureManager(this.d80_1);
    this.x80_1 = new AgBufferManager(this.d80_1);
    this.y80_1 = new Signal();
    this.z80_1 = 1.0;
    this.a81_1 = Colors_getInstance().s3y_1;
    this.b81_1 = new BatchBuilder2D(this, this.i80_1);
    var tmp_2 = this;
    tmp_2.c81_1 = Pool.k2p(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.d81_1 = new RenderContext2D(this.b81_1, this.w80_1);
    this.e81_1 = true;
    this.f81_1 = null;
    this.g81_1 = this.d80_1.a6g();
    this.h81_1 = LinkedHashSet.j1();
    var tmp_3 = this;
    tmp_3.i81_1 = Pool.k2p(VOID, RenderContext$frameBuffers$lambda);
    this.j81_1 = FastArrayList.ny();
  }
  x8a() {
    return this.j80_1.x8a();
  }
  g89() {
  }
  y8a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u80_1;
    projViewMatUB$factory();
    return this_0.r1();
  }
  b89() {
    if (this.s80_1 && this.g81_1.k6k()) {
      this.p80_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().y2d(0, this.g81_1.u6f_1, this.g81_1.t6f_1, 0), -1.0, 1.0);
    } else {
      this.p80_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().y2d(0, 0, this.g81_1.t6f_1, this.g81_1.u6f_1), -1.0, 1.0);
      this.p80_1 = this.p80_1.c2d(toMatrix4(this.n80_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.y8a();
      var _unary__edvuaz = this_0.t6o();
      this_0.u7b(_unary__edvuaz + 1 | 0);
      this_0.v7b(this_0.t6o() + 1 | 0);
      var blockSize = this_0.x6m_1;
      var index0 = imul(this_0.t6o() - 1 | 0, blockSize);
      var index1 = imul(this_0.t6o(), blockSize);
      var texBlockSize = this_0.u6m_1.t6u().e1();
      var texIndex0 = imul(this_0.t6o() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.t6o(), texBlockSize);
      if (this_0.t6o() > 0) {
        arraycopy_0(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.z6m_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.u6m_1;
      var it = this_0.a6n_1;
      it.j7c($this$push.r6u(), this.p80_1);
      it.j7c($this$push.s6u(), this.q80_1);
      if (true && this_0.t6o() >= 1) {
        var equals = arrayequal(this_0.z6m_1, index0, this_0.z6m_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.t6o();
          this_0.u7b(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  z8a() {
    return coerceAtLeast_0(round(this.a8b() * this.z80_1), 1.0);
  }
  b8b(kind) {
    this.y80_1.z1v(kind);
  }
  p82(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.b8b(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.b8b.call(this, kind);
    }
    return tmp;
  }
  c8b() {
    var tmp0_elvis_lhs = this.g81_1;
    return tmp0_elvis_lhs == null ? this.a6g() : tmp0_elvis_lhs;
  }
  d8b() {
    return this.c8b() === this.a6g();
  }
  a6g() {
    return this.d80_1.a6g();
  }
  e8b(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.d80_1.f6g(this.g81_1.m6f_1, this.g81_1.s6h(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  f8b(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().x3y_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_44().m6h_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.e8b(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.e8b.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  c6g() {
    this.d80_1.c6g();
    this.i81_1.o2p(this.h81_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.h81_1.g1()) {
      this.h81_1.h3();
    }
  }
  q82(bmp) {
    return this.w80_1.p86(bmp);
  }
  g8b(bmp) {
    return this.w80_1.q86(bmp);
  }
  a87(buffer) {
    return this.x80_1.a87(buffer);
  }
  h8b(closeable) {
    return this.v80_1.f85(closeable);
  }
  i8b() {
    this.b81_1.a88();
  }
  r86() {
    this.p82();
    this.c6g();
    this.b81_1.g85();
    this.v80_1.g85();
    this.w80_1.r86();
    this.x80_1.g85();
  }
  c6() {
    this.w80_1.c6();
    this.v80_1.c6();
  }
  j8b(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.i81_1.m2p();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.h81_1.h(rb);
    }
    rb.w6k(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.n6l(hasDepth, hasStencil);
    rb.m6l(msamples);
    return rb;
  }
  k8b(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.j8b(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.j8b.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  l8b(rb) {
    this.h81_1.j3(rb);
    this.i81_1.n2p(rb);
  }
  m8b(frameBuffer) {
    this.j81_1.h(this.g81_1);
    this.g81_1 = frameBuffer;
  }
  n8b() {
    this.g81_1 = this.j81_1.l3(this.j81_1.e1() - 1 | 0);
  }
  e6n(uniformBlock) {
    return this.k80_1.e6n(uniformBlock);
  }
  o8b(program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.l80_1;
      var res = get_0(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.k80_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  c89(program, autoUpload) {
    if (autoUpload) {
      this.f89();
    }
    return this.o8b(program).s6o();
  }
  w8a(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.c89(program, autoUpload) : $super.c89.call(this, program, autoUpload);
  }
  f89() {
    this.k80_1.c6n();
  }
  vx(value) {
    this.c80_1.vx(value);
  }
  wx() {
    return this.c80_1.wx();
  }
  n89(_set____db54di) {
    this.e80_1.n89(_set____db54di);
  }
  o89() {
    return this.e80_1.o89();
  }
  p89(_set____db54di) {
    this.e80_1.p89(_set____db54di);
  }
  q89() {
    return this.e80_1.q89();
  }
  r89(_set____db54di) {
    this.e80_1.r89(_set____db54di);
  }
  s89() {
    return this.e80_1.s89();
  }
  t89(_set____db54di) {
    this.e80_1.t89(_set____db54di);
  }
  u89() {
    return this.e80_1.u89();
  }
  v89(_set____db54di) {
    this.e80_1.v89(_set____db54di);
  }
  w89() {
    return this.e80_1.w89();
  }
  x89() {
    return this.e80_1.x89();
  }
  y89(pos) {
    return this.e80_1.y89(pos);
  }
  h6g() {
    return this.d80_1.h6g();
  }
  i6g() {
    return this.d80_1.i6g();
  }
  j6g() {
    return this.d80_1.j6g();
  }
  p8b() {
    return this.f80_1.p8b();
  }
  q8b() {
    return this.f80_1.q8b();
  }
  r8b() {
    return this.f80_1.r8b();
  }
  a8b() {
    return this.f80_1.a8b();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.s8b_1 = new Mixin();
    this.t8b_1 = batch;
    this.u8b_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.v8b_1 = Size2D.l26(0, 0);
    var tmp_0 = this;
    tmp_0.w8b_1 = Pool.k2p(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.j2t(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.k2t(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.x8b_1 = Companion_getInstance_7().x28_1;
    this.y8b_1 = Companion_getInstance_68().i7z_1;
    this.z8b_1 = Colors_getInstance().s3y_1;
    this.a8c_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.j2t(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.k2t(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  a62() {
    return this.t8b_1.k81_1;
  }
  b8c(matrix) {
    this.x8b_1 = matrix;
  }
  c8c(rect, color, filtering, bmp, program) {
    var tmp0_$this = this.t8b_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.getTexture' call
    var tmp1_tex = this.u8b_1.p86(bmp);
    var tmp2_x = rect.o25_1;
    var tmp3_y = rect.p25_1;
    var tmp4_width = rect.q25_1;
    var tmp5_height = rect.r25_1;
    var tmp6_m = this.x8b_1;
    var tmp7_blendMode = this.y8b_1;
    tmp0_$this.x88(tmp1_tex, tmp2_x, tmp3_y, tmp4_width, tmp5_height, tmp6_m, filtering, color, tmp7_blendMode, program);
  }
  d8c(rect, color, filtering, bmp, program, $super) {
    color = color === VOID ? this.z8b_1 : color;
    filtering = filtering === VOID ? this.a8c_1 : filtering;
    var tmp;
    if (bmp === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      tmp = get_Bitmaps_white();
    } else {
      tmp = bmp;
    }
    bmp = tmp;
    program = program === VOID ? null : program;
    var tmp_0;
    if ($super === VOID) {
      this.c8c(rect, color, filtering, bmp, program);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.c8c.call(this, rect, new RGBA(color), filtering, bmp, program);
    }
    return tmp_0;
  }
  e8c(x, y, width, height, program, padding) {
    var ctx = this.t8b_1.k81_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.b81_1;
    var this_1 = this_0.k81_1;
    if (!(this_1.f81_1 === this_0)) {
      this_1.f81_1 = this_0;
      this_1.p82();
    }
    var L = x - padding.j28_1;
    var T = y - padding.g28_1;
    var R = width + padding.n28();
    var B = height + padding.o28();
    var l = -padding.j28_1;
    var t = -padding.g28_1;
    var r = width + padding.h28_1;
    var b = height + padding.i28_1;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_73();
    var tmp$ret$0 = get_TEXTURED_ARRAY_QUAD_INDICES();
    var vertices = new TexturedVertexArray(6, tmp$ret$0);
    vertices.f8c(0, L, T, R, B, this.x8b_1, l, t, r, t, l, b, r, b, this.z8b_1);
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    var tmp$ret$1 = get_Bitmaps_white();
    this_0.w88(tmp$ret$1, this.a8c_1, this.y8b_1, program, 6, 4);
    this_0.q88(vertices, Companion_getInstance_7().y28_1);
    ctx.b8b(FlushKind_STATE_getInstance());
  }
  g8c(scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.x8b_1;
      var p = Vector2D.a28(scissor.v25(), scissor.x25());
      if (this_0.t25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.n27(this_0.p29(p.e25_1, p.f25_1), this_0.s29(p.e25_1, p.f25_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.x8b_1;
      var p_0 = Vector2D.a28(scissor.w25(), scissor.y25());
      if (this_1.t25()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.n27(this_1.p29(p_0.e25_1, p_0.f25_1), this_1.s29(p_0.e25_1, p_0.f25_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_44().t6q(tl.e25_1, tl.f25_1, br.e25_1, br.f25_1);
  }
  vx(value) {
    this.s8b_1.vx(value);
  }
  wx() {
    return this.s8b_1.wx();
  }
}
class SDFShaders extends Builder {
  static z8c() {
    SDFShaders_instance = null;
    var $this = this.u6x();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.s6y();
    var tmp_1 = $this.s6y();
    var tmp_2 = $this.s6y();
    var tmp_3 = $this.s6y();
    tmp.j8c_1 = $this.f6y(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).h6v($this, opInterpolate$factory());
    var tmp_4 = $this;
    var tmp_5 = $this.s6y();
    var tmp_6 = $this.s6y();
    var tmp_7 = $this.s6y();
    tmp_4.k8c_1 = $this.d6y(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).h6v($this, opUnion$factory());
    var tmp_8 = $this;
    var tmp_9 = $this.s6y();
    var tmp_10 = $this.s6y();
    var tmp_11 = $this.s6y();
    tmp_8.l8c_1 = $this.d6y(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).h6v($this, opIntersect$factory());
    var tmp_12 = $this;
    var tmp_13 = $this.s6y();
    var tmp_14 = $this.s6y();
    var tmp_15 = $this.s6y();
    tmp_12.m8c_1 = $this.d6y(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).h6v($this, opSubtract$factory());
    var tmp_16 = $this;
    var tmp_17 = $this.s6y();
    var tmp_18 = $this.s6y();
    var tmp_19 = $this.s6y();
    tmp_16.n8c_1 = $this.d6y(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).h6v($this, opRound$factory());
    var tmp_20 = $this;
    var tmp_21 = $this.s6y();
    var tmp_22 = $this.s6y();
    var tmp_23 = $this.s6y();
    tmp_20.o8c_1 = $this.d6y(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).h6v($this, opBorder$factory());
    var tmp_24 = $this;
    var tmp_25 = $this.s6y();
    var tmp_26 = $this.s6y();
    var tmp_27 = $this.s6y();
    tmp_24.p8c_1 = $this.d6y(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).h6v($this, opBorderInner$factory());
    var tmp_28 = $this;
    var tmp_29 = $this.s6y();
    var tmp_30 = $this.s6y();
    tmp_28.q8c_1 = $this.b6y(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).h6v($this, opAA$factory());
    var tmp_31 = $this;
    var tmp_32 = $this.s6y();
    var tmp_33 = $this.s6y();
    tmp_31.r8c_1 = $this.b6y(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).h6v($this, opAARev$factory());
    var tmp_34 = $this;
    var tmp_35 = $this.s6y();
    var tmp_36 = $this.s6y();
    var tmp_37 = $this.s6y();
    var tmp_38 = $this.s6y();
    tmp_34.s8c_1 = $this.f6y(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).h6v($this, opSmoothUnion$factory());
    var tmp_39 = $this;
    var tmp_40 = $this.s6y();
    var tmp_41 = $this.s6y();
    var tmp_42 = $this.s6y();
    var tmp_43 = $this.s6y();
    tmp_39.t8c_1 = $this.f6y(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).h6v($this, opSmoothSubtraction$factory());
    var tmp_44 = $this;
    var tmp_45 = $this.s6y();
    var tmp_46 = $this.s6y();
    var tmp_47 = $this.s6y();
    var tmp_48 = $this.s6y();
    tmp_44.u8c_1 = $this.f6y(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).h6v($this, opSmoothIntersection$factory());
    var tmp_49 = $this;
    var tmp_50 = $this.s7k();
    var tmp_51 = $this.s6y();
    var tmp_52 = $this.s6y();
    tmp_49.v8c_1 = $this.d6y(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).h6v($this, circle$factory());
    var tmp_53 = $this;
    var tmp_54 = $this.s7k();
    var tmp_55 = $this.s7k();
    var tmp_56 = $this.t7k();
    var tmp_57 = $this.s6y();
    tmp_53.w8c_1 = $this.f6y(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).h6v($this, roundedBox$factory());
    var tmp_58 = $this;
    var tmp_59 = $this.s7k();
    var tmp_60 = $this.s7k();
    var tmp_61 = $this.s6y();
    tmp_58.x8c_1 = $this.d6y(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).h6v($this, box$factory());
    var tmp_62 = $this;
    var tmp_63 = $this.t7k();
    var tmp_64 = $this.t7k();
    var tmp_65 = $this.t7k();
    tmp_62.y8c_1 = $this.d6y(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).h6v($this, opCombinePremultipliedColors$factory());
    return $this;
  }
  a8d() {
    return this.j8c_1.ko(this, opInterpolate$factory_0());
  }
  b8d() {
    return this.k8c_1.ko(this, opUnion$factory_0());
  }
  c8d() {
    return this.l8c_1.ko(this, opIntersect$factory_0());
  }
  d8d() {
    return this.m8c_1.ko(this, opSubtract$factory_0());
  }
  e8d() {
    return this.n8c_1.ko(this, opRound$factory_0());
  }
  f8d() {
    return this.o8c_1.ko(this, opBorder$factory_0());
  }
  g8d() {
    return this.p8c_1.ko(this, opBorderInner$factory_0());
  }
  h8d() {
    return this.q8c_1.ko(this, opAA$factory_0());
  }
  i8d() {
    return this.r8c_1.ko(this, opAARev$factory_0());
  }
  j8d() {
    return this.s8c_1.ko(this, opSmoothUnion$factory_0());
  }
  k8d() {
    return this.t8c_1.ko(this, opSmoothSubtraction$factory_0());
  }
  l8d() {
    return this.u8c_1.ko(this, opSmoothIntersection$factory_0());
  }
  m8d() {
    return this.v8c_1.ko(this, circle$factory_0());
  }
  n8d() {
    return this.w8c_1.ko(this, roundedBox$factory_0());
  }
  o8d() {
    return this.x8c_1.ko(this, box$factory_0());
  }
  p8d() {
    return this.y8c_1.ko(this, opCombinePremultipliedColors$factory_0());
  }
}
class TextureBase {
  static q8d(base, size) {
    var $this = createThis(this);
    $this.l85_1 = base;
    $this.m85_1 = size;
    $this.n85_1 = -1;
    return $this;
  }
  e1() {
    return this.m85_1;
  }
  static o85(base, width, height) {
    return this.q8d(base, SizeInt.k2g(width, height));
  }
  p85(width) {
    this.m85_1 = SizeInt.k2g(width, this.n2i());
  }
  m2i() {
    return this.m85_1.i2g_1;
  }
  q85(height) {
    this.m85_1 = SizeInt.k2g(this.m2i(), height);
  }
  n2i() {
    return this.m85_1.j2g_1;
  }
  c6() {
    var tmp0_safe_receiver = this.l85_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c6();
    }
    this.l85_1 = null;
  }
  j86(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.l85_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.j6m(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.l85_1) + ')';
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.r8d_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_73();
    icount = icount === VOID ? indices.length : icount;
    this.j88_1 = indices;
    this.k88_1 = vcount;
    this.l88_1 = vcount;
    this.m88_1 = icount;
    this.n88_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.k88_1), 4));
    this.o88_1 = this.n88_1;
    this.p88_1 = 0;
  }
  s8d(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  t8d(index, x, y, width, height, matrix, bmp, colMul) {
    this.f8c(index, x, y, width, height, matrix, bmp.m3h(), bmp.n3h(), bmp.o3h(), bmp.p3h(), bmp.s3h(), bmp.t3h(), bmp.q3h(), bmp.r3h(), colMul);
  }
  f8c(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.c29_1;
    var cf = matrix.e29_1;
    var txf = matrix.g29_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.f29_1;
    var bf = matrix.d29_1;
    var tyf = matrix.h29_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.o88_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.s8d(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.s8d(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.s8d(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.s8d(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ResourcesRoot {
  w8d(path, file) {
    _get_mountable__707cy(this).f2y(path, file);
  }
  e64(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.v8d_1 = this_0;
    tmp.u8d_1 = this_0.j23();
    this.w8d('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class RCollection {
  constructor() {
    this.x8d_1 = ArrayList.h1();
    this.y8d_1 = LinkedHashMap.bc();
  }
}
class Stats {
  constructor() {
    this.z8d_1 = new RCollection();
    this.a8e_1 = new RCollection();
  }
  e6g() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z8d_1.x8d_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).e6g();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.a8e_1.x8d_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.d1(_unary__edvuaz_0).e6g();
    }
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.s1u() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.t1u() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.i8e_1 = key;
    this.j8e_1 = initial;
    this.k8e_1 = end;
    this.l8e_1 = interpolator;
    this.m8e_1 = includeStart;
    this.n8e_1 = fastStartTime;
    this.o8e_1 = fastDuration;
    this.p8e_1 = initialization;
    this.q8e_1 = FastDuration__plus_impl_q1enab(this.n8e_1, equals(this.o8e_1, Companion_instance_3.t1u()) ? get_fastNanoseconds_0(0) : this.o8e_1);
  }
  r8e() {
    return toDuration_1(this.n8e_1);
  }
  s8e() {
    return toDuration_1(this.o8e_1);
  }
  t8e(default_0) {
    return equals(this.o8e_1, Companion_instance_3.t1u()) ? default_0 : this.q8e_1;
  }
  s35() {
    if (!this.m8e_1) {
      this.j8e_1 = this.i8e_1.get();
    }
    var tmp0_safe_receiver = this.p8e_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  u8e(ratio) {
    this.i8e_1.set(this.l8e_1(new Ratio(ratio), this.j8e_1, this.k8e_1));
  }
  toString() {
    return 'V2(key=' + this.i8e_1.callableName + ', range=[' + toString_1(this.j8e_1) + '-' + toString_1(this.k8e_1) + '], startTime=' + Duration__toString_impl_8d916b(this.r8e()) + ', duration=' + Duration__toString_impl_8d916b(this.s8e()) + ')';
  }
  hashCode() {
    var result = hashCode(this.i8e_1);
    result = imul(result, 31) + (this.j8e_1 == null ? 0 : hashCode(this.j8e_1)) | 0;
    result = imul(result, 31) + (this.k8e_1 == null ? 0 : hashCode(this.k8e_1)) | 0;
    result = imul(result, 31) + hashCode(this.l8e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m8e_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.n8e_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.o8e_1) | 0;
    result = imul(result, 31) + (this.p8e_1 == null ? 0 : hashCode(this.p8e_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.i8e_1, tmp0_other_with_cast.i8e_1))
      return false;
    if (!equals(this.j8e_1, tmp0_other_with_cast.j8e_1))
      return false;
    if (!equals(this.k8e_1, tmp0_other_with_cast.k8e_1))
      return false;
    if (!equals(this.l8e_1, tmp0_other_with_cast.l8e_1))
      return false;
    if (!(this.m8e_1 === tmp0_other_with_cast.m8e_1))
      return false;
    if (!equals(this.n8e_1, tmp0_other_with_cast.n8e_1))
      return false;
    if (!equals(this.o8e_1, tmp0_other_with_cast.o8e_1))
      return false;
    if (!equals(this.p8e_1, tmp0_other_with_cast.p8e_1))
      return false;
    return true;
  }
}
class V2CallbackSupport {
  constructor() {
    V2CallbackSupport_instance = this;
    this.v8e_1 = Unit_instance;
  }
}
class DEFAULT {}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.w8e_1 = quality;
  }
  x8a() {
    return this.w8e_1;
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.x8e_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.a8f_1 = text;
    this.b8f_1 = enabled;
    this.c8f_1 = children;
    this.d8f_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.a8f_1 + ', enabled=' + this.b8f_1 + ', children=' + toString_1(this.c8f_1) + ', action=' + toString(this.d8f_1) + ')';
  }
  hashCode() {
    var result = this.a8f_1 == null ? 0 : getStringHashCode(this.a8f_1);
    result = imul(result, 31) + getBooleanHashCode(this.b8f_1) | 0;
    result = imul(result, 31) + (this.c8f_1 == null ? 0 : hashCode(this.c8f_1)) | 0;
    result = imul(result, 31) + hashCode(this.d8f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.a8f_1 == tmp0_other_with_cast.a8f_1))
      return false;
    if (!(this.b8f_1 === tmp0_other_with_cast.b8f_1))
      return false;
    if (!equals(this.c8f_1, tmp0_other_with_cast.c8f_1))
      return false;
    if (!equals(this.d8f_1, tmp0_other_with_cast.d8f_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.e8f_1 = 60;
    this.f8f_1 = Companion_getInstance_1().mw('GameWindow');
    this.g8f_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.u8h_1 = level;
    this.v8h_1 = 4000000;
  }
  h2t() {
    return this.u8h_1;
  }
  w8h(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.n3_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  x8h(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.v8h_1 : targetPixels;
    return $super === VOID ? this.w8h(width, height, devicePixelRatio, targetPixels) : $super.w8h.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.y8e_1 = $entry;
    this.z8e_1 = this$0;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
  }
}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.e8i_1 = this$0;
    super($initialValue, $box);
  }
  f8i(property, oldValue, newValue) {
    var tmp0_safe_receiver = this.e8i_1.y8g_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  }
  jo(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    return this.f8i(property, tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  }
}
class GameWindow extends BaseEventListener {
  static g8i() {
    CoroutineKey_getInstance();
    var $this = this.m66();
    $this.l8f_1 = new Mixin();
    $this.m8f_1 = Cursor_DEFAULT_getInstance();
    $this.n8f_1 = false;
    $this.o8f_1 = AGDummy.q79();
    $this.p8f_1 = SyncEventLoopCoroutineDispatcher.j8i();
    $this.q8f_1 = GameWindowCoroutineDispatcher.u8i();
    $this.r8f_1 = new PauseEvent();
    $this.s8f_1 = new ResumeEvent();
    $this.t8f_1 = new StopEvent();
    $this.u8f_1 = new DestroyEvent();
    $this.v8f_1 = new UpdateEvent();
    $this.w8f_1 = new RenderEvent();
    $this.x8f_1 = new InitEvent();
    $this.y8f_1 = new DisposeEvent();
    $this.z8f_1 = new FullScreenEvent();
    $this.a8g_1 = new ReshapeEvent();
    $this.b8g_1 = new KeyEvent();
    $this.c8g_1 = new MouseEvent();
    $this.d8g_1 = new GestureEvent();
    $this.e8g_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.f8g_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.g8g_1 = 60;
    $this.h8g_1 = 0;
    $this.i8g_1 = 0;
    $this.j8g_1 = true;
    $this.k8g_1 = null;
    $this.l8g_1 = false;
    $this.m8g_1 = false;
    $this.n8g_1 = Colors_getInstance().t3y_1;
    $this.o8g_1 = new Signal();
    $this.p8g_1 = new Signal();
    $this.q8g_1 = null;
    $this.r8g_1 = false;
    $this.s8g_1 = true;
    $this.t8g_1 = 0;
    $this.u8g_1 = true;
    $this.v8g_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.w8g_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.x8g_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.y8g_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.z8g_1 = new _no_name_provided__qut3iv(true, $this);
    $this.a8h_1 = false;
    $this.b8h_1 = -1;
    $this.c8h_1 = -1;
    $this.d8h_1 = -1;
    $this.e8h_1 = -1;
    $this.f8h_1 = false;
    $this.g8h_1 = false;
    $this.h8h_1 = false;
    $this.i8h_1 = 0;
    $this.j8h_1 = Companion_instance_3.s1u();
    $this.k8h_1 = new Lock();
    $this.l8h_1 = booleanArray(Companion_getInstance_35().r6d_1);
    $this.m8h_1 = 0;
    $this.n8h_1 = 0.0;
    $this.o8h_1 = 0.0;
    $this.p8h_1 = 0.0;
    $this.q8h_1 = false;
    $this.r8h_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  v8i(windowRect) {
  }
  w8i(force, config) {
  }
  x8i(force, config, $super) {
    force = force === VOID ? true : force;
    config = config === VOID ? null : config;
    var tmp;
    if ($super === VOID) {
      this.w8i(force, config);
      tmp = Unit_instance;
    } else {
      tmp = $super.w8i.call(this, force, config);
    }
    return tmp;
  }
  y8i() {
  }
  z8i(_set____db54di) {
    this.m8f_1 = _set____db54di;
  }
  a8j() {
    return this.m8f_1;
  }
  q1() {
    return CoroutineKey_getInstance();
  }
  b8j() {
    return this.o8f_1;
  }
  c8j() {
    return this.q8f_1;
  }
  d8j(coroutineContext) {
    return coroutineContext.an(this.c8j());
  }
  y8h($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.mc();
    return this.d8j(tmp$ret$0);
  }
  e8j(block) {
    return this.o66(Companion_getInstance_19(), block);
  }
  a8i() {
    return get_fastMicroseconds(1000000.0 / this.f8j());
  }
  g8j() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.f8j();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  c8i() {
    return 60;
  }
  h8j(name, time) {
  }
  f8j() {
    return _get_fpsCached__581dty(this);
  }
  i8j(value) {
    return Unit_instance;
  }
  m2i() {
    return this.h8g_1;
  }
  n2i() {
    return this.i8g_1;
  }
  j8j(_set____db54di) {
    this.k8g_1 = _set____db54di;
  }
  k8j(_set____db54di) {
    this.l8g_1 = _set____db54di;
  }
  l8j(_set____db54di) {
    this.m8g_1 = _set____db54di;
  }
  m8j(_set____db54di) {
    this.n8g_1 = _set____db54di;
  }
  n8j() {
    return this.n8g_1;
  }
  o8j(value) {
    return Unit_instance;
  }
  x8a() {
    return Quality_AUTOMATIC_getInstance();
  }
  p8j(value) {
    this.r8g_1 = value;
    this.p8g_1.z1v(value);
    if (value) {
      invoke(this.o8g_1);
    }
  }
  q8j() {
    return this.r8g_1;
  }
  r8j(width, height) {
    return Unit_instance;
  }
  s8j(exitCode) {
    return this.a1d(exitCode);
  }
  t8j(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.s8j(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.s8j.call(this, exitCode);
    }
    return tmp;
  }
  a1d(exitCode) {
    if (this.v8g_1)
      return Unit_instance;
    this.v8g_1 = true;
    this.u8g_1 = false;
    this.t8g_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().f8f_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.c8j().c6();
    cancelChildren(this.c8j());
  }
  u8j(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.a1d(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.a1d.call(this, exitCode);
    }
    return tmp;
  }
  v8j($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_waitClose__fhnm35.bind(VOID, this), $completion);
  }
  w8j(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8.bind(VOID, this, entry), $completion);
  }
  b8i(time, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loopDelay__vgtnit.bind(VOID, this, time), $completion);
  }
  x8j(_set____db54di) {
    return this.z8g_1.no(this, continuousRenderMode$factory(), _set____db54di);
  }
  y8j() {
    return this.z8g_1.lo(this, continuousRenderMode$factory_0());
  }
  z8j(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().o64();
    if (doRender) {
      var tmp = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark = Monotonic_instance.ej();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.a8k(doUpdate, true);
      tmp.w8g_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark_0 = Monotonic_instance.ej();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.a8k(true, false);
      }
      this.b8k(frameStartTime);
      tmp_0.x8g_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().p64();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  z8h(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().p64() : frameStartTime;
    return $super === VOID ? this.z8j(doUpdate, doRender, frameStartTime) : $super.z8j.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).v1u_1;
  }
  a8k(doUpdate, doRender) {
    if (doRender) {
      if (this.h8h_1) {
        this.h8h_1 = false;
        this.b8j().b6g();
      }
      if (this.a8h_1) {
        this.a8h_1 = false;
        this.b8j().a6g().v6k(this.b8h_1, this.c8h_1, this.d8h_1, this.e8h_1);
        this.c8k(this.b8h_1, this.c8h_1, this.d8h_1, this.e8h_1);
      }
    }
    if (this.f8h_1) {
      this.f8h_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.m2i() + ', ' + this.n2i() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.x8f_1;
      this_0.h67_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.z66(this_0);
    }
    try {
      this.d8k(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  e6g() {
    this.i8h_1 = 0;
  }
  e8k() {
    this.i8h_1 = this.i8h_1 + 1 | 0;
  }
  b8k(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.f8k();
    tmp.j8h_1 = stopwatch.u64();
    try {
      var now = PerformanceCounter_getInstance().o64();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.c8j().s8i_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.g8j(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.c8j().g8k(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  f8k() {
  }
  d8k(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.k8h_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.d1v();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.w8f_1;
        this_1.h67_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.p67_1 = update;
        this_1.q67_1 = render;
        this.z66(this_1);
        break $l$block;
      }finally {
        this_0.f1v();
      }
    }
  }
  h8k(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.e8g_1;
    this_0.h67_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.e6a_1 = type;
    this_0.f6a_1 = files;
    return this.z66(this_0);
  }
  c8k(x, y, width, height) {
    this.i8k(x, y, width, height, width, height);
  }
  i8k(x, y, width, height, fullWidth, fullHeight) {
    this.b8j().a6g().w6k(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.a8g_1;
    this_0.h67_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.y67_1 = x;
    this_0.z67_1 = y;
    this_0.a68_1 = width;
    this_0.b68_1 = height;
    this.z66(this_0);
  }
  i6c() {
    this.r8h_1.i6c();
  }
  u6c(info) {
    this.r8h_1.u6c(info);
  }
  w6c(out) {
    return this.r8h_1.w6c(out);
  }
  j8k(out, $super) {
    out = out === VOID ? IntArrayList.n2j() : out;
    return $super === VOID ? this.w6c(out) : $super.w6c.call(this, out);
  }
  k8k(data, $completion) {
  }
  l8k($completion) {
    return null;
  }
  vx(_set____db54di) {
    this.l8f_1.vx(_set____db54di);
  }
  wx() {
    return this.l8f_1.wx();
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.m8k_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    Companion_getInstance_75();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    title = title === VOID ? '' : title;
    this.n8k_1 = multithreaded;
    this.o8k_1 = hdr;
    this.p8k_1 = msaa;
    this.q8k_1 = checkGl;
    this.r8k_1 = logGl;
    this.s8k_1 = cacheGl;
    this.t8k_1 = fullscreen;
    this.u8k_1 = decorated;
    this.v8k_1 = transparent;
    this.w8k_1 = resizable;
    this.x8k_1 = title;
  }
  y8k(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    return new GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  z8k(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title, $super) {
    multithreaded = multithreaded === VOID ? this.n8k_1 : multithreaded;
    hdr = hdr === VOID ? this.o8k_1 : hdr;
    msaa = msaa === VOID ? this.p8k_1 : msaa;
    checkGl = checkGl === VOID ? this.q8k_1 : checkGl;
    logGl = logGl === VOID ? this.r8k_1 : logGl;
    cacheGl = cacheGl === VOID ? this.s8k_1 : cacheGl;
    fullscreen = fullscreen === VOID ? this.t8k_1 : fullscreen;
    decorated = decorated === VOID ? this.u8k_1 : decorated;
    transparent = transparent === VOID ? this.v8k_1 : transparent;
    resizable = resizable === VOID ? this.w8k_1 : resizable;
    title = title === VOID ? this.x8k_1 : title;
    return $super === VOID ? this.y8k(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) : $super.y8k.call(this, multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.n8k_1 + ', hdr=' + this.o8k_1 + ', msaa=' + this.p8k_1 + ', checkGl=' + this.q8k_1 + ', logGl=' + this.r8k_1 + ', cacheGl=' + this.s8k_1 + ', fullscreen=' + this.t8k_1 + ', decorated=' + this.u8k_1 + ', transparent=' + this.v8k_1 + ', resizable=' + this.w8k_1 + ', title=' + this.x8k_1 + ')';
  }
  hashCode() {
    var result = this.n8k_1 == null ? 0 : getBooleanHashCode(this.n8k_1);
    result = imul(result, 31) + (this.o8k_1 == null ? 0 : getBooleanHashCode(this.o8k_1)) | 0;
    result = imul(result, 31) + (this.p8k_1 == null ? 0 : this.p8k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q8k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r8k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s8k_1) | 0;
    result = imul(result, 31) + (this.t8k_1 == null ? 0 : getBooleanHashCode(this.t8k_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u8k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v8k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w8k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x8k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.n8k_1 == tmp0_other_with_cast.n8k_1))
      return false;
    if (!(this.o8k_1 == tmp0_other_with_cast.o8k_1))
      return false;
    if (!(this.p8k_1 == tmp0_other_with_cast.p8k_1))
      return false;
    if (!(this.q8k_1 === tmp0_other_with_cast.q8k_1))
      return false;
    if (!(this.r8k_1 === tmp0_other_with_cast.r8k_1))
      return false;
    if (!(this.s8k_1 === tmp0_other_with_cast.s8k_1))
      return false;
    if (!(this.t8k_1 == tmp0_other_with_cast.t8k_1))
      return false;
    if (!(this.u8k_1 === tmp0_other_with_cast.u8k_1))
      return false;
    if (!(this.v8k_1 === tmp0_other_with_cast.v8k_1))
      return false;
    if (!(this.w8k_1 === tmp0_other_with_cast.w8k_1))
      return false;
    if (!(this.x8k_1 === tmp0_other_with_cast.x8k_1))
      return false;
    return true;
  }
}
class TextClipboardData {
  constructor(text, contentType) {
    contentType = contentType === VOID ? null : contentType;
    this.a8l_1 = text;
    this.b8l_1 = contentType;
  }
  toString() {
    return 'TextClipboardData(text=' + this.a8l_1 + ', contentType=' + this.b8l_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a8l_1);
    result = imul(result, 31) + (this.b8l_1 == null ? 0 : getStringHashCode(this.b8l_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextClipboardData))
      return false;
    var tmp0_other_with_cast = other instanceof TextClipboardData ? other : THROW_CCE();
    if (!(this.a8l_1 === tmp0_other_with_cast.a8l_1))
      return false;
    if (!(this.b8l_1 == tmp0_other_with_cast.b8l_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.c8l_1 = time;
    this.d8l_1 = continuation;
    this.e8l_1 = callback;
    this.f8l_1 = null;
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_69 = this;
    this.g8l_1 = Companion_getInstance_1().mw('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.h8l_1 = function_0;
  }
  d18() {
    return this.h8l_1();
  }
  k4() {
    return this.h8l_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.k4(), other.k4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.k4());
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  static u8i(nowProvider, fast) {
    Companion_getInstance_76();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.g1b();
    $this.l8i_1 = nowProvider;
    $this.m8i_1 = fast;
    $this.n8i_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.o8i_1 = tmp_1.g2q(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.p8i_1 = new NonRecursiveLock();
    $this.q8i_1 = get_fastMilliseconds_0(0);
    $this.r8i_1 = get_fastMilliseconds_0(0);
    $this.s8i_1 = null;
    $this.t8i_1 = Companion_getInstance_1().mw('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  i8l(block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.p8i_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.n8i_1.q2q(block);
  }
  i1b(context, block) {
    return this.i8l(block);
  }
  j8l() {
    return this.l8i_1().v1u_1;
  }
  t1b(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.j4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.k8l(tmp$ret$0, continuation);
  }
  k8l(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.j8l(), time), continuation, null);
    continuation.r17(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.p8i_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
    this.o8i_1.u2l(task);
  }
  u1b(timeMillis, block, context) {
    var tmp = this.j8l();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.j4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.p8i_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
    this.o8i_1.u2l(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  g8k(availableTime) {
    this.l8l(get_fast(availableTime));
  }
  l8l(availableTime) {
    try {
      var startTime = this.j8l();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.p8i_1.y1u_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.o8i_1.g1()) {
          tmp_1 = this.m8i_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.o8i_1.m2q().c8l_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.o8i_1.n2q();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.f8l_1 == null)) {
            var tmp1_safe_receiver = item.d8l_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.f8l_1);
              var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.oc(tmp$ret$5);
            }
            if (!(item.e8l_1 == null)) {
              var tmp2_safe_receiver = item.f8l_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.d8l_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.oc(tmp$ret$7);
            }
            var tmp4_safe_receiver = item.e8l_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.e1a();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.j8l(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.m8l(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.q8i_1 = stopwatch.u64();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.p8i_1.y1u_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.n8i_1.g1()) {
          tmp_4 = this.n8i_1.r2q();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.e1a();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.u64();
        var elapsed = FastDuration__minus_impl_evs237(this.j8l(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.m8l(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.r8i_1 = stopwatch_0.u64();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  }
  m8l(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.t8i_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.o8i_1.j2q_1 + ', tasks=' + this.n8i_1.e1() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  c6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.g8k(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_76().g8l_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.k2t(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.o8i_1.g1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.o8i_1.n2q().d8l_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.oc(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.n8i_1.g1()) {
        break $l$loop_0;
      }
      this.n8i_1.r2q().e1a();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.m8i_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  static n8l(eventLoop) {
    var $this = this.g1b();
    $this.i8i_1 = eventLoop;
    return $this;
  }
  static j8i(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.n8l(new SyncEventLoop(immediateRun));
  }
  c6() {
    this.i8i_1.c6();
  }
  i1b(context, block) {
    this.i8i_1.u65(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  t1b(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.r17(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.i8i_1.v65(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  u1b(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.i8i_1.v65(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_61 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.s1u() : fastDeltaTime;
    super();
    this.q8l_1 = fastDeltaTime;
  }
  r8l() {
    return toDuration_1(this.q8l_1);
  }
  n29() {
    return Companion_instance_70;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.q8l_1) + ')';
  }
}
class Companion_62 {
  constructor() {
    this.s8l_1 = 536805376;
    this.t8l_1 = 805240832;
    this.u8l_1 = 2;
    this.v8l_1 = 32;
    this.w8l_1 = 256;
    this.x8l_1 = 512;
    this.y8l_1 = 768;
    this.z8l_1 = 769;
    this.a8m_1 = 1024;
    this.b8m_1 = 1025;
    this.c8m_1 = 1026;
    this.d8m_1 = 1027;
  }
}
class SDL extends FFILib {
  static w8m() {
    var $this = this.a2v([get_SDLPath()]);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_14().f2v_1;
    tmp.j8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config, true)).t2u($this, SDL_Init$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_14().f2v_1;
    tmp_0.k8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_0, true)).t2u($this, SDL_CreateWindow$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_14().f2v_1;
    tmp_1.l8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).t2u($this, SDL_SetWindowTitle$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_14().f2v_1;
    tmp_2.m8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).t2u($this, SDL_SetWindowSize$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_14().f2v_1;
    tmp_3.n8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).t2u($this, SDL_SetWindowPosition$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_14().f2v_1;
    tmp_4.o8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).t2u($this, SDL_ShowWindow$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_14().f2v_1;
    tmp_5.p8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).t2u($this, SDL_RaiseWindow$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_14().f2v_1;
    tmp_6.q8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().tf(), arrayOf([]), false))]), false), null, config_6, true)).t2u($this, SDL_PollEvent$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_14().f2v_1;
    tmp_7.r8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).t2u($this, SDL_Quit$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_14().f2v_1;
    tmp_8.s8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_8, true)).t2u($this, SDL_GL_CreateContext$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_14().f2v_1;
    tmp_9.t8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).t2u($this, SDL_GL_DeleteContext$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_14().f2v_1;
    tmp_10.u8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_10, true)).t2u($this, SDL_GL_MakeCurrent$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_14().f2v_1;
    tmp_11.v8m_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).t2u($this, SDL_GL_SwapWindow$factory());
    return $this;
  }
  x8m() {
    return this.j8m_1.lo(this, SDL_Init$factory_0());
  }
  y8m() {
    return this.k8m_1.lo(this, SDL_CreateWindow$factory_0());
  }
  z8m() {
    return this.l8m_1.lo(this, SDL_SetWindowTitle$factory_0());
  }
  a8n() {
    return this.m8m_1.lo(this, SDL_SetWindowSize$factory_0());
  }
  b8n() {
    return this.n8m_1.lo(this, SDL_SetWindowPosition$factory_0());
  }
  c8n() {
    return this.o8m_1.lo(this, SDL_ShowWindow$factory_0());
  }
  d8n() {
    return this.p8m_1.lo(this, SDL_RaiseWindow$factory_0());
  }
  e8n() {
    return this.q8m_1.lo(this, SDL_PollEvent$factory_0());
  }
  f8n() {
    return this.r8m_1.lo(this, SDL_Quit$factory_0());
  }
  g8n() {
    return this.s8m_1.lo(this, SDL_GL_CreateContext$factory_0());
  }
  h8n() {
    return this.t8m_1.lo(this, SDL_GL_DeleteContext$factory_0());
  }
  i8n() {
    return this.u8m_1.lo(this, SDL_GL_MakeCurrent$factory_0());
  }
  j8n() {
    return this.v8m_1.lo(this, SDL_GL_SwapWindow$factory_0());
  }
}
class KmlGlOpenGL extends KmlGl {
  constructor(gl) {
    gl = gl === VOID ? OpenGL.n8t() : gl;
    super();
    this.s8t_1 = gl;
  }
  t8t(_this__u8e3s4) {
    return CreateFFIPointer(toLong(_this__u8e3s4));
  }
  u8t(_this__u8e3s4) {
    return CreateFFIPointer(_this__u8e3s4);
  }
  f75(texture) {
    return this.s8t_1.v8t()(texture);
  }
  k79(program, shader) {
    return this.s8t_1.w8t()(program, shader);
  }
  j79(program, index, name) {
    return this.s8t_1.x8t()(program, index, name);
  }
  z73(target, buffer) {
    return this.s8t_1.y8t()(target, buffer);
  }
  c78(target, framebuffer) {
    return this.s8t_1.z8t()(target, framebuffer);
  }
  j78(target, renderbuffer) {
    return this.s8t_1.a8u()(target, renderbuffer);
  }
  a78(target, texture) {
    return this.s8t_1.b8u()(target, texture);
  }
  n76(modeRGB, modeAlpha) {
    return this.s8t_1.c8u()(modeRGB, modeAlpha);
  }
  o76(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.s8t_1.d8u()(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  j75(target, size, data, usage) {
    return this.s8t_1.e8u()(target, this.t8t(size), get_pointer_0(data), usage);
  }
  i75(target, offset, size, data) {
    return this.s8t_1.f8u()(target, this.t8t(offset), this.t8t(size), get_pointer_0(data));
  }
  j76(mask) {
    return this.s8t_1.g8u()(mask);
  }
  e76(red, green, blue, alpha) {
    return this.s8t_1.h8u()(red, green, blue, alpha);
  }
  g76(d) {
    return this.s8t_1.i8u()(d);
  }
  i76(s) {
    return this.s8t_1.j8u()(s);
  }
  q78(red, green, blue, alpha) {
    var tmp = this.s8t_1.k8u();
    // Inline function 'korlibs.math.toInt' call
    var tmp_0 = red ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_1 = green ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_2 = blue ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    return tmp(tmp_0, tmp_1, tmp_2, alpha ? 1 : 0);
  }
  b79(shader) {
    return this.s8t_1.l8u()(shader);
  }
  d79() {
    return this.s8t_1.m8u()();
  }
  z78(type) {
    return this.s8t_1.n8u()(type);
  }
  g77(mode) {
    return this.s8t_1.o8u()(mode);
  }
  l7y(n, items) {
    return this.s8t_1.p8u()(n, get_pointer_0(items));
  }
  m7y(n, items) {
    return this.s8t_1.q8u()(n, get_pointer_0(items));
  }
  y78(program) {
    return this.s8t_1.r8u()(program);
  }
  n7y(n, items) {
    return this.s8t_1.s8u()(n, get_pointer_0(items));
  }
  x78(shader) {
    return this.s8t_1.t8u()(shader);
  }
  o7y(n, items) {
    return this.s8t_1.u8u()(n, get_pointer_0(items));
  }
  p78(func) {
    return this.s8t_1.v8u()(func);
  }
  f76(flag) {
    var tmp = this.s8t_1.w8u();
    // Inline function 'korlibs.math.toInt' call
    return tmp(flag ? 1 : 0);
  }
  o78(n, f) {
    return this.s8t_1.x8u()(n, f);
  }
  s76(cap) {
    return this.s8t_1.y8u()(cap);
  }
  i77(index) {
    return this.s8t_1.z8u()(index);
  }
  z76(mode, first, count) {
    return this.s8t_1.a8v()(mode, first, count);
  }
  b77(mode, count, type, indices) {
    return this.s8t_1.b8v()(mode, count, type, this.t8t(indices));
  }
  t76(cap) {
    return this.s8t_1.c8v()(cap);
  }
  m77(index) {
    return this.s8t_1.d8v()(index);
  }
  lc() {
    return this.s8t_1.e8v()();
  }
  m78(target, attachment, renderbuffertarget, renderbuffer) {
    return this.s8t_1.f8v()(target, attachment, renderbuffertarget, renderbuffer);
  }
  l78(target, attachment, textarget, texture, level) {
    return this.s8t_1.g8v()(target, attachment, textarget, texture, level);
  }
  n78(mode) {
    return this.s8t_1.h8v()(mode);
  }
  p7y(n, buffers) {
    return this.s8t_1.i8v()(n, get_pointer_0(buffers));
  }
  n75(target) {
    return this.s8t_1.j8v()(target);
  }
  q7y(n, framebuffers) {
    return this.s8t_1.k8v()(n, get_pointer_0(framebuffers));
  }
  r7y(n, renderbuffers) {
    return this.s8t_1.l8v()(n, get_pointer_0(renderbuffers));
  }
  s7y(n, textures) {
    return this.s8t_1.m8v()(n, get_pointer_0(textures));
  }
  v78(program, name) {
    return this.s8t_1.n8v()(program, name);
  }
  c79() {
    return this.s8t_1.o8v()();
  }
  t7y(pname, data) {
    return this.s8t_1.p8v()(pname, get_pointer_0(data));
  }
  u7y(program, pname, params) {
    return this.s8t_1.q8v()(program, pname, get_pointer_0(params));
  }
  v7y(shader, pname, params) {
    return this.s8t_1.r8v()(shader, pname, get_pointer_0(params));
  }
  w7y(shader, bufSize, length, infoLog) {
    this.s8t_1.s8v()(shader, bufSize, get_pointer_0(length), get_pointer_0(infoLog));
  }
  u71(name) {
    var tmp0_elvis_lhs = this.s8t_1.t8v()(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  l79(program) {
    return this.s8t_1.u8v()(program);
  }
  k75(pname, param) {
    return this.s8t_1.v8v()(pname, param);
  }
  k78(target, internalformat, width, height) {
    return this.s8t_1.w8v()(target, internalformat, width, height);
  }
  r78(x, y, width, height) {
    return this.s8t_1.x8v()(x, y, width, height);
  }
  a79(shader, string) {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = CreateFFIMemory(8);
    var lengthsPtr = get_pointer(Deno.UnsafePointer.of(this_0));
    var bytes = encodeToByteArray(string + '\x00');
    set32(lengthsPtr, bytes.length - 1 | 0);
    // Inline function 'korlibs.ffi.usePointer' call
    var this_1 = CreateFFIMemory_0(bytes);
    var strPtr = get_pointer(Deno.UnsafePointer.of(this_1));
    // Inline function 'korlibs.ffi.usePointer' call
    var this_2 = CreateFFIMemory(8);
    var strPtrPtr = get_pointer(Deno.UnsafePointer.of(this_2));
    setFFIPointer(strPtrPtr, strPtr);
    this.s8t_1.y8v()(shader, 1, strPtrPtr, lengthsPtr);
  }
  v76(func, ref, mask) {
    return this.s8t_1.z8v()(func, ref, mask);
  }
  u76(face, func, ref, mask) {
    return this.s8t_1.a8w()(face, func, ref, mask);
  }
  h76(mask) {
    return this.s8t_1.b8w()(mask);
  }
  y76(face, mask) {
    return this.s8t_1.c8w()(face, mask);
  }
  x76(fail, zfail, zpass) {
    return this.s8t_1.d8w()(fail, zfail, zpass);
  }
  w76(face, sfail, dpfail, dppass) {
    return this.s8t_1.e8w()(face, sfail, dpfail, dppass);
  }
  l75(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp = this.s8t_1.f8w();
    tmp(target, level, internalformat, width, height, border, format, type, pixels == null ? null : get_pointer_0(pixels));
  }
  e75(target, pname, param) {
    return this.s8t_1.g8w()(target, pname, param);
  }
  a75(location, count, value) {
    return this.s8t_1.h8w()(location, count, get_pointer_0(value));
  }
  y72(location, v0) {
    return this.s8t_1.i8w()(location, v0);
  }
  t74(location, count, value) {
    return this.s8t_1.j8w()(location, count, get_pointer_0(value));
  }
  b75(location, count, value) {
    return this.s8t_1.k8w()(location, count, get_pointer_0(value));
  }
  u74(location, count, value) {
    return this.s8t_1.l8w()(location, count, get_pointer_0(value));
  }
  c75(location, count, value) {
    return this.s8t_1.m8w()(location, count, get_pointer_0(value));
  }
  v74(location, count, value) {
    return this.s8t_1.n8w()(location, count, get_pointer_0(value));
  }
  d75(location, count, value) {
    return this.s8t_1.o8w()(location, count, get_pointer_0(value));
  }
  w74(location, count, value) {
    return this.s8t_1.p8w()(location, count, get_pointer_0(value));
  }
  x74(location, count, transpose, value) {
    var tmp = this.s8t_1.q8w();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  y74(location, count, transpose, value) {
    var tmp = this.s8t_1.r8w();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  z74(location, count, transpose, value) {
    var tmp = this.s8t_1.s8w();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  w78(program) {
    return this.s8t_1.t8w()(program);
  }
  n77(index, size, type, normalized, stride, pointer) {
    var tmp = this.s8t_1.u8w();
    // Inline function 'korlibs.math.toInt' call
    return tmp(index, size, type, normalized ? 1 : 0, stride, this.u8t(pointer));
  }
  b78(x, y, width, height) {
    return this.s8t_1.v8w()(x, y, width, height);
  }
  a77(mode, first, count, instancecount) {
    return this.s8t_1.w8w()(mode, first, count, instancecount);
  }
  c77(mode, count, type, indices, instancecount) {
    return this.s8t_1.x8w()(mode, count, type, this.t8t(indices), instancecount);
  }
  h77(index, divisor) {
    return this.s8t_1.y8w()(index, divisor);
  }
  i6g() {
    return true;
  }
  u77(target, index, buffer, offset, size) {
    return this.s8t_1.z8w()(target, index, buffer, this.t8t(offset), this.t8t(size));
  }
  z72(program, name) {
    return this.s8t_1.a8x()(program, name);
  }
  a73(program, uniformBlockIndex, uniformBlockBinding) {
    return this.s8t_1.b8x()(program, uniformBlockIndex, uniformBlockBinding);
  }
  j6g() {
    return true;
  }
  x7y(n, arrays) {
    return this.s8t_1.c8x()(n, get_pointer_0(arrays));
  }
  j77(array) {
    return this.s8t_1.d8x()(array);
  }
}
class Companion_63 {
  constructor() {
    this.e8x_1 = 16384;
  }
}
class OpenGL extends FFILib {
  static n8t() {
    var $this = this.a2v(['/System/Library/Frameworks/OpenGL.framework/OpenGL']);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_14().f2v_1;
    tmp.p8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config, true)).t2u($this, glDrawArraysInstanced$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_14().f2v_1;
    tmp_0.q8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_0, true)).t2u($this, glDrawElementsInstanced$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_14().f2v_1;
    tmp_1.r8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).t2u($this, glVertexAttribDivisor$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_14().f2v_1;
    tmp_2.s8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).t2u($this, glTexSubImage2D$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_14().f2v_1;
    tmp_3.t8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).t2u($this, glTexImage2D$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_14().f2v_1;
    tmp_4.u8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).t2u($this, glTexParameteri$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_14().f2v_1;
    tmp_5.v8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).t2u($this, glTexParameterf$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_14().f2v_1;
    tmp_6.w8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_6, true)).t2u($this, glTexParameterfv$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_14().f2v_1;
    tmp_7.x8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).t2u($this, glTexParameteriv$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_14().f2v_1;
    tmp_8.y8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_8, true)).t2u($this, glStencilOp$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_14().f2v_1;
    tmp_9.z8n_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).t2u($this, glStencilMask$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_14().f2v_1;
    tmp_10.a8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_10, true)).t2u($this, glReadPixels$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_14().f2v_1;
    tmp_11.b8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).t2u($this, glStencilFunc$factory());
    var tmp_12 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_12 = Companion_getInstance_14().f2v_1;
    tmp_12.c8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_12, true)).t2u($this, glScissor$factory());
    var tmp_13 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_13 = Companion_getInstance_14().f2v_1;
    tmp_13.d8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_13, true)).t2u($this, glPolygonOffset$factory());
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_14 = Companion_getInstance_14().f2v_1;
    tmp_14.e8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_14, true)).t2u($this, glPixelStorei$factory());
    var tmp_15 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_15 = Companion_getInstance_14().f2v_1;
    tmp_15.f8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_15, true)).t2u($this, glLineWidth$factory());
    var tmp_16 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_16 = Companion_getInstance_14().f2v_1;
    tmp_16.g8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_16, true)).t2u($this, glGetTexParameterfv$factory());
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_17 = Companion_getInstance_14().f2v_1;
    tmp_17.h8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_17, true)).t2u($this, glGetTexParameteriv$factory());
    var tmp_18 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_18 = Companion_getInstance_14().f2v_1;
    tmp_18.i8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_18, true)).t2u($this, glGetError$factory());
    var tmp_19 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_19 = Companion_getInstance_14().f2v_1;
    tmp_19.j8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_19, true)).t2u($this, glGetFloatv$factory());
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_20 = Companion_getInstance_14().f2v_1;
    tmp_20.k8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_20, true)).t2u($this, glGetIntegerv$factory());
    var tmp_21 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_21 = Companion_getInstance_14().f2v_1;
    tmp_21.l8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_21, true)).t2u($this, glGetBooleanv$factory());
    var tmp_22 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_22 = Companion_getInstance_14().f2v_1;
    tmp_22.m8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_22, true)).t2u($this, glGenTextures$factory());
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_23 = Companion_getInstance_14().f2v_1;
    tmp_23.n8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_23, true)).t2u($this, glDepthRange$factory());
    var tmp_24 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_24 = Companion_getInstance_14().f2v_1;
    tmp_24.o8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_24, true)).t2u($this, glDepthRangef$factory());
    var tmp_25 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_25 = Companion_getInstance_14().f2v_1;
    tmp_25.p8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_25, true)).t2u($this, glClearDepth$factory());
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_26 = Companion_getInstance_14().f2v_1;
    tmp_26.q8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_26, true)).t2u($this, glClearDepthf$factory());
    var tmp_27 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_27 = Companion_getInstance_14().f2v_1;
    tmp_27.r8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_27, true)).t2u($this, glDrawArrays$factory());
    var tmp_28 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_28 = Companion_getInstance_14().f2v_1;
    tmp_28.s8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_28, true)).t2u($this, glDrawElements$factory());
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_29 = Companion_getInstance_14().f2v_1;
    tmp_29.t8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_29, true)).t2u($this, glFrontFace$factory());
    var tmp_30 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_30 = Companion_getInstance_14().f2v_1;
    tmp_30.u8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_30, true)).t2u($this, glFinish$factory());
    var tmp_31 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_31 = Companion_getInstance_14().f2v_1;
    tmp_31.v8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_31, true)).t2u($this, glFlush$factory());
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_32 = Companion_getInstance_14().f2v_1;
    tmp_32.w8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_32, true)).t2u($this, glEnable$factory());
    var tmp_33 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_33 = Companion_getInstance_14().f2v_1;
    tmp_33.x8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_33, true)).t2u($this, glIsEnabled$factory());
    var tmp_34 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_34 = Companion_getInstance_14().f2v_1;
    tmp_34.y8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_34, true)).t2u($this, glDisable$factory());
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_35 = Companion_getInstance_14().f2v_1;
    tmp_35.z8o_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_35, true)).t2u($this, glDepthMask$factory());
    var tmp_36 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_36 = Companion_getInstance_14().f2v_1;
    tmp_36.a8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_36, true)).t2u($this, glDepthFunc$factory());
    var tmp_37 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_37 = Companion_getInstance_14().f2v_1;
    tmp_37.b8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_37, true)).t2u($this, glDeleteTextures$factory());
    var tmp_38 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_38 = Companion_getInstance_14().f2v_1;
    tmp_38.c8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_38, true)).t2u($this, glCullFace$factory());
    var tmp_39 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_39 = Companion_getInstance_14().f2v_1;
    tmp_39.d8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_39, true)).t2u($this, glCopyTexImage2D$factory());
    var tmp_40 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_40 = Companion_getInstance_14().f2v_1;
    tmp_40.e8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_40, true)).t2u($this, glCopyTexSubImage2D$factory());
    var tmp_41 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_41 = Companion_getInstance_14().f2v_1;
    tmp_41.f8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_41, true)).t2u($this, glColorMask$factory());
    var tmp_42 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_42 = Companion_getInstance_14().f2v_1;
    tmp_42.g8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_42, true)).t2u($this, glClearStencil$factory());
    var tmp_43 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_43 = Companion_getInstance_14().f2v_1;
    tmp_43.h8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_43, true)).t2u($this, glClearColor$factory());
    var tmp_44 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_44 = Companion_getInstance_14().f2v_1;
    tmp_44.i8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_44, true)).t2u($this, glClear$factory());
    var tmp_45 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_45 = Companion_getInstance_14().f2v_1;
    tmp_45.j8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_45, true)).t2u($this, glBindTexture$factory());
    var tmp_46 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_46 = Companion_getInstance_14().f2v_1;
    tmp_46.k8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_46, true)).t2u($this, glHint$factory());
    var tmp_47 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_47 = Companion_getInstance_14().f2v_1;
    tmp_47.l8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_47, true)).t2u($this, glViewport$factory());
    var tmp_48 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_48 = Companion_getInstance_14().f2v_1;
    tmp_48.m8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true))]), false), null, config_48, true)).t2u($this, glGetString$factory());
    var tmp_49 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_49 = Companion_getInstance_14().f2v_1;
    tmp_49.n8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true))]), false), null, config_49, true)).t2u($this, glGetStringi$factory());
    var tmp_50 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_50 = Companion_getInstance_14().f2v_1;
    tmp_50.o8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_50, true)).t2u($this, glVertexAttribPointer$factory());
    var tmp_51 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_51 = Companion_getInstance_14().f2v_1;
    tmp_51.p8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_51, true)).t2u($this, glVertexAttrib4fv$factory());
    var tmp_52 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_52 = Companion_getInstance_14().f2v_1;
    tmp_52.q8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_52, true)).t2u($this, glActiveTexture$factory());
    var tmp_53 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_53 = Companion_getInstance_14().f2v_1;
    tmp_53.r8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_53, true)).t2u($this, glAttachShader$factory());
    var tmp_54 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_54 = Companion_getInstance_14().f2v_1;
    tmp_54.s8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_54, true)).t2u($this, glBindAttribLocation$factory());
    var tmp_55 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_55 = Companion_getInstance_14().f2v_1;
    tmp_55.t8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_55, true)).t2u($this, glBindBuffer$factory());
    var tmp_56 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_56 = Companion_getInstance_14().f2v_1;
    tmp_56.u8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_56, true)).t2u($this, glBindFramebuffer$factory());
    var tmp_57 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_57 = Companion_getInstance_14().f2v_1;
    tmp_57.v8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_57, true)).t2u($this, glBindRenderbuffer$factory());
    var tmp_58 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_58 = Companion_getInstance_14().f2v_1;
    tmp_58.w8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_58, true)).t2u($this, glBlendColor$factory());
    var tmp_59 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_59 = Companion_getInstance_14().f2v_1;
    tmp_59.x8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_59, true)).t2u($this, glBlendEquation$factory());
    var tmp_60 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_60 = Companion_getInstance_14().f2v_1;
    tmp_60.y8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_60, true)).t2u($this, glBlendEquationSeparate$factory());
    var tmp_61 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_61 = Companion_getInstance_14().f2v_1;
    tmp_61.z8p_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_61, true)).t2u($this, glBlendFunc$factory());
    var tmp_62 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_62 = Companion_getInstance_14().f2v_1;
    tmp_62.a8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_62, true)).t2u($this, glBlendFuncSeparate$factory());
    var tmp_63 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_63 = Companion_getInstance_14().f2v_1;
    tmp_63.b8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_63, true)).t2u($this, glBufferData$factory());
    var tmp_64 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_64 = Companion_getInstance_14().f2v_1;
    tmp_64.c8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_64, true)).t2u($this, glBufferSubData$factory());
    var tmp_65 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_65 = Companion_getInstance_14().f2v_1;
    tmp_65.d8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_65, true)).t2u($this, glCheckFramebufferStatus$factory());
    var tmp_66 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_66 = Companion_getInstance_14().f2v_1;
    tmp_66.e8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_66, true)).t2u($this, glCompileShader$factory());
    var tmp_67 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_67 = Companion_getInstance_14().f2v_1;
    tmp_67.f8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_67, true)).t2u($this, glCompressedTexImage2D$factory());
    var tmp_68 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_68 = Companion_getInstance_14().f2v_1;
    tmp_68.g8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_68, true)).t2u($this, glCompressedTexSubImage2D$factory());
    var tmp_69 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_69 = Companion_getInstance_14().f2v_1;
    tmp_69.h8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_69, true)).t2u($this, glCreateProgram$factory());
    var tmp_70 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_70 = Companion_getInstance_14().f2v_1;
    tmp_70.i8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_70, true)).t2u($this, glCreateShader$factory());
    var tmp_71 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_71 = Companion_getInstance_14().f2v_1;
    tmp_71.j8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_71, true)).t2u($this, glDeleteBuffers$factory());
    var tmp_72 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_72 = Companion_getInstance_14().f2v_1;
    tmp_72.k8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_72, true)).t2u($this, glDeleteFramebuffers$factory());
    var tmp_73 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_73 = Companion_getInstance_14().f2v_1;
    tmp_73.l8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_73, true)).t2u($this, glDeleteProgram$factory());
    var tmp_74 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_74 = Companion_getInstance_14().f2v_1;
    tmp_74.m8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_74, true)).t2u($this, glDeleteRenderbuffers$factory());
    var tmp_75 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_75 = Companion_getInstance_14().f2v_1;
    tmp_75.n8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_75, true)).t2u($this, glDeleteShader$factory());
    var tmp_76 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_76 = Companion_getInstance_14().f2v_1;
    tmp_76.o8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_76, true)).t2u($this, glDetachShader$factory());
    var tmp_77 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_77 = Companion_getInstance_14().f2v_1;
    tmp_77.p8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_77, true)).t2u($this, glDisableVertexAttribArray$factory());
    var tmp_78 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_78 = Companion_getInstance_14().f2v_1;
    tmp_78.q8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_78, true)).t2u($this, glEnableVertexAttribArray$factory());
    var tmp_79 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_79 = Companion_getInstance_14().f2v_1;
    tmp_79.r8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_79, true)).t2u($this, glFramebufferRenderbuffer$factory());
    var tmp_80 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_80 = Companion_getInstance_14().f2v_1;
    tmp_80.s8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_80, true)).t2u($this, glFramebufferTexture2D$factory());
    var tmp_81 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_81 = Companion_getInstance_14().f2v_1;
    tmp_81.t8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_81, true)).t2u($this, glGenBuffers$factory());
    var tmp_82 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_82 = Companion_getInstance_14().f2v_1;
    tmp_82.u8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_82, true)).t2u($this, glGenerateMipmap$factory());
    var tmp_83 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_83 = Companion_getInstance_14().f2v_1;
    tmp_83.v8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_83, true)).t2u($this, glGenFramebuffers$factory());
    var tmp_84 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_84 = Companion_getInstance_14().f2v_1;
    tmp_84.w8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_84, true)).t2u($this, glGenRenderbuffers$factory());
    var tmp_85 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_85 = Companion_getInstance_14().f2v_1;
    tmp_85.x8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_85, true)).t2u($this, glGetActiveAttrib$factory());
    var tmp_86 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_86 = Companion_getInstance_14().f2v_1;
    tmp_86.y8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_86, true)).t2u($this, glGetActiveUniform$factory());
    var tmp_87 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_87 = Companion_getInstance_14().f2v_1;
    tmp_87.z8q_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_87, true)).t2u($this, glGetAttachedShaders$factory());
    var tmp_88 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_88 = Companion_getInstance_14().f2v_1;
    tmp_88.a8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_88, true)).t2u($this, glGetAttribLocation$factory());
    var tmp_89 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_89 = Companion_getInstance_14().f2v_1;
    tmp_89.b8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_89, true)).t2u($this, glGetUniformLocation$factory());
    var tmp_90 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_90 = Companion_getInstance_14().f2v_1;
    tmp_90.c8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_90, true)).t2u($this, glGetBufferParameteriv$factory());
    var tmp_91 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_91 = Companion_getInstance_14().f2v_1;
    tmp_91.d8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_91, true)).t2u($this, glGetFramebufferAttachmentParameteriv$factory());
    var tmp_92 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_92 = Companion_getInstance_14().f2v_1;
    tmp_92.e8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_92, true)).t2u($this, glGetProgramInfoLog$factory());
    var tmp_93 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_93 = Companion_getInstance_14().f2v_1;
    tmp_93.f8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_93, true)).t2u($this, glGetRenderbufferParameteriv$factory());
    var tmp_94 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_94 = Companion_getInstance_14().f2v_1;
    tmp_94.g8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_94, true)).t2u($this, glGetProgramiv$factory());
    var tmp_95 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_95 = Companion_getInstance_14().f2v_1;
    tmp_95.h8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_95, true)).t2u($this, glGetShaderiv$factory());
    var tmp_96 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_96 = Companion_getInstance_14().f2v_1;
    tmp_96.i8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_96, true)).t2u($this, glGetShaderInfoLog$factory());
    var tmp_97 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_97 = Companion_getInstance_14().f2v_1;
    tmp_97.j8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_97, true)).t2u($this, glGetShaderPrecisionFormat$factory());
    var tmp_98 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_98 = Companion_getInstance_14().f2v_1;
    tmp_98.k8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_98, true)).t2u($this, glGetShaderSource$factory());
    var tmp_99 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_99 = Companion_getInstance_14().f2v_1;
    tmp_99.l8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_99, true)).t2u($this, glGetUniformfv$factory());
    var tmp_100 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_100 = Companion_getInstance_14().f2v_1;
    tmp_100.m8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_100, true)).t2u($this, glGetUniformiv$factory());
    var tmp_101 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_101 = Companion_getInstance_14().f2v_1;
    tmp_101.n8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_101, true)).t2u($this, glGetVertexAttribfv$factory());
    var tmp_102 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_102 = Companion_getInstance_14().f2v_1;
    tmp_102.o8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_102, true)).t2u($this, glGetVertexAttribiv$factory());
    var tmp_103 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_103 = Companion_getInstance_14().f2v_1;
    tmp_103.p8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_103, true)).t2u($this, glGetVertexAttribPointerv$factory());
    var tmp_104 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_104 = Companion_getInstance_14().f2v_1;
    tmp_104.q8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_104, true)).t2u($this, glIsBuffer$factory());
    var tmp_105 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_105 = Companion_getInstance_14().f2v_1;
    tmp_105.r8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_105, true)).t2u($this, glIsFramebuffer$factory());
    var tmp_106 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_106 = Companion_getInstance_14().f2v_1;
    tmp_106.s8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_106, true)).t2u($this, glIsProgram$factory());
    var tmp_107 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_107 = Companion_getInstance_14().f2v_1;
    tmp_107.t8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_107, true)).t2u($this, glIsRenderbuffer$factory());
    var tmp_108 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_108 = Companion_getInstance_14().f2v_1;
    tmp_108.u8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_108, true)).t2u($this, glIsTexture$factory());
    var tmp_109 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_109 = Companion_getInstance_14().f2v_1;
    tmp_109.v8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_109, true)).t2u($this, glIsShader$factory());
    var tmp_110 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_110 = Companion_getInstance_14().f2v_1;
    tmp_110.w8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_110, true)).t2u($this, glLinkProgram$factory());
    var tmp_111 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_111 = Companion_getInstance_14().f2v_1;
    tmp_111.x8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_111, true)).t2u($this, glReleaseShaderCompiler$factory());
    var tmp_112 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_112 = Companion_getInstance_14().f2v_1;
    tmp_112.y8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_112, true)).t2u($this, glRenderbufferStorage$factory());
    var tmp_113 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_113 = Companion_getInstance_14().f2v_1;
    tmp_113.z8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_113, true)).t2u($this, glSampleCoverage$factory());
    var tmp_114 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_114 = Companion_getInstance_14().f2v_1;
    tmp_114.a8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_114, true)).t2u($this, glShaderBinary$factory());
    var tmp_115 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_115 = Companion_getInstance_14().f2v_1;
    tmp_115.b8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_115, true)).t2u($this, glShaderSource$factory());
    var tmp_116 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_116 = Companion_getInstance_14().f2v_1;
    tmp_116.c8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_116, true)).t2u($this, glStencilFuncSeparate$factory());
    var tmp_117 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_117 = Companion_getInstance_14().f2v_1;
    tmp_117.d8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_117, true)).t2u($this, glStencilMaskSeparate$factory());
    var tmp_118 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_118 = Companion_getInstance_14().f2v_1;
    tmp_118.e8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_118, true)).t2u($this, glStencilOpSeparate$factory());
    var tmp_119 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_119 = Companion_getInstance_14().f2v_1;
    tmp_119.f8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_119, true)).t2u($this, glUniform1f$factory());
    var tmp_120 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_120 = Companion_getInstance_14().f2v_1;
    tmp_120.g8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_120, true)).t2u($this, glUniform2f$factory());
    var tmp_121 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_121 = Companion_getInstance_14().f2v_1;
    tmp_121.h8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_121, true)).t2u($this, glUniform3f$factory());
    var tmp_122 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_122 = Companion_getInstance_14().f2v_1;
    tmp_122.i8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_122, true)).t2u($this, glUniform4f$factory());
    var tmp_123 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_123 = Companion_getInstance_14().f2v_1;
    tmp_123.j8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_123, true)).t2u($this, glUniform1i$factory());
    var tmp_124 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_124 = Companion_getInstance_14().f2v_1;
    tmp_124.k8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_124, true)).t2u($this, glUniform2i$factory());
    var tmp_125 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_125 = Companion_getInstance_14().f2v_1;
    tmp_125.l8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_125, true)).t2u($this, glUniform3i$factory());
    var tmp_126 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_126 = Companion_getInstance_14().f2v_1;
    tmp_126.m8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_126, true)).t2u($this, glUniform4i$factory());
    var tmp_127 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_127 = Companion_getInstance_14().f2v_1;
    tmp_127.n8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_127, true)).t2u($this, glUniform1fv$factory());
    var tmp_128 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_128 = Companion_getInstance_14().f2v_1;
    tmp_128.o8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_128, true)).t2u($this, glUniform2fv$factory());
    var tmp_129 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_129 = Companion_getInstance_14().f2v_1;
    tmp_129.p8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_129, true)).t2u($this, glUniform3fv$factory());
    var tmp_130 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_130 = Companion_getInstance_14().f2v_1;
    tmp_130.q8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_130, true)).t2u($this, glUniform4fv$factory());
    var tmp_131 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_131 = Companion_getInstance_14().f2v_1;
    tmp_131.r8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_131, true)).t2u($this, glUniform1iv$factory());
    var tmp_132 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_132 = Companion_getInstance_14().f2v_1;
    tmp_132.s8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_132, true)).t2u($this, glUniform2iv$factory());
    var tmp_133 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_133 = Companion_getInstance_14().f2v_1;
    tmp_133.t8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_133, true)).t2u($this, glUniform3iv$factory());
    var tmp_134 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_134 = Companion_getInstance_14().f2v_1;
    tmp_134.u8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_134, true)).t2u($this, glUniform4iv$factory());
    var tmp_135 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_135 = Companion_getInstance_14().f2v_1;
    tmp_135.v8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_135, true)).t2u($this, glUniformMatrix2fv$factory());
    var tmp_136 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_136 = Companion_getInstance_14().f2v_1;
    tmp_136.w8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_136, true)).t2u($this, glUniformMatrix3fv$factory());
    var tmp_137 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_137 = Companion_getInstance_14().f2v_1;
    tmp_137.x8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_137, true)).t2u($this, glUniformMatrix4fv$factory());
    var tmp_138 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_138 = Companion_getInstance_14().f2v_1;
    tmp_138.y8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_138, true)).t2u($this, glUseProgram$factory());
    var tmp_139 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_139 = Companion_getInstance_14().f2v_1;
    tmp_139.z8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_139, true)).t2u($this, glValidateProgram$factory());
    var tmp_140 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_140 = Companion_getInstance_14().f2v_1;
    tmp_140.a8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_140, true)).t2u($this, glVertexAttrib1f$factory());
    var tmp_141 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_141 = Companion_getInstance_14().f2v_1;
    tmp_141.b8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_141, true)).t2u($this, glVertexAttrib2f$factory());
    var tmp_142 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_142 = Companion_getInstance_14().f2v_1;
    tmp_142.c8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_142, true)).t2u($this, glVertexAttrib3f$factory());
    var tmp_143 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_143 = Companion_getInstance_14().f2v_1;
    tmp_143.d8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().xf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_143, true)).t2u($this, glVertexAttrib4f$factory());
    var tmp_144 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_144 = Companion_getInstance_14().f2v_1;
    tmp_144.e8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_144, true)).t2u($this, glVertexAttrib1fv$factory());
    var tmp_145 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_145 = Companion_getInstance_14().f2v_1;
    tmp_145.f8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_145, true)).t2u($this, glVertexAttrib2fv$factory());
    var tmp_146 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_146 = Companion_getInstance_14().f2v_1;
    tmp_146.g8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_146, true)).t2u($this, glVertexAttrib3fv$factory());
    var tmp_147 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_147 = Companion_getInstance_14().f2v_1;
    tmp_147.h8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_147, true)).t2u($this, glBindBufferRange$factory());
    var tmp_148 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_148 = Companion_getInstance_14().f2v_1;
    tmp_148.i8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false))]), false), null, config_148, true)).t2u($this, glGetUniformBlockIndex$factory());
    var tmp_149 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_149 = Companion_getInstance_14().f2v_1;
    tmp_149.j8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_149, true)).t2u($this, glUniformBlockBinding$factory());
    var tmp_150 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_150 = Companion_getInstance_14().f2v_1;
    tmp_150.k8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_150, true)).t2u($this, glGenVertexArrays$factory());
    var tmp_151 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_151 = Companion_getInstance_14().f2v_1;
    tmp_151.l8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_151, true)).t2u($this, glDeleteVertexArrays$factory());
    var tmp_152 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_152 = Companion_getInstance_14().f2v_1;
    tmp_152.m8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().wf(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_152, true)).t2u($this, glBindVertexArray$factory());
    return $this;
  }
  w8w() {
    return this.p8n_1.lo(this, glDrawArraysInstanced$factory_0());
  }
  x8w() {
    return this.q8n_1.lo(this, glDrawElementsInstanced$factory_0());
  }
  y8w() {
    return this.r8n_1.lo(this, glVertexAttribDivisor$factory_0());
  }
  f8x() {
    return this.s8n_1.lo(this, glTexSubImage2D$factory_0());
  }
  f8w() {
    return this.t8n_1.lo(this, glTexImage2D$factory_0());
  }
  g8w() {
    return this.u8n_1.lo(this, glTexParameteri$factory_0());
  }
  g8x() {
    return this.v8n_1.lo(this, glTexParameterf$factory_0());
  }
  h8x() {
    return this.w8n_1.lo(this, glTexParameterfv$factory_0());
  }
  i8x() {
    return this.x8n_1.lo(this, glTexParameteriv$factory_0());
  }
  d8w() {
    return this.y8n_1.lo(this, glStencilOp$factory_0());
  }
  b8w() {
    return this.z8n_1.lo(this, glStencilMask$factory_0());
  }
  j8x() {
    return this.a8o_1.lo(this, glReadPixels$factory_0());
  }
  z8v() {
    return this.b8o_1.lo(this, glStencilFunc$factory_0());
  }
  x8v() {
    return this.c8o_1.lo(this, glScissor$factory_0());
  }
  k8x() {
    return this.d8o_1.lo(this, glPolygonOffset$factory_0());
  }
  v8v() {
    return this.e8o_1.lo(this, glPixelStorei$factory_0());
  }
  l8x() {
    return this.f8o_1.lo(this, glLineWidth$factory_0());
  }
  m8x() {
    return this.g8o_1.lo(this, glGetTexParameterfv$factory_0());
  }
  n8x() {
    return this.h8o_1.lo(this, glGetTexParameteriv$factory_0());
  }
  o8v() {
    return this.i8o_1.lo(this, glGetError$factory_0());
  }
  o8x() {
    return this.j8o_1.lo(this, glGetFloatv$factory_0());
  }
  p8v() {
    return this.k8o_1.lo(this, glGetIntegerv$factory_0());
  }
  p8x() {
    return this.l8o_1.lo(this, glGetBooleanv$factory_0());
  }
  m8v() {
    return this.m8o_1.lo(this, glGenTextures$factory_0());
  }
  q8x() {
    return this.n8o_1.lo(this, glDepthRange$factory_0());
  }
  x8u() {
    return this.o8o_1.lo(this, glDepthRangef$factory_0());
  }
  r8x() {
    return this.p8o_1.lo(this, glClearDepth$factory_0());
  }
  i8u() {
    return this.q8o_1.lo(this, glClearDepthf$factory_0());
  }
  a8v() {
    return this.r8o_1.lo(this, glDrawArrays$factory_0());
  }
  b8v() {
    return this.s8o_1.lo(this, glDrawElements$factory_0());
  }
  h8v() {
    return this.t8o_1.lo(this, glFrontFace$factory_0());
  }
  s8x() {
    return this.u8o_1.lo(this, glFinish$factory_0());
  }
  e8v() {
    return this.v8o_1.lo(this, glFlush$factory_0());
  }
  c8v() {
    return this.w8o_1.lo(this, glEnable$factory_0());
  }
  t8x() {
    return this.x8o_1.lo(this, glIsEnabled$factory_0());
  }
  y8u() {
    return this.y8o_1.lo(this, glDisable$factory_0());
  }
  w8u() {
    return this.z8o_1.lo(this, glDepthMask$factory_0());
  }
  v8u() {
    return this.a8p_1.lo(this, glDepthFunc$factory_0());
  }
  u8u() {
    return this.b8p_1.lo(this, glDeleteTextures$factory_0());
  }
  o8u() {
    return this.c8p_1.lo(this, glCullFace$factory_0());
  }
  u8x() {
    return this.d8p_1.lo(this, glCopyTexImage2D$factory_0());
  }
  v8x() {
    return this.e8p_1.lo(this, glCopyTexSubImage2D$factory_0());
  }
  k8u() {
    return this.f8p_1.lo(this, glColorMask$factory_0());
  }
  j8u() {
    return this.g8p_1.lo(this, glClearStencil$factory_0());
  }
  h8u() {
    return this.h8p_1.lo(this, glClearColor$factory_0());
  }
  g8u() {
    return this.i8p_1.lo(this, glClear$factory_0());
  }
  b8u() {
    return this.j8p_1.lo(this, glBindTexture$factory_0());
  }
  w8x() {
    return this.k8p_1.lo(this, glHint$factory_0());
  }
  v8w() {
    return this.l8p_1.lo(this, glViewport$factory_0());
  }
  t8v() {
    return this.m8p_1.lo(this, glGetString$factory_0());
  }
  x8x() {
    return this.n8p_1.lo(this, glGetStringi$factory_0());
  }
  u8w() {
    return this.o8p_1.lo(this, glVertexAttribPointer$factory_0());
  }
  y8x() {
    return this.p8p_1.lo(this, glVertexAttrib4fv$factory_0());
  }
  v8t() {
    return this.q8p_1.lo(this, glActiveTexture$factory_0());
  }
  w8t() {
    return this.r8p_1.lo(this, glAttachShader$factory_0());
  }
  x8t() {
    return this.s8p_1.lo(this, glBindAttribLocation$factory_0());
  }
  y8t() {
    return this.t8p_1.lo(this, glBindBuffer$factory_0());
  }
  z8t() {
    return this.u8p_1.lo(this, glBindFramebuffer$factory_0());
  }
  a8u() {
    return this.v8p_1.lo(this, glBindRenderbuffer$factory_0());
  }
  z8x() {
    return this.w8p_1.lo(this, glBlendColor$factory_0());
  }
  a8y() {
    return this.x8p_1.lo(this, glBlendEquation$factory_0());
  }
  c8u() {
    return this.y8p_1.lo(this, glBlendEquationSeparate$factory_0());
  }
  b8y() {
    return this.z8p_1.lo(this, glBlendFunc$factory_0());
  }
  d8u() {
    return this.a8q_1.lo(this, glBlendFuncSeparate$factory_0());
  }
  e8u() {
    return this.b8q_1.lo(this, glBufferData$factory_0());
  }
  f8u() {
    return this.c8q_1.lo(this, glBufferSubData$factory_0());
  }
  c8y() {
    return this.d8q_1.lo(this, glCheckFramebufferStatus$factory_0());
  }
  l8u() {
    return this.e8q_1.lo(this, glCompileShader$factory_0());
  }
  d8y() {
    return this.f8q_1.lo(this, glCompressedTexImage2D$factory_0());
  }
  e8y() {
    return this.g8q_1.lo(this, glCompressedTexSubImage2D$factory_0());
  }
  m8u() {
    return this.h8q_1.lo(this, glCreateProgram$factory_0());
  }
  n8u() {
    return this.i8q_1.lo(this, glCreateShader$factory_0());
  }
  p8u() {
    return this.j8q_1.lo(this, glDeleteBuffers$factory_0());
  }
  q8u() {
    return this.k8q_1.lo(this, glDeleteFramebuffers$factory_0());
  }
  r8u() {
    return this.l8q_1.lo(this, glDeleteProgram$factory_0());
  }
  s8u() {
    return this.m8q_1.lo(this, glDeleteRenderbuffers$factory_0());
  }
  t8u() {
    return this.n8q_1.lo(this, glDeleteShader$factory_0());
  }
  f8y() {
    return this.o8q_1.lo(this, glDetachShader$factory_0());
  }
  z8u() {
    return this.p8q_1.lo(this, glDisableVertexAttribArray$factory_0());
  }
  d8v() {
    return this.q8q_1.lo(this, glEnableVertexAttribArray$factory_0());
  }
  f8v() {
    return this.r8q_1.lo(this, glFramebufferRenderbuffer$factory_0());
  }
  g8v() {
    return this.s8q_1.lo(this, glFramebufferTexture2D$factory_0());
  }
  i8v() {
    return this.t8q_1.lo(this, glGenBuffers$factory_0());
  }
  j8v() {
    return this.u8q_1.lo(this, glGenerateMipmap$factory_0());
  }
  k8v() {
    return this.v8q_1.lo(this, glGenFramebuffers$factory_0());
  }
  l8v() {
    return this.w8q_1.lo(this, glGenRenderbuffers$factory_0());
  }
  g8y() {
    return this.x8q_1.lo(this, glGetActiveAttrib$factory_0());
  }
  h8y() {
    return this.y8q_1.lo(this, glGetActiveUniform$factory_0());
  }
  i8y() {
    return this.z8q_1.lo(this, glGetAttachedShaders$factory_0());
  }
  j8y() {
    return this.a8r_1.lo(this, glGetAttribLocation$factory_0());
  }
  n8v() {
    return this.b8r_1.lo(this, glGetUniformLocation$factory_0());
  }
  k8y() {
    return this.c8r_1.lo(this, glGetBufferParameteriv$factory_0());
  }
  l8y() {
    return this.d8r_1.lo(this, glGetFramebufferAttachmentParameteriv$factory_0());
  }
  m8y() {
    return this.e8r_1.lo(this, glGetProgramInfoLog$factory_0());
  }
  n8y() {
    return this.f8r_1.lo(this, glGetRenderbufferParameteriv$factory_0());
  }
  q8v() {
    return this.g8r_1.lo(this, glGetProgramiv$factory_0());
  }
  r8v() {
    return this.h8r_1.lo(this, glGetShaderiv$factory_0());
  }
  s8v() {
    return this.i8r_1.lo(this, glGetShaderInfoLog$factory_0());
  }
  o8y() {
    return this.j8r_1.lo(this, glGetShaderPrecisionFormat$factory_0());
  }
  p8y() {
    return this.k8r_1.lo(this, glGetShaderSource$factory_0());
  }
  q8y() {
    return this.l8r_1.lo(this, glGetUniformfv$factory_0());
  }
  r8y() {
    return this.m8r_1.lo(this, glGetUniformiv$factory_0());
  }
  s8y() {
    return this.n8r_1.lo(this, glGetVertexAttribfv$factory_0());
  }
  t8y() {
    return this.o8r_1.lo(this, glGetVertexAttribiv$factory_0());
  }
  u8y() {
    return this.p8r_1.lo(this, glGetVertexAttribPointerv$factory_0());
  }
  v8y() {
    return this.q8r_1.lo(this, glIsBuffer$factory_0());
  }
  w8y() {
    return this.r8r_1.lo(this, glIsFramebuffer$factory_0());
  }
  x8y() {
    return this.s8r_1.lo(this, glIsProgram$factory_0());
  }
  y8y() {
    return this.t8r_1.lo(this, glIsRenderbuffer$factory_0());
  }
  z8y() {
    return this.u8r_1.lo(this, glIsTexture$factory_0());
  }
  a8z() {
    return this.v8r_1.lo(this, glIsShader$factory_0());
  }
  u8v() {
    return this.w8r_1.lo(this, glLinkProgram$factory_0());
  }
  b8z() {
    return this.x8r_1.lo(this, glReleaseShaderCompiler$factory_0());
  }
  w8v() {
    return this.y8r_1.lo(this, glRenderbufferStorage$factory_0());
  }
  c8z() {
    return this.z8r_1.lo(this, glSampleCoverage$factory_0());
  }
  d8z() {
    return this.a8s_1.lo(this, glShaderBinary$factory_0());
  }
  y8v() {
    return this.b8s_1.lo(this, glShaderSource$factory_0());
  }
  a8w() {
    return this.c8s_1.lo(this, glStencilFuncSeparate$factory_0());
  }
  c8w() {
    return this.d8s_1.lo(this, glStencilMaskSeparate$factory_0());
  }
  e8w() {
    return this.e8s_1.lo(this, glStencilOpSeparate$factory_0());
  }
  e8z() {
    return this.f8s_1.lo(this, glUniform1f$factory_0());
  }
  f8z() {
    return this.g8s_1.lo(this, glUniform2f$factory_0());
  }
  g8z() {
    return this.h8s_1.lo(this, glUniform3f$factory_0());
  }
  h8z() {
    return this.i8s_1.lo(this, glUniform4f$factory_0());
  }
  i8w() {
    return this.j8s_1.lo(this, glUniform1i$factory_0());
  }
  i8z() {
    return this.k8s_1.lo(this, glUniform2i$factory_0());
  }
  j8z() {
    return this.l8s_1.lo(this, glUniform3i$factory_0());
  }
  k8z() {
    return this.m8s_1.lo(this, glUniform4i$factory_0());
  }
  h8w() {
    return this.n8s_1.lo(this, glUniform1fv$factory_0());
  }
  k8w() {
    return this.o8s_1.lo(this, glUniform2fv$factory_0());
  }
  m8w() {
    return this.p8s_1.lo(this, glUniform3fv$factory_0());
  }
  o8w() {
    return this.q8s_1.lo(this, glUniform4fv$factory_0());
  }
  j8w() {
    return this.r8s_1.lo(this, glUniform1iv$factory_0());
  }
  l8w() {
    return this.s8s_1.lo(this, glUniform2iv$factory_0());
  }
  n8w() {
    return this.t8s_1.lo(this, glUniform3iv$factory_0());
  }
  p8w() {
    return this.u8s_1.lo(this, glUniform4iv$factory_0());
  }
  q8w() {
    return this.v8s_1.lo(this, glUniformMatrix2fv$factory_0());
  }
  r8w() {
    return this.w8s_1.lo(this, glUniformMatrix3fv$factory_0());
  }
  s8w() {
    return this.x8s_1.lo(this, glUniformMatrix4fv$factory_0());
  }
  t8w() {
    return this.y8s_1.lo(this, glUseProgram$factory_0());
  }
  l8z() {
    return this.z8s_1.lo(this, glValidateProgram$factory_0());
  }
  m8z() {
    return this.a8t_1.lo(this, glVertexAttrib1f$factory_0());
  }
  n8z() {
    return this.b8t_1.lo(this, glVertexAttrib2f$factory_0());
  }
  o8z() {
    return this.c8t_1.lo(this, glVertexAttrib3f$factory_0());
  }
  p8z() {
    return this.d8t_1.lo(this, glVertexAttrib4f$factory_0());
  }
  q8z() {
    return this.e8t_1.lo(this, glVertexAttrib1fv$factory_0());
  }
  r8z() {
    return this.f8t_1.lo(this, glVertexAttrib2fv$factory_0());
  }
  s8z() {
    return this.g8t_1.lo(this, glVertexAttrib3fv$factory_0());
  }
  z8w() {
    return this.h8t_1.lo(this, glBindBufferRange$factory_0());
  }
  a8x() {
    return this.i8t_1.lo(this, glGetUniformBlockIndex$factory_0());
  }
  b8x() {
    return this.j8t_1.lo(this, glUniformBlockBinding$factory_0());
  }
  c8x() {
    return this.k8t_1.lo(this, glGenVertexArrays$factory_0());
  }
  t8z() {
    return this.l8t_1.lo(this, glDeleteVertexArrays$factory_0());
  }
  d8x() {
    return this.m8t_1.lo(this, glBindVertexArray$factory_0());
  }
}
class SDLGameWindow$ag$1 extends KmlGlContext {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.x8z_1 = this$0;
    super(this$0.m92_1, new KmlGlOpenGL(), VOID, $box);
  }
  d77() {
    var tmp = this.x8z_1.l92_1.i8n();
    var tmp_0 = this.w75_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), this.x8z_1.n92_1);
  }
  f77() {
    var tmp = this.x8z_1.l92_1.i8n();
    var tmp_0 = this.w75_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), null);
  }
  c6() {
    this.x8z_1.l92_1.h8n()(this.x8z_1.n92_1);
  }
}
class SDLGameWindow extends GameWindow {
  static s92(size, config) {
    size = size === VOID ? Size2D.l26(640, 480) : size;
    config = config === VOID ? Companion_getInstance_75().m8k_1 : config;
    var $this = this.g8i();
    $this.j92_1 = size;
    $this.k92_1 = config;
    $this.l92_1 = SDL.w8m();
    $this.m92_1 = $this.l92_1.y8m()($this.k92_1.x8k_1, 805240832, 805240832, numberToInt($this.j92_1.j26_1), numberToInt($this.j92_1.k26_1), 34);
    $this.n92_1 = $this.l92_1.g8n()($this.m92_1);
    $this.l92_1.c8n()($this.m92_1);
    var tmp = $this;
    tmp.o92_1 = AGOpengl.v75(new SDLGameWindow$ag$1($this));
    $this.p92_1 = $this.b8j().k70_1;
    $this.q92_1 = '';
    $this.r92_1 = CreateFFIMemory(1024);
    return $this;
  }
  b8j() {
    return this.o92_1;
  }
  i8j(value) {
    this.q92_1 = value;
    this.l92_1.z8m()(this.m92_1, this.t92());
  }
  t92() {
    return this.q92_1;
  }
  r8j(width, height) {
    this.l92_1.a8n()(this.m92_1, width, height);
    this.l92_1.b8n()(this.m92_1, 805240832, 805240832);
  }
  u92() {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = this.r92_1;
    var it = get_pointer(Deno.UnsafePointer.of(this_0));
    while (this.l92_1.e8n()(it)) {
      var type = getS32(it, 0);
      switch (type) {
        case 512:
          println('WINDOW EVENT');
          break;
        case 1024:
          println('MOUSE MOTION');
          break;
        case 1025:
          println('MOUSE DOWN');
          break;
        case 1026:
          println('MOUSE UP');
          break;
        case 256:
          this.u8j();
          break;
        default:
          println('EVENT: type=' + type);
          break;
      }
    }
    this.l92_1.i8n()(this.m92_1, this.n92_1);
    this.p92_1.e76(1.0, 0.0, 0.0, 1.0);
    this.p92_1.j76(16384);
  }
  v92() {
    this.l92_1.j8n()(this.m92_1);
  }
  a1d(exitCode) {
    super.a1d(exitCode);
    this.l92_1.h8n()(this.n92_1);
    this.l92_1.f8n()();
  }
}
class Size3D {
  constructor(width, height, depthOrArrayLayers) {
    height = height === VOID ? 1 : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? 1 : depthOrArrayLayers;
    this.width = width;
    this.height = height;
    this.depthOrArrayLayers = depthOrArrayLayers;
  }
  p85(_set____db54di) {
    this.width = _set____db54di;
  }
  m2i() {
    return this.width;
  }
  q85(_set____db54di) {
    this.height = _set____db54di;
  }
  n2i() {
    return this.height;
  }
  w92(_set____db54di) {
    this.depthOrArrayLayers = _set____db54di;
  }
  x92() {
    return this.depthOrArrayLayers;
  }
  toArray() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.width, this.height, this.depthOrArrayLayers];
  }
  fl() {
    return this.width;
  }
  gl() {
    return this.height;
  }
  pr() {
    return this.depthOrArrayLayers;
  }
  y92(width, height, depthOrArrayLayers) {
    return new Size3D(width, height, depthOrArrayLayers);
  }
  copy(width, height, depthOrArrayLayers, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? this.depthOrArrayLayers : depthOrArrayLayers;
    return this.y92(width, height, depthOrArrayLayers);
  }
  toString() {
    return 'Size3D(width=' + this.width + ', height=' + this.height + ', depthOrArrayLayers=' + this.depthOrArrayLayers + ')';
  }
  hashCode() {
    var result = this.width;
    result = imul(result, 31) + this.height | 0;
    result = imul(result, 31) + this.depthOrArrayLayers | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size3D))
      return false;
    var tmp0_other_with_cast = other instanceof Size3D ? other : THROW_CCE();
    if (!(this.width === tmp0_other_with_cast.width))
      return false;
    if (!(this.height === tmp0_other_with_cast.height))
      return false;
    if (!(this.depthOrArrayLayers === tmp0_other_with_cast.depthOrArrayLayers))
      return false;
    return true;
  }
}
class AGOpenglFactory {
  g84() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.d93_1 = canvas;
    this.e93_1 = glOpts;
    this.f93_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp1_safe_receiver = this.d93_1.getContext('webgl2', this.e93_1);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.f93_1 = 2;
        tmp_1 = tmp1_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.d93_1.getContext('webgl', this.e93_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.d93_1.getContext('experimental-webgl', this.e93_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.f93_1 + ', opts=' + JSON.stringify(this.e93_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      try {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException.w4(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.g93_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.h93_1 = fillArrayVal(Array(8192), null);
    this.i93_1 = toMutableList(reversed_0(until(1, this.h93_1.length)));
    var tmp_7 = this;
    tmp_7.j93_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.k93_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.l93_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.m93_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  g75() {
    return Companion_instance_54.s7c(this.f93_1);
  }
  f75(texture) {
    return this.g93_1.activeTexture(texture);
  }
  k79(program, shader) {
    return this.g93_1.attachShader(get_2(program, this), get_2(shader, this));
  }
  j79(program, index, name) {
    return this.g93_1.bindAttribLocation(get_2(program, this), index, name);
  }
  z73(target, buffer) {
    return this.g93_1.bindBuffer(target, get_2(buffer, this));
  }
  c78(target, framebuffer) {
    return this.g93_1.bindFramebuffer(target, get_2(framebuffer, this));
  }
  j78(target, renderbuffer) {
    return this.g93_1.bindRenderbuffer(target, get_2(renderbuffer, this));
  }
  a78(target, texture) {
    return this.g93_1.bindTexture(target, get_2(texture, this));
  }
  n76(modeRGB, modeAlpha) {
    return this.g93_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  o76(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.g93_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  j75(target, size, data, usage) {
    return this.g93_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  i75(target, offset, size, data) {
    return this.g93_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  j76(mask) {
    return this.g93_1.clear(mask);
  }
  e76(red, green, blue, alpha) {
    return this.g93_1.clearColor(red, green, blue, alpha);
  }
  g76(d) {
    return this.g93_1.clearDepth(d);
  }
  i76(s) {
    return this.g93_1.clearStencil(s);
  }
  q78(red, green, blue, alpha) {
    return this.g93_1.colorMask(red, green, blue, alpha);
  }
  b79(shader) {
    return this.g93_1.compileShader(get_2(shader, this));
  }
  d79() {
    return alloc(this.g93_1.createProgram(), this);
  }
  z78(type) {
    return alloc(this.g93_1.createShader(type), this);
  }
  g77(mode) {
    return this.g93_1.cullFace(mode);
  }
  l7y(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.g93_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  m7y(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.g93_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  y78(program) {
    return this.g93_1.deleteProgram(get_2(program, this));
  }
  n7y(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.g93_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  x78(shader) {
    return this.g93_1.deleteShader(get_2(shader, this));
  }
  o7y(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.g93_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  p78(func) {
    return this.g93_1.depthFunc(func);
  }
  f76(flag) {
    return this.g93_1.depthMask(flag);
  }
  o78(n, f) {
    return this.g93_1.depthRange(n, f);
  }
  s76(cap) {
    return this.g93_1.disable(cap);
  }
  i77(index) {
    return this.g93_1.disableVertexAttribArray(index);
  }
  z76(mode, first, count) {
    return this.g93_1.drawArrays(mode, first, count);
  }
  b77(mode, count, type, indices) {
    return this.g93_1.drawElements(mode, count, type, indices);
  }
  t76(cap) {
    return this.g93_1.enable(cap);
  }
  m77(index) {
    return this.g93_1.enableVertexAttribArray(index);
  }
  lc() {
    return this.g93_1.flush();
  }
  m78(target, attachment, renderbuffertarget, renderbuffer) {
    return this.g93_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_2(renderbuffer, this));
  }
  l78(target, attachment, textarget, texture, level) {
    return this.g93_1.framebufferTexture2D(target, attachment, textarget, get_2(texture, this), level);
  }
  n78(mode) {
    return this.g93_1.frontFace(mode);
  }
  p7y(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.g93_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  }
  n75(target) {
    return this.g93_1.generateMipmap(target);
  }
  q7y(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.g93_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  }
  r7y(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.g93_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  }
  s7y(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.g93_1.createTexture(), this);
      }
       while (inductionVariable < n);
  }
  v78(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_2(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this.g93_1.getUniformLocation(prg, name), this);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  c79() {
    return this.g93_1.getError();
  }
  t7y(pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.g93_1.getParameter(pname);
  }
  u7y(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.g93_1.getProgramInfoLog(get_2(program, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.g93_1.getProgramParameter(get_2(program, this), pname);
    }
  }
  v7y(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.g93_1.getShaderInfoLog(get_2(shader, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.g93_1.getShaderParameter(get_2(shader, this), pname);
    }
  }
  w7y(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.g93_1.getShaderInfoLog(get_2(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  u71(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.g93_1.getParameter(name);
  }
  l79(program) {
    return this.g93_1.linkProgram(get_2(program, this));
  }
  k75(pname, param) {
    return this.g93_1.pixelStorei(pname, param);
  }
  k78(target, internalformat, width, height) {
    return this.g93_1.renderbufferStorage(target, internalformat, width, height);
  }
  r78(x, y, width, height) {
    return this.g93_1.scissor(x, y, width, height);
  }
  a79(shader, string) {
    return this.g93_1.shaderSource(get_2(shader, this), string);
  }
  v76(func, ref, mask) {
    return this.g93_1.stencilFunc(func, ref, mask);
  }
  u76(face, func, ref, mask) {
    return this.g93_1.stencilFuncSeparate(face, func, ref, mask);
  }
  h76(mask) {
    return this.g93_1.stencilMask(mask);
  }
  y76(face, mask) {
    return this.g93_1.stencilMaskSeparate(face, mask);
  }
  x76(fail, zfail, zpass) {
    return this.g93_1.stencilOp(fail, zfail, zpass);
  }
  w76(face, sfail, dpfail, dppass) {
    return this.g93_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  l75(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.g93_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  m75(target, level, internalformat, format, type, data) {
    if (data instanceof HtmlNativeImage) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = !data.s3x_1 && data.r3x_1 ? 1 : 0;
      this.g93_1.pixelStorei(37441, tmp$ret$0);
      this.g93_1.texImage2D(target, level, internalformat, format, type, data.m61_1);
      this.g93_1.pixelStorei(37441, 0);
    } else {
      return super.m75(target, level, internalformat, format, type, data);
    }
  }
  e75(target, pname, param) {
    return this.g93_1.texParameteri(target, pname, param);
  }
  a75(location, count, value) {
    return this.g93_1.uniform1fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  y72(location, v0) {
    return this.g93_1.uniform1i(get_2(location, this), v0);
  }
  t74(location, count, value) {
    return this.g93_1.uniform1iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  b75(location, count, value) {
    return this.g93_1.uniform2fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  u74(location, count, value) {
    return this.g93_1.uniform2iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  c75(location, count, value) {
    return this.g93_1.uniform3fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  v74(location, count, value) {
    return this.g93_1.uniform3iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  d75(location, count, value) {
    return this.g93_1.uniform4fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  w74(location, count, value) {
    return this.g93_1.uniform4iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  x74(location, count, transpose, value) {
    return this.g93_1.uniformMatrix2fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  y74(location, count, transpose, value) {
    return this.g93_1.uniformMatrix3fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  z74(location, count, transpose, value) {
    return this.g93_1.uniformMatrix4fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  w78(program) {
    return this.g93_1.useProgram(get_2(program, this));
  }
  n77(index, size, type, normalized, stride, pointer) {
    return this.g93_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.i2());
  }
  b78(x, y, width, height) {
    return this.g93_1.viewport(x, y, width, height);
  }
  k7y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j93_1;
    extensions$factory();
    return this_0.r1();
  }
  a77(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.g93_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  c77(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.g93_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  h77(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.g93_1.vertexAttribDivisor(index, divisor);
  }
  i6g() {
    return get_versionInt(this) >= 2;
  }
  u77(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.g93_1.bindBufferRange(target, index, get_2(buffer, this), offset, size);
  }
  z72(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.g93_1.getUniformBlockIndex(get_2(program, this), name);
  }
  a73(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.g93_1.uniformBlockBinding(get_2(program, this), uniformBlockIndex, uniformBlockBinding);
  }
  j6g() {
    return this.m93_1.u93();
  }
  x7y(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.g93_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  j77(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.g93_1.bindVertexArray(get_2(array, this));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.n93_1 = canvas;
    this.o93_1 = name;
    this.p93_1 = coreSince;
    this.q93_1 = functions;
    this.r93_1 = suffix;
    this.s93_1 = false;
    this.t93_1 = null;
  }
  r1() {
    if (!this.s93_1) {
      this.s93_1 = true;
      this.t93_1 = this.n93_1.g93_1.getExtension(this.o93_1);
      var _iterator__ex2g4s = this.q93_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var func = _iterator__ex2g4s.c1();
        var base = removeSuffix(func, this.r93_1);
        var vfunc = this.t93_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.n93_1.g93_1[base] = vfunc.bind(this.t93_1);
        }
      }
    }
    return this.t93_1;
  }
  u93() {
    return this.n93_1.f93_1 >= this.p93_1 || this.r1() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class JsGameWindow extends GameWindow {
  static o9e() {
    return this.g8i();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  static h99() {
    return this.o9e();
  }
}
class BrowserCanvasJsGameWindow$close$slambda {
  constructor(this$0) {
    this.p9e_1 = this$0;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.q9e_1 = $entry;
    this.r9e_1 = this$0;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  static v96(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.o9e();
    $this.g96_1 = canvas;
    $this.h96_1 = AGWebgl(new AGConfig(), $this.g96_1);
    $this.i96_1 = new DialogInterfaceJs();
    $this.j96_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k96_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.l96_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.m96_1 = new GamepadInfo();
    $this.n96_1 = Quality_AUTOMATIC_getInstance();
    $this.o96_1 = 1.0;
    $this.p96_1 = new TouchBuilder();
    $this.q96_1 = Cursor_DEFAULT_getInstance();
    $this.r96_1 = null;
    $this.s96_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.g96_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.b8j();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.b8j().k70_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($this.g96_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.g96_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.g96_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.g96_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.g96_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.g96_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.g96_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.g96_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.g96_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.g96_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.g96_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.g96_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.g96_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.g96_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.g96_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.g96_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.g96_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.g96_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.g96_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.g96_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.t96_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.u96_1 = null;
    return $this;
  }
  t9e() {
    return window.devicePixelRatio;
  }
  p8b() {
    return this.t9e() <= 0.0 ? 1.0 : isNaN_0(this.t9e()) ? 1.0 : isInfinite(this.t9e()) ? 1.0 : this.t9e();
  }
  b8j() {
    return this.h96_1;
  }
  s9e() {
    if (this.j96_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.j96_1 = tmp_0;
    }
    return ensureNotNull(this.j96_1);
  }
  f8k() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.i6c();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.m96_1;
            gamepad.p6c_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.k96_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.q6c_1;
                var tmp_1 = this.k96_1[n].m6d();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.l96_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_24.h6d(value, VOID, n_0 <= 3);
                gamepad.q6c_1[this.l96_1[n_0].m6d()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.u6c(gamepad);
          }
           while (inductionVariable < last);
        this.j8k();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().f8f_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.j2t(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.k2t(level, e);
        tmp_2 = Unit_instance;
      }
    }
  }
  o8j(value) {
    if (!this.n96_1.equals(value)) {
      this.n96_1 = value;
      onResized(this);
    }
  }
  x8a() {
    return this.n96_1;
  }
  i8j(value) {
    document.title = value;
  }
  m2i() {
    return this.g96_1.clientWidth;
  }
  n2i() {
    return this.g96_1.clientHeight;
  }
  z8i(value) {
    this.q96_1 = value;
    var tmp = this.g96_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.n3_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  a8j() {
    return this.q96_1;
  }
  j8j(value) {
    this.r96_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).c62();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  }
  k8j(value) {
    if (!(this.u9e() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.g96_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  u9e() {
    return !(document.fullscreenElement == null);
  }
  l8j(value) {
    this.g96_1.style.visibility = value ? 'visible' : 'hidden';
  }
  r8j(width, height) {
  }
  a1d(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this));
    this.s96_1 = null;
  }
  w8j(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_0.bind(VOID, this, entry), $completion);
  }
  k8k(data, $completion) {
    try {
      var tmp = _get_navigatorClipboard__ni2gks(this);
      tmp.writeText((data instanceof TextClipboardData ? data : THROW_CCE()).a8l_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        console.error('Failed to write to clipboard: ' + e.message);
      } else {
        throw $p;
      }
    }
  }
  l8k($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_clipboardRead__wie2ug.bind(VOID, this), $completion);
  }
  v8i(windowRect) {
    ensureSoftKeyboardInput(this);
    var tmp0_safe_receiver = this.u96_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.style;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp1_safe_receiver.left = '' + windowRect.v25() / this.o96_1 + 'px';
      tmp1_safe_receiver.top = '' + (windowRect.x25() / this.o96_1 - 16) + 'px';
      tmp1_safe_receiver.width = '' + windowRect.q25_1 / this.o96_1 + 'px';
      tmp1_safe_receiver.font = '32px Arial';
      tmp1_safe_receiver.height = '1px';
      tmp1_safe_receiver.opacity = '0';
      tmp1_safe_receiver.background = 'transparent';
      tmp1_safe_receiver.color = 'transparent';
      println('BOUNDS.setInputRectangle:' + tmp1_safe_receiver.left + ',' + tmp1_safe_receiver.top + ',' + tmp1_safe_receiver.width + ',' + tmp1_safe_receiver.height);
    }
  }
  w8i(force, config) {
    var tmp0_safe_receiver = document.body;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.appendChild(ensureNotNull(this.u96_1));
    var tmp1_safe_receiver = this.u96_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.focus();
    }
  }
  y8i() {
    var tmp0_safe_receiver = this.u96_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.blur();
    }
    var tmp1_safe_receiver = document.body;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.removeChild(ensureNotNull(this.u96_1));
  }
}
class DenoJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.v9e_1 = $entry;
    this.w9e_1 = this$0;
  }
  pd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class DenoJsGameWindow extends SDLGameWindow {
  static c9c(size, config) {
    size = size === VOID ? Size2D.l26(640, 480) : size;
    config = config === VOID ? Companion_getInstance_75().m8k_1 : config;
    return this.s92(size, config);
  }
  w8j(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_1.bind(VOID, this, entry), $completion);
  }
  a1d(exitCode) {
    super.a1d(exitCode);
    Deno.exit(exitCode);
  }
}
class DialogInterfaceJs {}
//endregion
function _get_now__e6dlkr($this) {
  return $this.p65_1().kj_1;
}
function _queueAfter($this, time, interval, task) {
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  var this_0 = $this.m65_1;
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.d1v();
    try {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop._queueAfter.<anonymous>' call
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.n65_1) {
        $this.r65_1.u2l(task_0);
      } else {
        Console_getInstance().p2s(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.m65_1.h1v();
      break $l$block;
    }finally {
      this_0.f1v();
    }
  }
  return task_0;
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return function () {
    return new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.o65_1));
  };
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.h65(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function paused$factory($b0) {
  return getPropertyCallableRef('paused', 0, KMutableProperty0, function () {
    return $b0.x2q_1;
  }, function (value) {
    return $b0.y2q(value);
  });
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.l66_1 == null)
    $this.l66_1 = FastIdentityMap();
  var tmp0_safe_receiver = $this.l66_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_elvis_lhs = get_0(ensureNotNull($this.l66_1), type);
    set(tmp0_safe_receiver, type, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + delta | 0);
  }
  var tmp2_safe_receiver = $this.j66_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp2_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp0_safe_receiver = child.l66_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp0_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
      var i = ensureNotNull(get_0(tmp0_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Companion_instance_8;
function Companion_getInstance_15() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_16() {
  return Companion_instance_9;
}
var Companion_instance_10;
function Companion_getInstance_17() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_18() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_19() {
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_20() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_21() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_22() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_23() {
  return Companion_instance_16;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_17;
function Companion_getInstance_24() {
  Type_initEntries();
  if (Companion_instance_17 === VOID)
    new Companion_8();
  return Companion_instance_17;
}
function values() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_UP_instance = new Type('UP', 0);
  Type_DOWN_instance = new Type('DOWN', 1);
  Type_TYPE_instance = new Type('TYPE', 2);
  Companion_getInstance_24();
}
function Type_UP_getInstance() {
  Type_initEntries();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_18;
function Companion_getInstance_25() {
  Type_initEntries_0();
  if (Companion_instance_18 === VOID)
    new Companion_9();
  return Companion_instance_18;
}
function values_0() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_MOVE_instance = new Type_0('MOVE', 0);
  Type_DRAG_instance = new Type_0('DRAG', 1);
  Type_UP_instance_0 = new Type_0('UP', 2);
  Type_DOWN_instance_0 = new Type_0('DOWN', 3);
  Type_CLICK_instance = new Type_0('CLICK', 4);
  Type_ENTER_instance = new Type_0('ENTER', 5);
  Type_EXIT_instance = new Type_0('EXIT', 6);
  Type_SCROLL_instance = new Type_0('SCROLL', 7);
  Companion_getInstance_25();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_0();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_0();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_0();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_0();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_0();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_0();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_0();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_0();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_19;
function Companion_getInstance_26() {
  Type_initEntries_1();
  if (Companion_instance_19 === VOID)
    new Companion_10();
  return Companion_instance_19;
}
function values_1() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MAGNIFY_instance = new Type_1('MAGNIFY', 0);
  Type_ROTATE_instance = new Type_1('ROTATE', 1);
  Type_SWIPE_instance = new Type_1('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type_1('SMART_MAGNIFY', 3);
  Companion_getInstance_26();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries_1();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries_1();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_SMART_MAGNIFY_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_DROP_instance;
var Companion_instance_20;
function Companion_getInstance_27() {
  Type_initEntries_2();
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_DROP_instance = new Type_2('DROP', 2);
  Companion_getInstance_27();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_DROP_getInstance() {
  Type_initEntries_2();
  return Type_DROP_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_21;
function Companion_getInstance_28() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_22;
function Companion_getInstance_29() {
  Type_initEntries_3();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_MOVE_instance_0 = new Type_3('MOVE', 2);
  Type_HOVER_instance = new Type_3('HOVER', 3);
  Type_UNKNOWN_instance = new Type_3('UNKNOWN', 4);
  Companion_getInstance_29();
}
var Companion_instance_23;
function Companion_getInstance_30() {
  return Companion_instance_23;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_3();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_3();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_3();
  return Type_UNKNOWN_instance;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_24;
function Companion_getInstance_31() {
  return Companion_instance_24;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Companion_instance_25;
function Companion_getInstance_32() {
  return Companion_instance_25;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_33() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_33();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_34() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_34();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_35() {
  Key_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_35();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_29;
function Companion_getInstance_36() {
  MouseButton_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
function values_6() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_36();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var SoftKeyboardType_DEFAULT_instance;
var SoftKeyboardType_ASCII_CAPABLE_instance;
var SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance;
var SoftKeyboardType_URL_instance;
var SoftKeyboardType_NUMBER_PAD_instance;
var SoftKeyboardType_PHONE_PAD_instance;
var SoftKeyboardType_NAME_PHONE_PAD_instance;
var SoftKeyboardType_EMAIL_ADDRESS_instance;
var SoftKeyboardType_DECIMAL_PAD_instance;
var SoftKeyboardType_TWITTER_instance;
var SoftKeyboardType_WEB_SEARCH_instance;
var SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance;
var SoftKeyboardType_ALPHABET_instance;
var SoftKeyboardType_entriesInitialized;
function SoftKeyboardType_initEntries() {
  if (SoftKeyboardType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardType_entriesInitialized = true;
  SoftKeyboardType_DEFAULT_instance = new SoftKeyboardType('DEFAULT', 0);
  SoftKeyboardType_ASCII_CAPABLE_instance = new SoftKeyboardType('ASCII_CAPABLE', 1);
  SoftKeyboardType_NUMBERS_AND_PUNCTUATION_instance = new SoftKeyboardType('NUMBERS_AND_PUNCTUATION', 2);
  SoftKeyboardType_URL_instance = new SoftKeyboardType('URL', 3);
  SoftKeyboardType_NUMBER_PAD_instance = new SoftKeyboardType('NUMBER_PAD', 4);
  SoftKeyboardType_PHONE_PAD_instance = new SoftKeyboardType('PHONE_PAD', 5);
  SoftKeyboardType_NAME_PHONE_PAD_instance = new SoftKeyboardType('NAME_PHONE_PAD', 6);
  SoftKeyboardType_EMAIL_ADDRESS_instance = new SoftKeyboardType('EMAIL_ADDRESS', 7);
  SoftKeyboardType_DECIMAL_PAD_instance = new SoftKeyboardType('DECIMAL_PAD', 8);
  SoftKeyboardType_TWITTER_instance = new SoftKeyboardType('TWITTER', 9);
  SoftKeyboardType_WEB_SEARCH_instance = new SoftKeyboardType('WEB_SEARCH', 10);
  SoftKeyboardType_ASCII_CAPABLE_NUMBER_PAD_instance = new SoftKeyboardType('ASCII_CAPABLE_NUMBER_PAD', 11);
  SoftKeyboardType_ALPHABET_instance = new SoftKeyboardType('ALPHABET', 12);
}
var SoftKeyboardReturnKeyType_DEFAULT_instance;
var SoftKeyboardReturnKeyType_GO_instance;
var SoftKeyboardReturnKeyType_JOIN_instance;
var SoftKeyboardReturnKeyType_NEXT_instance;
var SoftKeyboardReturnKeyType_ROUTE_instance;
var SoftKeyboardReturnKeyType_SEARCH_instance;
var SoftKeyboardReturnKeyType_DONE_instance;
var SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance;
var SoftKeyboardReturnKeyType_CONTINUE_instance;
var SoftKeyboardReturnKeyType_entriesInitialized;
function SoftKeyboardReturnKeyType_initEntries() {
  if (SoftKeyboardReturnKeyType_entriesInitialized)
    return Unit_instance;
  SoftKeyboardReturnKeyType_entriesInitialized = true;
  SoftKeyboardReturnKeyType_DEFAULT_instance = new SoftKeyboardReturnKeyType('DEFAULT', 0);
  SoftKeyboardReturnKeyType_GO_instance = new SoftKeyboardReturnKeyType('GO', 1);
  SoftKeyboardReturnKeyType_JOIN_instance = new SoftKeyboardReturnKeyType('JOIN', 2);
  SoftKeyboardReturnKeyType_NEXT_instance = new SoftKeyboardReturnKeyType('NEXT', 3);
  SoftKeyboardReturnKeyType_ROUTE_instance = new SoftKeyboardReturnKeyType('ROUTE', 4);
  SoftKeyboardReturnKeyType_SEARCH_instance = new SoftKeyboardReturnKeyType('SEARCH', 5);
  SoftKeyboardReturnKeyType_DONE_instance = new SoftKeyboardReturnKeyType('DONE', 6);
  SoftKeyboardReturnKeyType_EMERGENCY_CALL_instance = new SoftKeyboardReturnKeyType('EMERGENCY_CALL', 7);
  SoftKeyboardReturnKeyType_CONTINUE_instance = new SoftKeyboardReturnKeyType('CONTINUE', 8);
}
function SoftKeyboardType_DEFAULT_getInstance() {
  SoftKeyboardType_initEntries();
  return SoftKeyboardType_DEFAULT_instance;
}
function SoftKeyboardReturnKeyType_DEFAULT_getInstance() {
  SoftKeyboardReturnKeyType_initEntries();
  return SoftKeyboardReturnKeyType_DEFAULT_instance;
}
var Companion_instance_30;
function Companion_getInstance_37() {
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_42().m6g_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_43().q6g_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_59().u6g_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_31.w6g() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_46().y6g_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_47().a6h_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_48().e6h_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_49().i6h_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_44().m6h_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_50().o6h_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.g6g(frameBuffer.m6f_1, frameBuffer.s6h(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function draw_0(_this__u8e3s4, batch) {
  return batch.b6i(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, batch) {
  return batch.b6i(_this__u8e3s4);
}
function upload($this, data, needClone) {
  var tmp0_safe_receiver = $this.z6i_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j12()) === data.j12()) {
    if (data.j12() < 1024 && Companion_instance_4.b12(data, 0, ensureNotNull($this.z6i_1), 0, data.j12())) {
      return $this;
    }
    Companion_instance_4.a12(data, 0, ensureNotNull($this.z6i_1), 0, data.j12());
  } else {
    $this.z6i_1 = needClone ? clone(data) : data;
  }
  $this.e6j();
  return $this;
}
var Companion_instance_31;
function Companion_getInstance_38() {
  return Companion_instance_31;
}
var Companion_instance_32;
function Companion_getInstance_39() {
  return Companion_instance_32;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.r3x_1) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.c6l_1;
    var level = Level_ERROR_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
      var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_40().g6k_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_40().m6m(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_33;
function Companion_getInstance_40() {
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function AGTextureUnitInfo__toString_impl_7im6je($this) {
  return 'AGTextureUnitInfo(wrap=' + AGWrapMode__toString_impl_8bjnw2(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + AGTextureTargetKind__toString_impl_68648p(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
}
function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
  return $this;
}
function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
  if (!(other instanceof AGTextureUnitInfo))
    return false;
  if (!($this === (other instanceof AGTextureUnitInfo ? other.s6m_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_34;
function Companion_getInstance_41() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_41().l6p_1 ? 'POINTS' : $this === Companion_getInstance_41().m6p_1 ? 'LINE_STRIP' : $this === Companion_getInstance_41().n6p_1 ? 'LINE_LOOP' : $this === Companion_getInstance_41().o6p_1 ? 'LINES' : $this === Companion_getInstance_41().p6p_1 ? 'TRIANGLES' : $this === Companion_getInstance_41().q6p_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_41().r6p_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function AGDrawType__equals_impl_rtafo6($this, other) {
  if (!(other instanceof AGDrawType))
    return false;
  if (!($this === (other instanceof AGDrawType ? other.s6p_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
var Companion_instance_35;
function Companion_getInstance_42() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_42().k6g_1 ? 'null' : $this === Companion_getInstance_42().l6g_1 ? 'UBYTE' : $this === Companion_getInstance_42().m6g_1 ? 'USHORT' : $this === Companion_getInstance_42().n6g_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).u6p.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).t6p_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).v6p.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).t6p_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).w6p.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).t6p_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_43().p6g_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_36;
function Companion_getInstance_43() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.t6p_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_44() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(data).f4(new Long(-1, 0)).g4(toLong(data2).c4(32));
  return _AGFrameBufferInfo___init__impl__dbxiro(tmp$ret$0);
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_48.b6r(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_38;
function Companion_getInstance_45() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(front).f4(new Long(-1, 0)).g4(toLong(back).c4(32));
  return _AGStencilReference___init__impl__rta8vg(tmp$ret$0);
}
var Companion_instance_39;
function Companion_getInstance_46() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).n6r.call(new AGStencilReference($this), referenceValue, referenceValueBack).m6r_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).o6r.call(new AGStencilReference($this), readMask, readMaskBack).m6r_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).p6r.call(new AGStencilReference($this), writeMask, writeMaskBack).m6r_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.m6r_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_40;
function Companion_getInstance_47() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).h6s.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).g6s_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).i6s.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).g6s_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).j6s.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).g6s_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.g6s_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
  this_0.ob('AGColorMask(');
  this_0.ob(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.ob(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.ob(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.ob(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.ob(')');
  return this_0.toString();
}
var Companion_instance_41;
function Companion_getInstance_48() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function AGColorMask__equals_impl_mrih8l($this, other) {
  if (!(other instanceof AGColorMask))
    return false;
  if (!($this === (other instanceof AGColorMask ? other.k6s_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_42;
function Companion_getInstance_49() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_43;
function Companion_getInstance_50() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_50().o6h_1 ? 'NONE' : $this === Companion_getInstance_50().r6h_1 ? 'BOTH' : $this === Companion_getInstance_50().p6h_1 ? 'FRONT' : $this === Companion_getInstance_50().q6h_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function AGCullFace__equals_impl_wgngjr($this, other) {
  if (!(other instanceof AGCullFace))
    return false;
  if (!($this === (other instanceof AGCullFace ? other.o6s_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_51().o6l_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_51().p6l_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_51().q6l_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_51().r6l_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_51().o6l_1 ? 2 : $this === Companion_getInstance_51().p6l_1 ? 3 : $this === Companion_getInstance_51().q6l_1 ? 3 : $this === Companion_getInstance_51().r6l_1 ? 3 : 0;
}
var Companion_instance_44;
function Companion_getInstance_51() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.t6l_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_45;
function Companion_getInstance_52() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_52().n6m_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_52().o6m_1 ? 'REPEAT' : $this === Companion_getInstance_52().p6m_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.k6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_46;
function Companion_getInstance_53() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_53().x6p_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_53().y6p_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_53().z6p_1 ? 'ONE' : $this === Companion_getInstance_53().a6q_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_53().b6q_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_53().c6q_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_53().d6q_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_53().e6q_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_53().f6q_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_53().g6q_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_53().x6p_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_53().y6p_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_53().z6p_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_53().a6q_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_53().b6q_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_53().c6q_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_53().d6q_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_53().e6q_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_53().f6q_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_53().g6q_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.l6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_47;
function Companion_getInstance_54() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_54().k6q_1 ? 'ADD' : $this === Companion_getInstance_54().l6q_1 ? 'SUBTRACT' : $this === Companion_getInstance_54().m6q_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_54().k6q_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_54().l6q_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_54().m6q_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.m6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_48;
function Companion_getInstance_55() {
  return Companion_instance_48;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_49;
function Companion_getInstance_56() {
  if (Companion_instance_49 === VOID)
    new Companion_40();
  return Companion_instance_49;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_56().y6r_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_56().z6r_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_56().a6s_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_56().b6s_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_56().c6s_1 ? 'INVERT' : $this === Companion_getInstance_56().d6s_1 ? 'KEEP' : $this === Companion_getInstance_56().e6s_1 ? 'SET' : $this === Companion_getInstance_56().f6s_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.o6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_57() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_57().q6r_1 ? 'ALWAYS' : $this === Companion_getInstance_57().r6r_1 ? 'EQUAL' : $this === Companion_getInstance_57().s6r_1 ? 'GREATER' : $this === Companion_getInstance_57().t6r_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_57().u6r_1 ? 'LESS' : $this === Companion_getInstance_57().v6r_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_57().w6r_1 ? 'NEVER' : $this === Companion_getInstance_57().x6r_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__inverted_impl_7xxk8m($this) {
  return $this === Companion_getInstance_57().q6r_1 ? Companion_getInstance_57().w6r_1 : $this === Companion_getInstance_57().r6r_1 ? Companion_getInstance_57().x6r_1 : $this === Companion_getInstance_57().s6r_1 ? Companion_getInstance_57().v6r_1 : $this === Companion_getInstance_57().t6r_1 ? Companion_getInstance_57().u6r_1 : $this === Companion_getInstance_57().u6r_1 ? Companion_getInstance_57().t6r_1 : $this === Companion_getInstance_57().v6r_1 ? Companion_getInstance_57().s6r_1 : $this === Companion_getInstance_57().w6r_1 ? Companion_getInstance_57().q6r_1 : $this === Companion_getInstance_57().x6r_1 ? Companion_getInstance_57().r6r_1 : Companion_getInstance_57().w6r_1;
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.p6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_58() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
function toAGScissor(_this__u8e3s4) {
  if (_this__u8e3s4 == null)
    return Companion_getInstance_44().m6h_1;
  return AGScissor.s6q(numberToInt(_this__u8e3s4.o25_1), numberToInt(_this__u8e3s4.p25_1), numberToInt(_this__u8e3s4.q25_1), numberToInt(_this__u8e3s4.r25_1));
}
function plus_5(_this__u8e3s4, scissor) {
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D.a28(scissor.v25(), scissor.x25())), Vector2D.a28(scissor.w25(), scissor.y25()));
}
function applyMatrixBounds(_this__u8e3s4, m) {
  var x0 = m.t29(_this__u8e3s4.v25(), _this__u8e3s4.x25());
  var x1 = m.t29(_this__u8e3s4.w25(), _this__u8e3s4.x25());
  var x2 = m.t29(_this__u8e3s4.v25(), _this__u8e3s4.y25());
  var x3 = m.t29(_this__u8e3s4.w25(), _this__u8e3s4.y25());
  var y0 = m.u29(_this__u8e3s4.v25(), _this__u8e3s4.x25());
  var y1 = m.u29(_this__u8e3s4.w25(), _this__u8e3s4.x25());
  var y2 = m.u29(_this__u8e3s4.v25(), _this__u8e3s4.y25());
  var y3 = m.u29(_this__u8e3s4.w25(), _this__u8e3s4.y25());
  return Companion_getInstance_44().y2d(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max_0(x0, x1, x2, x3)), numberToInt(max_0(y0, y1, y2, y3)));
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function u_Tex$factory() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.o6x();
  }, null);
}
function u_TexEx$factory() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.q6x();
  }, null);
}
function u_Tex$factory_0() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.o6x();
  }, null);
}
function u_TexEx$factory_0() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.q6x();
  }, null);
}
function u_ProjMat$factory() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.r6u();
  }, null);
}
function u_ViewMat$factory() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.s6u();
  }, null);
}
function u_ProjMat$factory_0() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.r6u();
  }, null);
}
function u_ViewMat$factory_0() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.s6u();
  }, null);
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var this_0 = gl$delegate;
  var property = gl$factory();
  var value = this_0.by_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.zx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = gl$delegate;
    var property = gl$factory_0();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.k70_1;
  var map = $this.o70_1;
  if ($this.p70_1 == null) {
    $this.p70_1 = gl.u71(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_37().f6f_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.j2t(level)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$0 = 'GL_VERSION=' + gl.u71(7938);
      this_0.k2t(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_37().f6f_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.j2t(level_0)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.p70_1;
      this_1.k2t(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_37().f6f_1;
    var level_1 = Level_INFO_getInstance();
    var tmp_1;
    if (this_2.j2t(level_1)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      this_2.k2t(level_1, tmp$ret$4);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_37().f6f_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_2;
    if (this_3.j2t(level_2)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
      this_3.k2t(level_2, tmp$ret$6);
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_4 = Companion_getInstance_37().f6f_1;
    var level_3 = Level_INFO_getInstance();
    var tmp_3;
    if (this_4.j2t(level_3)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
      this_4.k2t(level_3, tmp$ret$8);
      tmp_3 = Unit_instance;
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.c3(program);
  var tmp_4;
  if (value == null) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_5 = new GLBaseProgram($this.n70_1, GLShaderCompiler_getInstance().x71(gl, $this.v71(), program, program.q6n_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
    this_5.b72();
    var programInfo = this_5.a72_1;
    var programId = programInfo.c72_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = program.u6n_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
      var location = programInfo.x72(gl, element.s72_1);
      gl.y72(location, element.c6k_1);
    }
    if (programInfo.g72_1.f73()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_6 = program.t6n_1;
      var n = 0;
      while (n < this_6.e1()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_6.d1(_unary__edvuaz);
        var index = gl.z72(programId, it.o3());
        gl.a73(programId, index, it.o6o_1);
      }
    }
    var answer = this_5;
    map.e3(program, answer);
    tmp_4 = answer;
  } else {
    tmp_4 = value;
  }
  var nprogram = tmp_4;
  if (!equals($this.y70_1, nprogram)) {
    $this.y70_1 = nprogram;
    nprogram.b72();
  }
}
function resetObjects($this) {
  $this.r70_1 = null;
  $this.c71_1 = Companion_getInstance_44().l6h_1;
  $this.s70_1 = Companion_getInstance_43().o6g_1;
  $this.t70_1 = Companion_getInstance_50().n6h_1;
  $this.u70_1 = Companion_getInstance_47().z6g_1;
  $this.v70_1 = Companion_getInstance_46().x6g_1;
  $this.w70_1 = Companion_getInstance_48().b6h_1;
  $this.x70_1 = Companion_getInstance_49().h6h_1;
  $this.z70_1.h3();
  $this.y70_1 = null;
  $this.n71_1 = -1;
  $this.l71_1 = 0;
  $this.m71_1 = Companion_instance_48.n6t();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.i71_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].c2q();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $this.n70_1.u73_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.d1v();
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.n70_1.v73_1.g1()) {
          // Inline function 'kotlin.also' call
          var this_1 = toList($this.n70_1.v73_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
          $this.n70_1.v73_1.h3();
          tmp = this_1;
        } else {
          return Unit_instance;
        }
        tmp$ret$3 = tmp;
        break $l$block;
      }finally {
        this_0.f1v();
      }
    }
    var n = 0;
    while (n < tmp$ret$3.e1()) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$3.d1(_unary__edvuaz).y73();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  var gl = $this.k70_1;
  if (reallocated == null)
    null;
  else {
    reallocated.s2q(false);
  }
  if (updated == null)
    null;
  else {
    updated.s2q(false);
  }
  if (buffer == null) {
    gl.z73(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty(buffer, $this);
  if (!onlyUpdate) {
    gl.z73(toGl_6(target), bufferInfo.c74_1);
  }
  $this.f74(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.k70_1;
  var location = programInfo.x72(gl, uniform.s72_1);
  var uniformType = uniform.n29();
  var arrayCount = uniform.i74_1;
  if (uniformType.p74_1.n3_1 === 6) {
    switch (uniformType.n3_1) {
      case 1:
        gl.x74(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.h71_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.y74(location, arrayCount, false, $this.h71_1);
        break;
      case 3:
        gl.z74(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.q74_1) {
          case 1:
            gl.a75(location, arrayCount, data);
            break;
          case 2:
            gl.b75(location, arrayCount, data);
            break;
          case 3:
            gl.c75(location, arrayCount, data);
            break;
          case 4:
            gl.d75(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.q74_1) {
      case 1:
        gl.t74(location, arrayCount, data);
        break;
      case 2:
        gl.u74(location, arrayCount, data);
        break;
      case 3:
        gl.v74(location, arrayCount, data);
        break;
      case 4:
        gl.w74(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.k70_1;
  var params = $this.i71_1[$this.l71_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.h73_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.e75(glTarget, 10242, glWrap);
  gl.e75(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.e75(glTarget, 32882, glWrap);
  }
  params.i73_1 = minFilter;
  params.j73_1 = magFilter;
  gl.e75(glTarget, 10241, minFilter);
  gl.e75(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.e12(bmp.i2f());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
        arraycopy_3(bmp.x46(), 0, get_i8(this_0), 0, bmp.i2f());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.e12(imul(imul(bmp.i2f(), 4), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_2(bmp.e4a_1, 0, get_f32(this_1), 0, imul(bmp.i2f(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.e12(imul(bmp.i2f(), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          var abmp = bmp.r3x_1 ? bmp.i45().m48() : bmp.i45().n48();
          arraycopy_1(abmp.b3x_1, 0, get_i32(this_2), 0, abmp.i2f());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.l71_1;
  if (!($this.l71_1 === index)) {
    $this.l71_1 = index;
    if (index >= 0) {
      $this.k70_1.f75(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty(_this__u8e3s4, $this) {
  return gl(_this__u8e3s4, $this.n70_1);
}
function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
  return gl_0(_this__u8e3s4, $this.n70_1);
}
function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
  return gl_1(_this__u8e3s4, $this.n70_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return function () {
    return new GlslConfig(this$0.k70_1.g75(), this$0.k70_1);
  };
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return function (it) {
    var tmp0_elvis_lhs = $buffer.z6i_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.e12(0) : tmp0_elvis_lhs;
    $bufferInfo.h75(mem.j12());
    var tmp;
    if ($onlyUpdate) {
      $gl.z73(toGl_6($target), $bufferInfo.c74_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.d74_1 < mem.j12()) {
      $bufferInfo.d74_1 = mem.j12();
      $gl.j75(toGl_6($target), mem.j12(), mem, 35048);
      var tmp1_safe_receiver = $reallocated;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.s2q(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.i75(toGl_6($target), 0, mem.j12(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp2_safe_receiver = $updated;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.s2q(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return function (it) {
    var rbmp = $tex.h6l_1;
    var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6m_1;
    var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
    var requestMipmaps = $tex.e6l_1;
    $tex.i6l_1 = $tex.k6m(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.a1();
    var index = 0;
    while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.c1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_51().q6l_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.g75()) && _GLVariant___get_version__impl__9nyfwa($gl.g75()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.g75()).wt()) {
        $gl.k75(3313, 0);
        $gl.k75(3312, 1);
      }
      if (bmp == null) {
        $gl.l75(toGl_8($target), 0, type, $tex.m2i(), $tex.n2i(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.i2f() === 0)) {
            $gl.m75(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.l75(texTarget, 0, internalFormat, bmp.l3x_1, bmp.m3x_1, 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.l3x_1 === 0) && !(bmp.m3x_1 === 0) && !(get_size_0(buffer) === 0)) {
              $gl.l75(texTarget, 0, internalFormat, bmp.l3x_1, bmp.m3x_1, 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.m2i(), $tex.n2i()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.g75())) {
        var tmp_0;
        if ($tex.i6l_1) {
          var tmp4_elvis_lhs = $tex.f6l_1;
          tmp_0 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.e75(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.i6l_1) {
          var tmp5_elvis_lhs = $tex.g6l_1;
          tmp_1 = tmp5_elvis_lhs == null ? 1000 : tmp5_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.e75(3553, 33085, tmp_1);
      }
      if ($tex.i6l_1) {
        $gl.n75(texTarget);
      }
    }
    $glTex.h75(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function gl$factory() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function gl$factory_0() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function glslConfig$factory() {
  return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
    return receiver.v71();
  }, null);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.bi('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.bi('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_51().o6l_1;
      break;
    case 32879:
      tmp = Companion_getInstance_51().p6l_1;
      break;
    case 34067:
      tmp = Companion_getInstance_51().q6l_1;
      break;
    case 36197:
      tmp = Companion_getInstance_51().r6l_1;
      break;
    case 34069:
      tmp = Companion_getInstance_51().q6l_1;
      break;
    case 34070:
      tmp = Companion_getInstance_51().q6l_1;
      break;
    case 34071:
      tmp = Companion_getInstance_51().q6l_1;
      break;
    case 34072:
      tmp = Companion_getInstance_51().q6l_1;
      break;
    case 34073:
      tmp = Companion_getInstance_51().q6l_1;
      break;
    case 34074:
      tmp = Companion_getInstance_51().q6l_1;
      break;
    default:
      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.od('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_54().k6q_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_54().l6q_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_54().m6q_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_53().x6p_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_53().y6p_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_53().z6p_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_53().a6q_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_53().b6q_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_53().c6q_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_53().d6q_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_53().e6q_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_53().f6q_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_53().g6q_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_57().q6r_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_57().r6r_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_57().s6r_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_57().t6r_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_57().u6r_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_57().v6r_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_57().w6r_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_57().x6r_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_56().y6r_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_56().z6r_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_56().a6s_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_56().b6s_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_56().c6s_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_56().d6s_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_56().e6s_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_56().f6s_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_41().l6p_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_41().m6p_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_41().n6p_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_41().o6p_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_41().q6p_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_41().r6p_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_41().p6p_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_42().k6g_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_42().l6g_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_42().m6g_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_42().n6g_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_50().r6h_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_50().p6h_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_50().q6h_1) {
    tmp = 1029;
  } else {
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.od('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.n3_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.p74_1.n3_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_51().o6l_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_51().p6l_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_51().q6l_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_51().r6l_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_52().n6m_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_52().o6m_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_52().p6m_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_58().l6s_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_58().n6s_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_58().m6s_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.a6j_1 == null || !(_this__u8e3s4.b6j_1 === state.n73_1.j6f_1)) {
    _this__u8e3s4.b6j_1 = state.n73_1.j6f_1;
    _this__u8e3s4.k6j();
    _this__u8e3s4.a6j_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.a6j_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return function (it) {
    return new GLBuffer($state);
  };
}
function gl$lambda_0($state, $this_gl) {
  return function (it) {
    return new GLFrameBuffer($state, $this_gl);
  };
}
function gl$lambda_1($state) {
  return function (it) {
    return new GLTexture($state);
  };
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionString$delegate;
    var property = versionString$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionInt$delegate;
    var property = versionInt$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.z78(type);
  gl.a79(shaderId, str);
  gl.b79(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.c79();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.f70(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.g75())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.g75()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.u71(35724);
  }
  return tmp;
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0_safe_receiver = Regex.oh('(\\d+\\.\\d+)').qh(get_versionString($this$PropertyThis));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r1();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
  return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
}
function versionString$factory() {
  return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
    return get_versionString(receiver);
  }, null);
}
function versionInt$factory() {
  return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
    return get_versionInt(receiver);
  }, null);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_52;
function Companion_getInstance_59() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp0_elvis_lhs = this$0.i6u_1;
    var this_0 = TypedUniform.m7a(tmp0_elvis_lhs == null ? 'unknown' + this$0.h6u_1.w6u() : tmp0_elvis_lhs, this$0.j6u_1, this$0.k6u_1, this$0.h6u_1, this$0.l6u_1, this$0.m6u_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
    this$0.h6u_1.q6o_1.h(this_0);
    return this_0;
  };
}
var Companion_instance_53;
function Companion_getInstance_60() {
  return Companion_instance_53;
}
function _get_bufferSize__mp12kq($this) {
  return $this.z6m_1.j12() / $this.x6m_1 | 0;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.p7a_1;
  tmp.p7a_1 = Math.max(a, size);
  while (!(($this.o7a_1 % size | 0) === 0)) {
    $this.o7a_1 = $this.o7a_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return function () {
    align(this$0, this$0.p7a_1);
    return this$0.o7a_1;
  };
}
function uniform$factory() {
  return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
    return receiver.n7a();
  }, null);
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.e1();
  }, null);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_3().st_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_54;
function Companion_getInstance_61() {
  return Companion_instance_54;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.q7c_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).u7c_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.y7c_1, config)).m7d(_this__u8e3s4);
}
var Companion_instance_55;
function Companion_getInstance_62() {
  if (Companion_instance_55 === VOID)
    new Companion_46();
  return Companion_instance_55;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp = a.s72_1;
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.s72_1;
  return compareValues(tmp, tmp$ret$1);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return function ($this$Indenter) {
    var tmp;
    if (!this$0.l7d_1.e73_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.l7d_1.b73_1) ? ' es' : '';
      $this$Indenter.p34('#version ' + this$0.l7d_1.d73_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.k7d_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.p34('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.p34('#ifdef GL_ES');
    $this$Indenter.p34('precision mediump float;');
    $this$Indenter.p34('#endif');
    var _iterator__ex2g4s = $types.o7d_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var it = _iterator__ex2g4s.c1();
      var layout = this$0.l7d_1.t7f() && this$0.l7d_1.d73_1 >= 410 ? 'layout(location = ' + it.x6v_1 + ') ' : '';
      $this$Indenter.p34(layout + this$0.u7f() + ' ' + this$0.v7f(it.t72_1) + this$0.w7f(it.n29()) + ' ' + it.s72_1 + this$0.x7f(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.t7d_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var it_0 = _iterator__ex2g4s_0.c1();
      var layout_0 = this$0.l7d_1.t7f() ? '' : '';
      $this$Indenter.p34(layout_0 + this$0.y7f() + ' ' + this$0.v7f(it_0.t72_1) + this$0.w7f(it_0.n29()) + ' ' + it_0.s72_1 + this$0.x7f(it_0) + ';');
    }
    var tmp_1;
    if (this$0.l7d_1.f73()) {
      var _iterator__ex2g4s_1 = $types.s7d_1.a1();
      while (_iterator__ex2g4s_1.b1()) {
        var block = _iterator__ex2g4s_1.c1();
        $this$Indenter.p34('layout(std140) uniform ' + block.o3() + ' {');
        var _iterator__ex2g4s_2 = block.t6u().a1();
        while (_iterator__ex2g4s_2.b1()) {
          var uniform = _iterator__ex2g4s_2.c1();
          $this$Indenter.p34('  ' + this$0.v7f(uniform.t72_1) + this$0.w7f(uniform.n29()) + ' ' + uniform.s72_1 + this$0.x7f(uniform) + ';');
        }
        $this$Indenter.p34('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.q7d_1.a1();
      while (_iterator__ex2g4s_3.b1()) {
        var it_1 = _iterator__ex2g4s_3.c1();
        $this$Indenter.p34(this$0.y7f() + ' ' + this$0.v7f(it_1.t72_1) + this$0.w7f(it_1.n29()) + ' ' + it_1.s72_1 + this$0.x7f(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.p7d_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$0).a1();
    var index = 0;
    $l$loop: while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.c1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.l7d_1.t7f() ? this$0.z7f() : it_2.s72_1 === this$0.l7d_1.a7g() && this$0.k7d_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.z7f() : this$0.k7d_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.z7f() : this$0.u7f();
      $this$Indenter.p34(INOUT + ' ' + this$0.v7f(it_2.t72_1) + this$0.w7f(it_2.n29()) + ' ' + it_2.s72_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.a1();
    while (_iterator__ex2g4s_4.b1()) {
      var func = _iterator__ex2g4s_4.c1();
      var gen = new GlslBodyGenerator(this$0.k7d_1, this$0.l7d_1);
      gen.m7e(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.d7g_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$2 = this$0.w7f(item.el_1) + ' ' + item.dl_1;
        destination.h(tmp$ret$2);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.w7f(func.c7g_1) + ' ' + func.b7g_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.p34(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.q34();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var _iterator__ex2g4s_5 = gen.j7g_1.a1();
        while (_iterator__ex2g4s_5.b1()) {
          var temp = _iterator__ex2g4s_5.c1();
          $this$Indenter.p34(this$0.v7f(temp.t72_1) + this$0.w7f(temp.n29()) + ' ' + temp.s72_1 + ';');
        }
        $this$Indenter.o34(gen.k7g_1);
      }finally {
        $this$Indenter.r34();
      }
      $this$Indenter.p34('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_56;
function Companion_getInstance_63() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return function (it) {
    return this$0.x7e(it);
  };
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return function (it) {
    return this$0.x7e(it);
  };
}
function ProgramLayout$names$lambda(it) {
  return it.s72_1;
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
var Companion_instance_57;
function Companion_getInstance_64() {
  if (Companion_instance_57 === VOID)
    new Companion_48();
  return Companion_instance_57;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return function ($this$FUNC) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.p7i_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var tmp$ret$0 = $this$FUNC.v7i('p' + index_0, item);
      destination.h(tmp$ret$0);
    }
    var args = destination;
    this$0.r7i_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1), it.d1(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return function ($this$ELSE) {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.m6y($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.n6y($ref, $min + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.j7l();
  return Output_instance;
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_58;
function Companion_getInstance_65() {
  return Companion_instance_58;
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
function FragmentShader(info) {
  return FragmentShader_0(info.dl_1, info.el_1);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function VertexShader(info) {
  return VertexShader_0(info.dl_1, info.el_1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return function () {
    $this_toDisposable.c6();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      _this__u8e3s4.u12(_unary__edvuaz, toByte(tmp$ret$0));
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    _this__u8e3s4.u12(_unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _this__u8e3s4.s12(n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_59;
function Companion_getInstance_66() {
  return Companion_instance_59;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.k7y().w2('GL_OES_texture_float') || this$0.k7y().w2('GL_ARB_texture_float');
  };
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
  _this__u8e3s4.t7y(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
  _this__u8e3s4.x7y(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
  _this__u8e3s4.u7y(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
  _this__u8e3s4.v7y(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.w7y(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
  _this__u8e3s4.p7y(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
  _this__u8e3s4.l7y(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
  _this__u8e3s4.s7y(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
  _this__u8e3s4.o7y(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
  _this__u8e3s4.r7y(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
  _this__u8e3s4.q7y(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
  _this__u8e3s4.n7y(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
  _this__u8e3s4.m7y(1, it);
  getInt32(it, 0);
}
function _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return get_tempNBuffer1();
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_1().mw('KmlGlException');
    tempNBufferByte = Buffer.e12(1, true);
    tempNBuffer1 = Buffer.e12(4, true);
    tempNBuffer4 = Buffer.e12(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_60;
function Companion_getInstance_67() {
  return Companion_instance_60;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().x28_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().s3y_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_68().j7z_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().x28_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().s3y_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_68().j7z_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.f4p();
  var m2 = m.h2a(x, y).z29(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.b81_1;
  var this_1 = this_0.k81_1;
  if (!(this_1.f81_1 === this_0)) {
    this_1.f81_1 = this_0;
    this_1.p82();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  var tmp;
  if (inductionVariable <= last) {
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.f4p();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp_0 = charSequenceGet(str, index);
      } else {
        // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
        tmp_0 = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$1 = tmp_0;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
      var glyph = _this__u8e3s4.d1(c1);
      var tex = glyph.t4o_1;
      var tmp0_tex = ctx.q82(tex);
      var tmp1_x = dx + glyph.u4o_1;
      var tmp2_y = dy + glyph.v4o_1;
      var tmp3_width = tex.b3g_1;
      var tmp4_height = tex.c3g_1;
      var tmp5_m = get_immutable(m2);
      this_0.r82(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_m, filtering, colMul, blendMode);
      var tmp6_safe_receiver = _this__u8e3s4.j4p().d1(Companion_instance_5.q4o(c1, c2));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.b4p_1;
      var kerningOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      dx = dx + (glyph.w4o_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
    tmp = Unit_instance;
  }
}
var debugBmpFontOrNull;
function *_generator_debugBmpFont__zhh4ef($completion) {
  if (debugBmpFontOrNull == null) {
    var tmp = readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    debugBmpFontOrNull = debugBmpFont_0(slice(tmp.i45()));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_debugBmpFont__zhh4ef.bind(VOID), $completion);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.cc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable = this_0.a2_1;
  var last = this_0.b2_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
      var it = element;
      var x = it % 16 | 0;
      var y = it / 16 | 0;
      var tmp$ret$0 = new Glyph(fntHeight, it, tex.j3h(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.e3(element, tmp$ret$0);
    }
     while (!(element === last));
  var glyphs = toIntMap(result);
  var kernings = IntMap.i2o();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_61;
function Companion_getInstance_68() {
  if (Companion_instance_61 === VOID)
    new Companion_52();
  return Companion_instance_61;
}
var Companion_instance_62;
function Companion_getInstance_69() {
  return Companion_instance_62;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.y83_1[n];
      var curr = $this.x83_1[n];
      $this.d84_1[n] = (prev && !curr);
      $this.c84_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.z83_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.z83_1[n] = 0.0;
        $this.a84_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.z83_1[n]);
      if ($this.z83_1[n] > 0) {
        var tmp0_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp0_subject ? tmp0_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp0_subject ? tmp0_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp0_subject ? tmp0_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.a84_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.a84_1[n] = $this.z83_1[n];
      }
      $this.b84_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.x83_1, 0, $this.y83_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.g84();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *_generator_configureLoggerFromProperties__heiqlb(file, $completion) {
  try {
    var tmp = file.u23(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    configureLoggerFromProperties_0(tmp);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties(file, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureLoggerFromProperties__heiqlb.bind(VOID, file), $completion);
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_63.t84(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.p1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.q1();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.r1();
    try {
      var tmp = Companion_getInstance_1().mw(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = value.toUpperCase();
      tmp.c2t(valueOf(tmp$ret$4));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_63;
function Companion_getInstance_70() {
  return Companion_instance_63;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.c2q();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.a86_1 === bitmap && ensureNotNull($this.b86_1).j85_1.n85_1 === bitmap.u3x_1)
    return ensureNotNull($this.b86_1);
  if ($this.c86_1 === bitmap && ensureNotNull($this.d86_1).j85_1.n85_1 === bitmap.u3x_1)
    return ensureNotNull($this.d86_1);
  $this.u85_1.t2m(bitmap);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.z85_1;
    var res = get_0(this_0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = $this.y85_1.m2p();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
    var base = this_1.j85_1;
    base.n85_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_51().q6l_1;
    } else {
      tmp_0 = Companion_getInstance_51().o6l_1;
    }
    tmp.l85_1 = new AGTexture(tmp_0);
    base.p85(bitmap.l3x_1);
    base.q85(bitmap.m3x_1);
    var out = this_1;
    set(this_0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.c86_1 = $this.a86_1;
  $this.d86_1 = $this.b86_1;
  var base_0 = textureInfo.j85_1;
  $this.a86_1 = bitmap;
  $this.b86_1 = textureInfo;
  if (!(bitmap.u3x_1 === base_0.n85_1)) {
    base_0.n85_1 = bitmap.u3x_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.Long.minus' call
    var this_2 = $this.x85_1;
    var other = textureInfo.i85_1;
    tmp_1.x85_1 = this_2.x1(toLong(other));
    try {
      base_0.j86(bitmap, bitmap.w3x_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.i85_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
      var tmp_2 = $this;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = $this.x85_1;
      var other_0 = textureInfo.i85_1;
      tmp_2.x85_1 = this_3.u3(toLong(other_0));
    }
    bitmap.h3y();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
  return imul(_this__u8e3s4.m3x_1, imul(_this__u8e3s4.l3x_1, _this__u8e3s4.n3x_1) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.e86_1 === slice)
    return ensureNotNull($this.f86_1);
  if ($this.g86_1 === slice)
    return ensureNotNull($this.h86_1);
  var info = getTextureInfo($this, slice.b3h());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = info.k85_1;
    var res = get_0(this_0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture_1(info.j85_1).l3h(RectangleInt.u2e(slice.v25(), slice.x25(), slice.b3g_1, slice.c3g_1));
    } else {
      tmp = Companion_instance_7.z3h(info.j85_1, slice);
    }
    var out = tmp;
    set(this_0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.g86_1 = $this.e86_1;
  $this.h86_1 = $this.f86_1;
  $this.e86_1 = slice;
  $this.f86_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.a86_1 = null;
  $this.b86_1 = null;
  $this.c86_1 = null;
  $this.d86_1 = null;
  $this.e86_1 = null;
  $this.f86_1 = null;
  $this.g86_1 = null;
  $this.h86_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.c2q();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.e6x($this$IF_ELSE_BINARY_LOOKUP.h6x(), $this$IF_ELSE_BINARY_LOOKUP.p6x(Companion_getInstance_71().e87_1[n], $this$IF_ELSE_BINARY_LOOKUP.n6x($$this$apply.a6x(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.s81_1);
  var idx_0 = idx;
  var ma = matrix.c29_1;
  var mb = matrix.d29_1;
  var mc = matrix.e29_1;
  var md = matrix.f29_1;
  var mtx = matrix.g29_1;
  var mty = matrix.h29_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.g2a(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_7().k29(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.e25_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.f25_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.y81_1 + indices | 0) < $this.r81_1 && ($this.x81_1 + vertices | 0) < $this.q81_1;
}
var Companion_instance_64;
function Companion_getInstance_71() {
  if (Companion_instance_64 === VOID)
    new Companion_55();
  return Companion_instance_64;
}
function BatchBuilder2D$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (it.n3_1) {
      case 0:
        this$0.v87();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.w87();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_1().mw('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_2().wt() && Companion_getInstance_2().du().ht_1 && Companion_getInstance_2().du().mt() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = debugLineRenderContext$delegate;
    var property = debugLineRenderContext$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_65;
function Companion_getInstance_72() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function addVertex($this, x, y, color, m) {
  setFloat32($this.k8a_1, $this.n8a_1 + 0 | 0, m.q29(x, y));
  setFloat32($this.k8a_1, $this.n8a_1 + 1 | 0, m.r29(x, y));
  setInt32($this.k8a_1, $this.n8a_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.n8a_1 = $this.n8a_1 + (Companion_getInstance_72().z89_1.g6p_1 / 4 | 0) | 0;
  $this.m8a_1 = $this.m8a_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return function (it) {
    this$0.lc();
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function debugLineRenderContext$factory() {
  return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
    return get_debugLineRenderContext(receiver);
  }, null);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return function () {
    return this$0.e6n(ProjViewUB_getInstance());
  };
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.z6f(VOID, it);
}
function FlushKind_STATE_getInstance() {
  FlushKind_initEntries();
  return FlushKind_STATE_instance;
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function projViewMatUB$factory() {
  return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
    return receiver.y8a();
  }, null);
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_1().mw('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.p6y($this$FUNC.p7j(a, b, c));
  return Unit_instance;
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.p6y($this$FUNC.m7j(a, b));
  return Unit_instance;
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.p6y($this$FUNC.n7j(a, b));
  return Unit_instance;
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.p6y($this$FUNC.n7j(a, $this$FUNC.e6z(b)));
  return Unit_instance;
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.p6y($this$FUNC.f6z(d, r));
  return Unit_instance;
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.p6y($this$FUNC.f6z($this$FUNC.w6y(d), r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.p6z(d, 0.0);
  var body = $this$FUNC.v6x();
  // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
  body.p6y(d);
  var stmIf = new If(cond, body.x6x());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.d6x_1.h(stmIf);
  var tmp = stmIf;
  $this$FUNC.l6y(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return function ($this$ELSE) {
    $this$ELSE.p6y($this$ELSE.f6z($this$ELSE.w6y($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.p6y($this$FUNC.g6z(1.0, $this$FUNC.l7j($this$FUNC.s7j($this$FUNC.t6x(d, $this$FUNC.o7j(d)), 0.5), $this$FUNC.k6x(0.0), $this$FUNC.k6x(1.0))));
  return Unit_instance;
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.p6y($this$FUNC.l7j($this$FUNC.s7j($this$FUNC.t6x(d, $this$FUNC.o7j(d)), 0.5), $this$FUNC.k6x(0.0), $this$FUNC.k6x(1.0)));
  return Unit_instance;
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h6y($this$FUNC.l7j($this$FUNC.r7j(0.5, $this$FUNC.t6x($this$FUNC.t7j(0.5, $this$FUNC.f6z(d2, d1)), k)), $this$FUNC.k6x(0.0), $this$FUNC.k6x(1.0)));
  $this$FUNC.p6y($this$FUNC.f6z($this$FUNC.p7j(d2, d1, h), $this$FUNC.i6x($this$FUNC.i6x(k, h), $this$FUNC.g6z(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h6y($this$FUNC.l7j($this$FUNC.g6z(0.5, $this$FUNC.t6x($this$FUNC.t7j(0.5, $this$FUNC.h6z(d2, d1)), k)), $this$FUNC.k6x(0.0), $this$FUNC.k6x(1.0)));
  $this$FUNC.p6y($this$FUNC.h6z($this$FUNC.p7j(d2, $this$FUNC.e6z(d1), h), $this$FUNC.i6x($this$FUNC.i6x(k, h), $this$FUNC.g6z(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h6y($this$FUNC.l7j($this$FUNC.g6z(0.5, $this$FUNC.t6x($this$FUNC.t7j(0.5, $this$FUNC.f6z(d2, d1)), k)), $this$FUNC.k6x(0.0), $this$FUNC.k6x(1.0)));
  $this$FUNC.p6y($this$FUNC.h6z($this$FUNC.p7j(d2, d1, h), $this$FUNC.i6x($this$FUNC.i6x(k, h), $this$FUNC.g6z(1.0, h))));
  return Unit_instance;
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.p6y($this$FUNC.f6z($this$FUNC.q7j(p), r));
  return Unit_instance;
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  $this$FUNC.e6x($this$FUNC.n6x(r, 'xy'), $this$FUNC.k7j($this$FUNC.p6z($this$FUNC.a6z(p), 0.0), $this$FUNC.n6x(r, 'xy'), $this$FUNC.n6x(r, 'zw')));
  $this$FUNC.e6x($this$FUNC.a6z(r), $this$FUNC.k7j($this$FUNC.p6z($this$FUNC.b6z(p), 0.0), $this$FUNC.a6z(r), $this$FUNC.b6z(r)));
  var q = $this$FUNC.h6y($this$FUNC.h6z($this$FUNC.f6z($this$FUNC.w6y(p), b), $this$FUNC.a6z(r)));
  $this$FUNC.p6y($this$FUNC.f6z($this$FUNC.h6z($this$FUNC.m7j($this$FUNC.n7j($this$FUNC.a6z(q), $this$FUNC.b6z(q)), $this$FUNC.k6x(0.0)), $this$FUNC.q7j($this$FUNC.n7j(q, $this$FUNC.k6x(0.0)))), $this$FUNC.a6z(r)));
  return Unit_instance;
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.h6y($this$FUNC.f6z($this$FUNC.w6y(p), b));
  $this$FUNC.p6y($this$FUNC.h6z($this$FUNC.q7j($this$FUNC.n7j(d, $this$FUNC.k6x(0.0))), $this$FUNC.m7j($this$FUNC.n7j($this$FUNC.a6z(d), $this$FUNC.b6z(d)), $this$FUNC.k6x(0.0))));
  return Unit_instance;
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.p6y($this$FUNC.h6z(src, $this$FUNC.i6x(dst, $this$FUNC.g6z(1.0, $this$FUNC.r6x(src)))));
  return Unit_instance;
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.z8c();
  return SDFShaders_instance;
}
function opInterpolate$factory() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.a8d();
  }, null);
}
function opUnion$factory() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.b8d();
  }, null);
}
function opIntersect$factory() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.c8d();
  }, null);
}
function opSubtract$factory() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.d8d();
  }, null);
}
function opRound$factory() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.e8d();
  }, null);
}
function opBorder$factory() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.f8d();
  }, null);
}
function opBorderInner$factory() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.g8d();
  }, null);
}
function opAA$factory() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.h8d();
  }, null);
}
function opAARev$factory() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.i8d();
  }, null);
}
function opSmoothUnion$factory() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.j8d();
  }, null);
}
function opSmoothSubtraction$factory() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.k8d();
  }, null);
}
function opSmoothIntersection$factory() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.l8d();
  }, null);
}
function circle$factory() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.m8d();
  }, null);
}
function roundedBox$factory() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.n8d();
  }, null);
}
function box$factory() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.o8d();
  }, null);
}
function opCombinePremultipliedColors$factory() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.p8d();
  }, null);
}
function opInterpolate$factory_0() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.a8d();
  }, null);
}
function opUnion$factory_0() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.b8d();
  }, null);
}
function opIntersect$factory_0() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.c8d();
  }, null);
}
function opSubtract$factory_0() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.d8d();
  }, null);
}
function opRound$factory_0() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.e8d();
  }, null);
}
function opBorder$factory_0() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.f8d();
  }, null);
}
function opBorderInner$factory_0() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.g8d();
  }, null);
}
function opAA$factory_0() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.h8d();
  }, null);
}
function opAARev$factory_0() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.i8d();
  }, null);
}
function opSmoothUnion$factory_0() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.j8d();
  }, null);
}
function opSmoothSubtraction$factory_0() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.k8d();
  }, null);
}
function opSmoothIntersection$factory_0() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.l8d();
  }, null);
}
function circle$factory_0() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.m8d();
  }, null);
}
function roundedBox$factory_0() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.n8d();
  }, null);
}
function box$factory_0() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.o8d();
  }, null);
}
function opCombinePremultipliedColors$factory_0() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.p8d();
  }, null);
}
function Texture(frameBuffer) {
  return Texture_0(frameBuffer.t6k(), frameBuffer.t6f_1, frameBuffer.u6f_1);
}
function Texture_0(agBase, width, height) {
  return new RectSlice(TextureBase.q8d(agBase, SizeInt.k2g(width, height)), RectangleInt.u2e(0, 0, width, height));
}
function Texture_1(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.m2i() : right;
  bottom = bottom === VOID ? base.n2i() : bottom;
  return new RectSlice(base, Companion_instance_2.y2d(left, top, right, bottom));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_66;
function Companion_getInstance_73() {
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.u8d_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.v8d_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function V2Callback(init, callback) {
  var tmp;
  if (init === VOID) {
    tmp = V2Callback$lambda;
  } else {
    tmp = init;
  }
  init = tmp;
  var tmp_0 = dummy$factory(V2CallbackSupport_getInstance());
  return new V2(tmp_0, Unit_instance, Unit_instance, V2Callback$lambda_0(callback), true, VOID, VOID, init);
}
function _interpolate(ratio, l, r) {
  return interpolate(ratio, l, r);
}
function _interpolateColor(ratio, l, r) {
  return Companion_getInstance_11().i4o(l, r, ratio);
}
var V2CallbackSupport_instance;
function V2CallbackSupport_getInstance() {
  if (V2CallbackSupport_instance === VOID)
    new V2CallbackSupport();
  return V2CallbackSupport_instance;
}
function _interpolateRatio(ratio, l, r) {
  return interpolate_0(ratio, l, r);
}
function V2Callback$lambda() {
  return Unit_instance;
}
function V2Callback$lambda_0($callback) {
  return function (ratio, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    $callback(ratio);
    return Unit_instance;
  };
}
function dummy$factory($b0) {
  return getPropertyCallableRef('dummy', 0, KMutableProperty0, function () {
    return Unit_instance;
  }, function (value) {
    $b0.v8e_1 = value;
    return Unit_instance;
  });
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_67;
function Companion_getInstance_74() {
  Cursor_initEntries();
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_74();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.y8e_1($this.z8e_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  return $this.f8g_1.ko($this, fpsCached$factory());
}
function *_generator_waitClose__fhnm35($this, $completion) {
  while ($this.u8g_1) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay_0(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_loop__qll5p8($this, entry, $completion) {
  var tmp = $this.y8h($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.an(CoroutineName.n1b('GameWindow.loop'));
  launchImmediately(tmp_0, GameWindow$loop$slambda_0(entry, $this));
  while ($this.u8g_1) {
    var elapsed;
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.ej();
    // Inline function 'korlibs.render.GameWindow.loop.<anonymous>' call
    elapsed = $this.z8h();
    var realElapsed = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    var available = FastDuration__minus_impl_evs237($this.a8i(), elapsed);
    if (FastDuration__compareTo_impl_4fhnj7(available, Companion_instance_3.s1u()) > 0) {
      var tmp_1 = $this.b8i(available, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  return Unit_instance;
}
function *_generator_loopDelay__vgtnit($this, time, $completion) {
  var tmp = delay(time, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return function () {
    return this$0.c8i();
  };
}
function GameWindow$loop$slambda_0($entry, this$0) {
  var i = new GameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_TEXT_getInstance() {
  Cursor_initEntries();
  return Cursor_TEXT_instance;
}
function Cursor_HAND_getInstance() {
  Cursor_initEntries();
  return Cursor_HAND_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_68;
function Companion_getInstance_75() {
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().t3y_1 : bgcolor;
  _this__u8e3s4.r8j(numberToInt(size.j26_1), numberToInt(size.k26_1));
  if (!(title == null)) {
    _this__u8e3s4.i8j(title);
  }
  _this__u8e3s4.j8j(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.k8j(fullscreen);
  }
  _this__u8e3s4.m8j(bgcolor);
  _this__u8e3s4.l8j(true);
}
function fpsCached$factory() {
  return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
    return _get_fpsCached__581dty(receiver);
  }, null);
}
function continuousRenderMode$factory() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.y8j();
  }, function (receiver, value) {
    return receiver.x8j(value);
  });
}
function continuousRenderMode$factory_0() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.y8j();
  }, function (receiver, value) {
    return receiver.x8j(value);
  });
}
var Companion_instance_69;
function Companion_getInstance_76() {
  if (Companion_instance_69 === VOID)
    new Companion_60();
  return Companion_instance_69;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().p64());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.c8l_1, b.c8l_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return function (it) {
    $task.f8l_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this$0.p8i_1.y1u_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this$0.o8i_1.v2l($task);
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return function () {
    $block.e1a();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return function (it) {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return function () {
    var tmp;
    if (!($cancelled._v == null)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.oc(tmp$ret$0);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      this_1.oc(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.e1a();
    return Unit_instance;
  };
}
var Companion_instance_70;
function Companion_getInstance_77() {
  return Companion_instance_70;
}
var korgwJvmEngine;
function get_SDLPath() {
  _init_properties_SDL_kt__pqu7sn();
  // Inline function 'kotlin.getValue' call
  var this_0 = SDLPath$delegate;
  SDLPath$factory();
  return this_0.r1();
}
var SDLPath$delegate;
var Companion_instance_71;
function Companion_getInstance_78() {
  return Companion_instance_71;
}
var Companion_instance_72;
function Companion_getInstance_79() {
  return Companion_instance_72;
}
function SDLPath$delegate$lambda() {
  _init_properties_SDL_kt__pqu7sn();
  return Companion_getInstance_2().xt() ? '/Library/Frameworks/SDL2.framework/SDL2' : 'SDL2.dll';
}
function SDLPath$factory() {
  return getPropertyCallableRef('SDLPath', 0, KProperty0, function () {
    return get_SDLPath();
  }, null);
}
function SDL_Init$factory() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.x8m();
  }, null);
}
function SDL_CreateWindow$factory() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.y8m();
  }, null);
}
function SDL_SetWindowTitle$factory() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.z8m();
  }, null);
}
function SDL_SetWindowSize$factory() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.a8n();
  }, null);
}
function SDL_SetWindowPosition$factory() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.b8n();
  }, null);
}
function SDL_ShowWindow$factory() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.c8n();
  }, null);
}
function SDL_RaiseWindow$factory() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.d8n();
  }, null);
}
function SDL_PollEvent$factory() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.e8n();
  }, null);
}
function SDL_Quit$factory() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.f8n();
  }, null);
}
function SDL_GL_CreateContext$factory() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.g8n();
  }, null);
}
function SDL_GL_DeleteContext$factory() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.h8n();
  }, null);
}
function SDL_GL_MakeCurrent$factory() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.i8n();
  }, null);
}
function SDL_GL_SwapWindow$factory() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.j8n();
  }, null);
}
function SDL_Init$factory_0() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.x8m();
  }, null);
}
function SDL_CreateWindow$factory_0() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.y8m();
  }, null);
}
function SDL_SetWindowTitle$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.z8m();
  }, null);
}
function SDL_SetWindowSize$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.a8n();
  }, null);
}
function SDL_SetWindowPosition$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.b8n();
  }, null);
}
function SDL_ShowWindow$factory_0() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.c8n();
  }, null);
}
function SDL_RaiseWindow$factory_0() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.d8n();
  }, null);
}
function SDL_PollEvent$factory_0() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.e8n();
  }, null);
}
function SDL_Quit$factory_0() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.f8n();
  }, null);
}
function SDL_GL_CreateContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.g8n();
  }, null);
}
function SDL_GL_DeleteContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.h8n();
  }, null);
}
function SDL_GL_MakeCurrent$factory_0() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.i8n();
  }, null);
}
function SDL_GL_SwapWindow$factory_0() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.j8n();
  }, null);
}
function glDrawArraysInstanced$factory() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.w8w();
  }, null);
}
function glDrawElementsInstanced$factory() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.x8w();
  }, null);
}
function glVertexAttribDivisor$factory() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.y8w();
  }, null);
}
function glTexSubImage2D$factory() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.f8x();
  }, null);
}
function glTexImage2D$factory() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.f8w();
  }, null);
}
function glTexParameteri$factory() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.g8w();
  }, null);
}
function glTexParameterf$factory() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.g8x();
  }, null);
}
function glTexParameterfv$factory() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.h8x();
  }, null);
}
function glTexParameteriv$factory() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.i8x();
  }, null);
}
function glStencilOp$factory() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.d8w();
  }, null);
}
function glStencilMask$factory() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.b8w();
  }, null);
}
function glReadPixels$factory() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.j8x();
  }, null);
}
function glStencilFunc$factory() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.z8v();
  }, null);
}
function glScissor$factory() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.x8v();
  }, null);
}
function glPolygonOffset$factory() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.k8x();
  }, null);
}
function glPixelStorei$factory() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.v8v();
  }, null);
}
function glLineWidth$factory() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.l8x();
  }, null);
}
function glGetTexParameterfv$factory() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.m8x();
  }, null);
}
function glGetTexParameteriv$factory() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.n8x();
  }, null);
}
function glGetError$factory() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.o8v();
  }, null);
}
function glGetFloatv$factory() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.o8x();
  }, null);
}
function glGetIntegerv$factory() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.p8v();
  }, null);
}
function glGetBooleanv$factory() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.p8x();
  }, null);
}
function glGenTextures$factory() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.m8v();
  }, null);
}
function glDepthRange$factory() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.q8x();
  }, null);
}
function glDepthRangef$factory() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.x8u();
  }, null);
}
function glClearDepth$factory() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.r8x();
  }, null);
}
function glClearDepthf$factory() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.i8u();
  }, null);
}
function glDrawArrays$factory() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.a8v();
  }, null);
}
function glDrawElements$factory() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.b8v();
  }, null);
}
function glFrontFace$factory() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.h8v();
  }, null);
}
function glFinish$factory() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.s8x();
  }, null);
}
function glFlush$factory() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.e8v();
  }, null);
}
function glEnable$factory() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.c8v();
  }, null);
}
function glIsEnabled$factory() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.t8x();
  }, null);
}
function glDisable$factory() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.y8u();
  }, null);
}
function glDepthMask$factory() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.w8u();
  }, null);
}
function glDepthFunc$factory() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.v8u();
  }, null);
}
function glDeleteTextures$factory() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.u8u();
  }, null);
}
function glCullFace$factory() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.o8u();
  }, null);
}
function glCopyTexImage2D$factory() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.u8x();
  }, null);
}
function glCopyTexSubImage2D$factory() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.v8x();
  }, null);
}
function glColorMask$factory() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.k8u();
  }, null);
}
function glClearStencil$factory() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.j8u();
  }, null);
}
function glClearColor$factory() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.h8u();
  }, null);
}
function glClear$factory() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.g8u();
  }, null);
}
function glBindTexture$factory() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.b8u();
  }, null);
}
function glHint$factory() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.w8x();
  }, null);
}
function glViewport$factory() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.v8w();
  }, null);
}
function glGetString$factory() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.t8v();
  }, null);
}
function glGetStringi$factory() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.x8x();
  }, null);
}
function glVertexAttribPointer$factory() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.u8w();
  }, null);
}
function glVertexAttrib4fv$factory() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.y8x();
  }, null);
}
function glActiveTexture$factory() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.v8t();
  }, null);
}
function glAttachShader$factory() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.w8t();
  }, null);
}
function glBindAttribLocation$factory() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.x8t();
  }, null);
}
function glBindBuffer$factory() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.y8t();
  }, null);
}
function glBindFramebuffer$factory() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.z8t();
  }, null);
}
function glBindRenderbuffer$factory() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.a8u();
  }, null);
}
function glBlendColor$factory() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.z8x();
  }, null);
}
function glBlendEquation$factory() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.a8y();
  }, null);
}
function glBlendEquationSeparate$factory() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.c8u();
  }, null);
}
function glBlendFunc$factory() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.b8y();
  }, null);
}
function glBlendFuncSeparate$factory() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.d8u();
  }, null);
}
function glBufferData$factory() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.e8u();
  }, null);
}
function glBufferSubData$factory() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.f8u();
  }, null);
}
function glCheckFramebufferStatus$factory() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.c8y();
  }, null);
}
function glCompileShader$factory() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.l8u();
  }, null);
}
function glCompressedTexImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.d8y();
  }, null);
}
function glCompressedTexSubImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.e8y();
  }, null);
}
function glCreateProgram$factory() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.m8u();
  }, null);
}
function glCreateShader$factory() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.n8u();
  }, null);
}
function glDeleteBuffers$factory() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.p8u();
  }, null);
}
function glDeleteFramebuffers$factory() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.q8u();
  }, null);
}
function glDeleteProgram$factory() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.r8u();
  }, null);
}
function glDeleteRenderbuffers$factory() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.s8u();
  }, null);
}
function glDeleteShader$factory() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.t8u();
  }, null);
}
function glDetachShader$factory() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.f8y();
  }, null);
}
function glDisableVertexAttribArray$factory() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.z8u();
  }, null);
}
function glEnableVertexAttribArray$factory() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.d8v();
  }, null);
}
function glFramebufferRenderbuffer$factory() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.f8v();
  }, null);
}
function glFramebufferTexture2D$factory() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.g8v();
  }, null);
}
function glGenBuffers$factory() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.i8v();
  }, null);
}
function glGenerateMipmap$factory() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.j8v();
  }, null);
}
function glGenFramebuffers$factory() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.k8v();
  }, null);
}
function glGenRenderbuffers$factory() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.l8v();
  }, null);
}
function glGetActiveAttrib$factory() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.g8y();
  }, null);
}
function glGetActiveUniform$factory() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.h8y();
  }, null);
}
function glGetAttachedShaders$factory() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.i8y();
  }, null);
}
function glGetAttribLocation$factory() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.j8y();
  }, null);
}
function glGetUniformLocation$factory() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.n8v();
  }, null);
}
function glGetBufferParameteriv$factory() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.k8y();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.l8y();
  }, null);
}
function glGetProgramInfoLog$factory() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.m8y();
  }, null);
}
function glGetRenderbufferParameteriv$factory() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.n8y();
  }, null);
}
function glGetProgramiv$factory() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.q8v();
  }, null);
}
function glGetShaderiv$factory() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.r8v();
  }, null);
}
function glGetShaderInfoLog$factory() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.s8v();
  }, null);
}
function glGetShaderPrecisionFormat$factory() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.o8y();
  }, null);
}
function glGetShaderSource$factory() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.p8y();
  }, null);
}
function glGetUniformfv$factory() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.q8y();
  }, null);
}
function glGetUniformiv$factory() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.r8y();
  }, null);
}
function glGetVertexAttribfv$factory() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.s8y();
  }, null);
}
function glGetVertexAttribiv$factory() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.t8y();
  }, null);
}
function glGetVertexAttribPointerv$factory() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.u8y();
  }, null);
}
function glIsBuffer$factory() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.v8y();
  }, null);
}
function glIsFramebuffer$factory() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.w8y();
  }, null);
}
function glIsProgram$factory() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.x8y();
  }, null);
}
function glIsRenderbuffer$factory() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.y8y();
  }, null);
}
function glIsTexture$factory() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.z8y();
  }, null);
}
function glIsShader$factory() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.a8z();
  }, null);
}
function glLinkProgram$factory() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.u8v();
  }, null);
}
function glReleaseShaderCompiler$factory() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.b8z();
  }, null);
}
function glRenderbufferStorage$factory() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.w8v();
  }, null);
}
function glSampleCoverage$factory() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.c8z();
  }, null);
}
function glShaderBinary$factory() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.d8z();
  }, null);
}
function glShaderSource$factory() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.y8v();
  }, null);
}
function glStencilFuncSeparate$factory() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.a8w();
  }, null);
}
function glStencilMaskSeparate$factory() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.c8w();
  }, null);
}
function glStencilOpSeparate$factory() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.e8w();
  }, null);
}
function glUniform1f$factory() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.e8z();
  }, null);
}
function glUniform2f$factory() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.f8z();
  }, null);
}
function glUniform3f$factory() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.g8z();
  }, null);
}
function glUniform4f$factory() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.h8z();
  }, null);
}
function glUniform1i$factory() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.i8w();
  }, null);
}
function glUniform2i$factory() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.i8z();
  }, null);
}
function glUniform3i$factory() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.j8z();
  }, null);
}
function glUniform4i$factory() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.k8z();
  }, null);
}
function glUniform1fv$factory() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.h8w();
  }, null);
}
function glUniform2fv$factory() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.k8w();
  }, null);
}
function glUniform3fv$factory() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.m8w();
  }, null);
}
function glUniform4fv$factory() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.o8w();
  }, null);
}
function glUniform1iv$factory() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.j8w();
  }, null);
}
function glUniform2iv$factory() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.l8w();
  }, null);
}
function glUniform3iv$factory() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.n8w();
  }, null);
}
function glUniform4iv$factory() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.p8w();
  }, null);
}
function glUniformMatrix2fv$factory() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.q8w();
  }, null);
}
function glUniformMatrix3fv$factory() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.r8w();
  }, null);
}
function glUniformMatrix4fv$factory() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.s8w();
  }, null);
}
function glUseProgram$factory() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.t8w();
  }, null);
}
function glValidateProgram$factory() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.l8z();
  }, null);
}
function glVertexAttrib1f$factory() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.m8z();
  }, null);
}
function glVertexAttrib2f$factory() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.n8z();
  }, null);
}
function glVertexAttrib3f$factory() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.o8z();
  }, null);
}
function glVertexAttrib4f$factory() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.p8z();
  }, null);
}
function glVertexAttrib1fv$factory() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function glVertexAttrib2fv$factory() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function glVertexAttrib3fv$factory() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.s8z();
  }, null);
}
function glBindBufferRange$factory() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.z8w();
  }, null);
}
function glGetUniformBlockIndex$factory() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.a8x();
  }, null);
}
function glUniformBlockBinding$factory() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.b8x();
  }, null);
}
function glGenVertexArrays$factory() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.c8x();
  }, null);
}
function glDeleteVertexArrays$factory() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.t8z();
  }, null);
}
function glBindVertexArray$factory() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.d8x();
  }, null);
}
function glDrawArraysInstanced$factory_0() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.w8w();
  }, null);
}
function glDrawElementsInstanced$factory_0() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.x8w();
  }, null);
}
function glVertexAttribDivisor$factory_0() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.y8w();
  }, null);
}
function glTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.f8x();
  }, null);
}
function glTexImage2D$factory_0() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.f8w();
  }, null);
}
function glTexParameteri$factory_0() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.g8w();
  }, null);
}
function glTexParameterf$factory_0() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.g8x();
  }, null);
}
function glTexParameterfv$factory_0() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.h8x();
  }, null);
}
function glTexParameteriv$factory_0() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.i8x();
  }, null);
}
function glStencilOp$factory_0() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.d8w();
  }, null);
}
function glStencilMask$factory_0() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.b8w();
  }, null);
}
function glReadPixels$factory_0() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.j8x();
  }, null);
}
function glStencilFunc$factory_0() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.z8v();
  }, null);
}
function glScissor$factory_0() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.x8v();
  }, null);
}
function glPolygonOffset$factory_0() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.k8x();
  }, null);
}
function glPixelStorei$factory_0() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.v8v();
  }, null);
}
function glLineWidth$factory_0() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.l8x();
  }, null);
}
function glGetTexParameterfv$factory_0() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.m8x();
  }, null);
}
function glGetTexParameteriv$factory_0() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.n8x();
  }, null);
}
function glGetError$factory_0() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.o8v();
  }, null);
}
function glGetFloatv$factory_0() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.o8x();
  }, null);
}
function glGetIntegerv$factory_0() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.p8v();
  }, null);
}
function glGetBooleanv$factory_0() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.p8x();
  }, null);
}
function glGenTextures$factory_0() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.m8v();
  }, null);
}
function glDepthRange$factory_0() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.q8x();
  }, null);
}
function glDepthRangef$factory_0() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.x8u();
  }, null);
}
function glClearDepth$factory_0() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.r8x();
  }, null);
}
function glClearDepthf$factory_0() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.i8u();
  }, null);
}
function glDrawArrays$factory_0() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.a8v();
  }, null);
}
function glDrawElements$factory_0() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.b8v();
  }, null);
}
function glFrontFace$factory_0() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.h8v();
  }, null);
}
function glFinish$factory_0() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.s8x();
  }, null);
}
function glFlush$factory_0() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.e8v();
  }, null);
}
function glEnable$factory_0() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.c8v();
  }, null);
}
function glIsEnabled$factory_0() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.t8x();
  }, null);
}
function glDisable$factory_0() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.y8u();
  }, null);
}
function glDepthMask$factory_0() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.w8u();
  }, null);
}
function glDepthFunc$factory_0() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.v8u();
  }, null);
}
function glDeleteTextures$factory_0() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.u8u();
  }, null);
}
function glCullFace$factory_0() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.o8u();
  }, null);
}
function glCopyTexImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.u8x();
  }, null);
}
function glCopyTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.v8x();
  }, null);
}
function glColorMask$factory_0() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.k8u();
  }, null);
}
function glClearStencil$factory_0() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.j8u();
  }, null);
}
function glClearColor$factory_0() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.h8u();
  }, null);
}
function glClear$factory_0() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.g8u();
  }, null);
}
function glBindTexture$factory_0() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.b8u();
  }, null);
}
function glHint$factory_0() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.w8x();
  }, null);
}
function glViewport$factory_0() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.v8w();
  }, null);
}
function glGetString$factory_0() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.t8v();
  }, null);
}
function glGetStringi$factory_0() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.x8x();
  }, null);
}
function glVertexAttribPointer$factory_0() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.u8w();
  }, null);
}
function glVertexAttrib4fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.y8x();
  }, null);
}
function glActiveTexture$factory_0() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.v8t();
  }, null);
}
function glAttachShader$factory_0() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.w8t();
  }, null);
}
function glBindAttribLocation$factory_0() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.x8t();
  }, null);
}
function glBindBuffer$factory_0() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.y8t();
  }, null);
}
function glBindFramebuffer$factory_0() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.z8t();
  }, null);
}
function glBindRenderbuffer$factory_0() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.a8u();
  }, null);
}
function glBlendColor$factory_0() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.z8x();
  }, null);
}
function glBlendEquation$factory_0() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.a8y();
  }, null);
}
function glBlendEquationSeparate$factory_0() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.c8u();
  }, null);
}
function glBlendFunc$factory_0() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.b8y();
  }, null);
}
function glBlendFuncSeparate$factory_0() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.d8u();
  }, null);
}
function glBufferData$factory_0() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.e8u();
  }, null);
}
function glBufferSubData$factory_0() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.f8u();
  }, null);
}
function glCheckFramebufferStatus$factory_0() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.c8y();
  }, null);
}
function glCompileShader$factory_0() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.l8u();
  }, null);
}
function glCompressedTexImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.d8y();
  }, null);
}
function glCompressedTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.e8y();
  }, null);
}
function glCreateProgram$factory_0() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.m8u();
  }, null);
}
function glCreateShader$factory_0() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.n8u();
  }, null);
}
function glDeleteBuffers$factory_0() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.p8u();
  }, null);
}
function glDeleteFramebuffers$factory_0() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.q8u();
  }, null);
}
function glDeleteProgram$factory_0() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.r8u();
  }, null);
}
function glDeleteRenderbuffers$factory_0() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.s8u();
  }, null);
}
function glDeleteShader$factory_0() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.t8u();
  }, null);
}
function glDetachShader$factory_0() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.f8y();
  }, null);
}
function glDisableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.z8u();
  }, null);
}
function glEnableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.d8v();
  }, null);
}
function glFramebufferRenderbuffer$factory_0() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.f8v();
  }, null);
}
function glFramebufferTexture2D$factory_0() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.g8v();
  }, null);
}
function glGenBuffers$factory_0() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.i8v();
  }, null);
}
function glGenerateMipmap$factory_0() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.j8v();
  }, null);
}
function glGenFramebuffers$factory_0() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.k8v();
  }, null);
}
function glGenRenderbuffers$factory_0() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.l8v();
  }, null);
}
function glGetActiveAttrib$factory_0() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.g8y();
  }, null);
}
function glGetActiveUniform$factory_0() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.h8y();
  }, null);
}
function glGetAttachedShaders$factory_0() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.i8y();
  }, null);
}
function glGetAttribLocation$factory_0() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.j8y();
  }, null);
}
function glGetUniformLocation$factory_0() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.n8v();
  }, null);
}
function glGetBufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.k8y();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory_0() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.l8y();
  }, null);
}
function glGetProgramInfoLog$factory_0() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.m8y();
  }, null);
}
function glGetRenderbufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.n8y();
  }, null);
}
function glGetProgramiv$factory_0() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.q8v();
  }, null);
}
function glGetShaderiv$factory_0() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.r8v();
  }, null);
}
function glGetShaderInfoLog$factory_0() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.s8v();
  }, null);
}
function glGetShaderPrecisionFormat$factory_0() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.o8y();
  }, null);
}
function glGetShaderSource$factory_0() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.p8y();
  }, null);
}
function glGetUniformfv$factory_0() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.q8y();
  }, null);
}
function glGetUniformiv$factory_0() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.r8y();
  }, null);
}
function glGetVertexAttribfv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.s8y();
  }, null);
}
function glGetVertexAttribiv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.t8y();
  }, null);
}
function glGetVertexAttribPointerv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.u8y();
  }, null);
}
function glIsBuffer$factory_0() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.v8y();
  }, null);
}
function glIsFramebuffer$factory_0() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.w8y();
  }, null);
}
function glIsProgram$factory_0() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.x8y();
  }, null);
}
function glIsRenderbuffer$factory_0() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.y8y();
  }, null);
}
function glIsTexture$factory_0() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.z8y();
  }, null);
}
function glIsShader$factory_0() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.a8z();
  }, null);
}
function glLinkProgram$factory_0() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.u8v();
  }, null);
}
function glReleaseShaderCompiler$factory_0() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.b8z();
  }, null);
}
function glRenderbufferStorage$factory_0() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.w8v();
  }, null);
}
function glSampleCoverage$factory_0() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.c8z();
  }, null);
}
function glShaderBinary$factory_0() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.d8z();
  }, null);
}
function glShaderSource$factory_0() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.y8v();
  }, null);
}
function glStencilFuncSeparate$factory_0() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.a8w();
  }, null);
}
function glStencilMaskSeparate$factory_0() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.c8w();
  }, null);
}
function glStencilOpSeparate$factory_0() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.e8w();
  }, null);
}
function glUniform1f$factory_0() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.e8z();
  }, null);
}
function glUniform2f$factory_0() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.f8z();
  }, null);
}
function glUniform3f$factory_0() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.g8z();
  }, null);
}
function glUniform4f$factory_0() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.h8z();
  }, null);
}
function glUniform1i$factory_0() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.i8w();
  }, null);
}
function glUniform2i$factory_0() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.i8z();
  }, null);
}
function glUniform3i$factory_0() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.j8z();
  }, null);
}
function glUniform4i$factory_0() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.k8z();
  }, null);
}
function glUniform1fv$factory_0() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.h8w();
  }, null);
}
function glUniform2fv$factory_0() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.k8w();
  }, null);
}
function glUniform3fv$factory_0() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.m8w();
  }, null);
}
function glUniform4fv$factory_0() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.o8w();
  }, null);
}
function glUniform1iv$factory_0() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.j8w();
  }, null);
}
function glUniform2iv$factory_0() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.l8w();
  }, null);
}
function glUniform3iv$factory_0() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.n8w();
  }, null);
}
function glUniform4iv$factory_0() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.p8w();
  }, null);
}
function glUniformMatrix2fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.q8w();
  }, null);
}
function glUniformMatrix3fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.r8w();
  }, null);
}
function glUniformMatrix4fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.s8w();
  }, null);
}
function glUseProgram$factory_0() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.t8w();
  }, null);
}
function glValidateProgram$factory_0() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.l8z();
  }, null);
}
function glVertexAttrib1f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.m8z();
  }, null);
}
function glVertexAttrib2f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.n8z();
  }, null);
}
function glVertexAttrib3f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.o8z();
  }, null);
}
function glVertexAttrib4f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.p8z();
  }, null);
}
function glVertexAttrib1fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function glVertexAttrib2fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function glVertexAttrib3fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.s8z();
  }, null);
}
function glBindBufferRange$factory_0() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.z8w();
  }, null);
}
function glGetUniformBlockIndex$factory_0() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.a8x();
  }, null);
}
function glUniformBlockBinding$factory_0() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.b8x();
  }, null);
}
function glGenVertexArrays$factory_0() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.c8x();
  }, null);
}
function glDeleteVertexArrays$factory_0() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.t8z();
  }, null);
}
function glBindVertexArray$factory_0() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.d8x();
  }, null);
}
var properties_initialized_SDL_kt_s4ko39;
function _init_properties_SDL_kt__pqu7sn() {
  if (!properties_initialized_SDL_kt_s4ko39) {
    properties_initialized_SDL_kt_s4ko39 = true;
    SDLPath$delegate = lazy(SDLPath$delegate$lambda);
  }
}
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.getValue' call
  var this_0 = korgwCanvasQuery$delegate;
  korgwCanvasQuery$factory();
  return this_0.r1();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.fl();
    var v = _destruct__k2r9zo.gl();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
    var tmp_0 = document.querySelector(tmp0_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = AGOpengl.u75(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.q6t_1)])));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return window.korgwCanvasQuery;
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return function (e) {
    $ag.b6g();
    return Unit_instance;
  };
}
function korgwCanvasQuery$factory() {
  return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
    return get_korgwCanvasQuery();
  }, null);
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc(_this__u8e3s4, $this) {
  if (_this__u8e3s4 === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.id === undefined) {
    if ($this.i93_1.g1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.w4(toString(message));
    }
    var index = $this.i93_1.l3($this.i93_1.e1() - 1 | 0);
    $this.h93_1[index] = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.id = index;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.id;
}
function get_2(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.h93_1[_this__u8e3s4];
  } else {
    tmp = null;
  }
  return tmp;
}
function free(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.h93_1[_this__u8e3s4];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.i93_1.h(_this__u8e3s4);
    $this.h93_1[_this__u8e3s4] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.g93_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.g93_1.getExtension('OES_texture_float_linear') != null || this$0.g93_1.getExtension('OES_texture_float') != null || this$0.f93_1 >= 2;
  };
}
function extensions$factory() {
  return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
    return receiver.k7y();
  }, null);
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_2().ju() ? DenoJsGameWindow.c9c(VOID, config) : Companion_getInstance_2().iu() ? NodeJsGameWindow.h99() : BrowserCanvasJsGameWindow.v96();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_safe_receiver = $this.p9e_1.s96_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = cancelAndJoin(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  window.close();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.q9e_1($this.r9e_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onResized($this) {
  $this.j96_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.x8a().x8h(window.innerWidth, window.innerHeight, $this.p8b());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.g96_1.width = canvasWidth;
    $this.g96_1.height = canvasHeight;
    $this.g96_1.style.position = 'absolute';
    $this.g96_1.style.left = '0';
    $this.g96_1.style.right = '0';
    $this.g96_1.style.width = '' + window.innerWidth + 'px';
    $this.g96_1.style.height = '' + window.innerHeight + 'px';
    $this.o96_1 = scale;
  } else {
    $this.o96_1 = $this.g96_1.width / $this.g96_1.clientWidth;
  }
  $this.c8k(0, 0, $this.g96_1.width, $this.g96_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_35().j6e();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_35().k6e();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_35().f6e();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_35().g6e();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_35().d6e();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_35().e6e();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_35().h6e();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_35().i6e();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = CoroutineKey_getInstance().f8f_1;
            var level = Level_INFO_getInstance();
            var tmp_1;
            if (this_0.j2t(level)) {
              // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
              var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              this_0.k2t(level, tmp$ret$1);
              tmp_1 = Unit_instance;
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.z66(invoke_0($this.b8g_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.n6e()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.g96_1.getBoundingClientRect();
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  var this_0 = $this.p96_1;
  this_0.y6b_1 = Mode_JS_getInstance();
  this_0.z6b(type, false);
  try {
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.o96_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.o96_1;
        var tmp_1 = Vector2D.g2a(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_elvis_lhs = touch.force;
        this_0.c6c(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    this_0.a6c();
  }
  var this_1 = this_0.x6b_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
  $this.z66(this_1);
}
function mouseEvent($this, e, type, pressingType) {
  var canvasBounds = $this.g96_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.o96_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.o96_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.c8g_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.s9e() || type.equals(Type_SCROLL_getInstance())) {
    $this.z66($this.c8g_1);
  }
}
function mouseEvent$default($this, e, type, pressingType, $super) {
  pressingType = pressingType === VOID ? type : pressingType;
  return mouseEvent($this, e, type, pressingType);
}
function *_generator_loop__qll5p8_0($this, entry, $completion) {
  var tmp = $this;
  var tmp_0 = $this.y8h($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.s96_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda_0(entry, $this));
  _get_jsFrame__gugpar($this)(0.0);
  return Unit_instance;
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.t96_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function ensureSoftKeyboardInput($this) {
  if ($this.u96_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u96_1 = document.createElement('input');
    var tmp0_safe_receiver = $this.u96_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.id = 'softKeyboardInput';
    }
    var tmp1_safe_receiver = $this.u96_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.type = 'input';
    }
    var tmp2_safe_receiver = $this.u96_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp3_safe_receiver.zIndex = '10000000';
      tmp3_safe_receiver.position = 'absolute';
      tmp3_safe_receiver.top = '0';
      tmp3_safe_receiver.left = '0';
      tmp3_safe_receiver.width = '200px';
      tmp3_safe_receiver.height = '24px';
      tmp3_safe_receiver.background = 'transparent';
    }
  }
}
function _get_navigatorClipboard__ni2gks($this) {
  // Inline function 'kotlin.js.unsafeCast' call
  return navigator.clipboard;
}
function *_generator_clipboardRead__wie2ug($this, $completion) {
  var tmp = await_0(_get_navigatorClipboard__ni2gks($this).readText(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var text = tmp;
  var tmp_0;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(text) > 0) {
    tmp_0 = new TextClipboardData(text);
  } else {
    tmp_0 = null;
  }
  return tmp_0;
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return function ($this$keyEvent) {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.w4(toString(message));
    }
    tmp.g68_1 = tmp_0;
    $this$keyEvent.h68_1 = 0;
    $this$keyEvent.j68_1 = $me.keyCode;
    $this$keyEvent.i68_1 = $key;
    $this$keyEvent.l68_1 = $me.shiftKey;
    $this$keyEvent.m68_1 = $me.ctrlKey;
    $this$keyEvent.n68_1 = $me.altKey;
    $this$keyEvent.o68_1 = $me.metaKey;
    $this$keyEvent.k68_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return function ($this$mouseEvent) {
    $this$mouseEvent.z68_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.m69_1 = false;
    $this$mouseEvent.a69_1 = 0;
    $this$mouseEvent.b69_1 = $tx;
    $this$mouseEvent.c69_1 = $ty;
    $this$mouseEvent.d69_1 = Companion_getInstance_36().d1($e.button);
    $this$mouseEvent.e69_1 = $e.buttons;
    $this$mouseEvent.i69_1 = $e.shiftKey;
    $this$mouseEvent.j69_1 = $e.ctrlKey;
    $this$mouseEvent.k69_1 = $e.altKey;
    $this$mouseEvent.l69_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp0_subject = we.deltaMode;
      var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.s69(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda_0(this$0) {
  var i = new BrowserCanvasJsGameWindow$close$slambda(this$0);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return function (it) {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return function (it) {
    return this$0.h8k(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return function (it) {
    return this$0.h8k(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return function (it) {
    return this$0.h8k(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return function (it) {
    return this$0.h8k(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return function (it) {
    return this$0.h8k(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return function (it) {
    it.preventDefault();
    this$0.h8k(Type_END_getInstance(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = until(0, items.length);
    var destination = ArrayList.h1();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var files = destination;
    return this$0.h8k(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return function (step) {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.z8h();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.v9e_1($this.w9e_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_loop__qll5p8_1($this, entry, $completion) {
  var tmp = $this.y8h($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  launchImmediately(tmp, DenoJsGameWindow$loop$slambda_0(entry, $this));
  var tmp_0 = get_jsGlobalThis();
  tmp_0.setInterval(DenoJsGameWindow$loop$lambda($this), 16);
  return Unit_instance;
}
function DenoJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new DenoJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.pd($completion);
  };
  l.$arity = 0;
  return l;
}
function DenoJsGameWindow$loop$lambda(this$0) {
  return function () {
    this$0.u92();
    this$0.z8h();
    this$0.v92();
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).wr = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).y66 = dispatch$default;
protoOf(BaseEventListener).a67 = onEvents;
protoOf(BaseEventListener).b67 = dispatchDown;
protoOf(BaseEventListener).c67 = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.m66, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForCompanion(Companion);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Type, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Type_2, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.j6a);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Type_3, 'Type');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_20);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForInterface(ISoftKeyboardConfig, 'ISoftKeyboardConfig');
initMetadataForClass(SoftKeyboardType, 'SoftKeyboardType');
initMetadataForClass(SoftKeyboardReturnKeyType, 'SoftKeyboardReturnKeyType');
initMetadataForClass(SoftKeyboardConfig, 'SoftKeyboardConfig', SoftKeyboardConfig, VOID, [ISoftKeyboardConfig]);
initMetadataForCompanion(Companion_21);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).h6g = get_parentFeatures;
protoOf(AG).i6g = get_isUniformBuffersSupported;
protoOf(AG).j6g = get_isVertexArraysSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForCompanion(Companion_22);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.n6j);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.z6f, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AGObject, AutoCloseable]);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_24);
initMetadataForClass(AGTextureUnitInfo, 'AGTextureUnitInfo');
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData);
initMetadataForCompanion(Companion_25);
initMetadataForClass(AGDrawType, 'AGDrawType');
initMetadataForCompanion(Companion_26);
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_29);
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_30);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_32);
initMetadataForClass(AGColorMask, 'AGColorMask');
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(AGCullFace, 'AGCullFace');
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_35);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_36);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_37);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_39);
initMetadataForCompanion(Companion_40);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).s6y = get_Float1;
protoOf(Builder).s7k = get_Float2;
protoOf(Builder).t7k = get_Float4;
protoOf(Builder).h6x = get_out;
protoOf(Builder).t6y = atan;
protoOf(Builder).p6x = texture2D;
protoOf(Builder).k7j = TERNARY;
protoOf(Builder).u6y = pow;
protoOf(Builder).v6y = sqrt;
protoOf(Builder).w6y = abs;
protoOf(Builder).x6y = fract;
protoOf(Builder).l7j = clamp;
protoOf(Builder).m7j = min_0;
protoOf(Builder).n7j = max_1;
protoOf(Builder).o7j = fwidth;
protoOf(Builder).p7j = mix;
protoOf(Builder).y6y = smoothstep;
protoOf(Builder).q7j = length;
protoOf(Builder).k6x = get_lit;
protoOf(Builder).z6y = vec2;
protoOf(Builder).l6x = vec4;
protoOf(Builder).n6x = get_1;
protoOf(Builder).a6z = get_x;
protoOf(Builder).b6z = get_y;
protoOf(Builder).c6z = get_z;
protoOf(Builder).d6z = get_w;
protoOf(Builder).r6x = get_a;
protoOf(Builder).e6z = unaryMinus;
protoOf(Builder).f6z = minus_0;
protoOf(Builder).g6z = minus_1;
protoOf(Builder).h6z = plus_2;
protoOf(Builder).r7j = plus_3;
protoOf(Builder).s7j = plus_4;
protoOf(Builder).i6x = times;
protoOf(Builder).t7j = times_0;
protoOf(Builder).i6z = times_1;
protoOf(Builder).t6x = div;
protoOf(Builder).j6z = div_0;
protoOf(Builder).k6z = eq;
protoOf(Builder).l6z = lt;
protoOf(Builder).m6z = lt_0;
protoOf(Builder).n6z = le;
protoOf(Builder).o6z = gt;
protoOf(Builder).p6z = gt_0;
protoOf(Builder).q6z = and;
initMetadataForClass(Builder, 'Builder', Builder.u6x, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).o6x = get_u_Tex;
protoOf(ProgramBuilderDefault).r6u = get_u_ProjMat;
protoOf(ProgramBuilderDefault).s6u = get_u_ViewMat;
protoOf(ProgramBuilderDefault).j6x = get_a_Pos;
protoOf(ProgramBuilderDefault).b6x = get_a_Tex;
protoOf(ProgramBuilderDefault).g6x = get_a_Col;
protoOf(ProgramBuilderDefault).a6x = get_v_Tex;
protoOf(ProgramBuilderDefault).f6x = get_v_Col;
protoOf(ProgramBuilderDefault).s6x = get_t_Temp0;
protoOf(ProgramBuilderDefault).r6z = get_t_Temp1;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.z6w, VOID, [Builder, IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy.q79);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog.k7a);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint.a7a);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_43);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(Gen, 'Gen');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForCompanion(Companion_45);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
initMetadataForCompanion(Companion_46);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).v7f = precToString;
protoOf(GlslGenerator).w7f = typeToString;
protoOf(GlslGenerator).x7f = get_arrayDecl;
protoOf(GlslGenerator).u7f = get_IN;
protoOf(GlslGenerator).z7f = get_OUT;
protoOf(GlslGenerator).y7f = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(GlslConfig, 'GlslConfig');
protoOf(GlslBodyGenerator).w7f = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [Visitor, BaseGlslGenerator]);
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).u6y = pow;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).k6x = get_lit;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).n6x = get_1;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).f6z = minus_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).h6z = plus_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).i6x = times;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).t6x = div;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).l6z = lt;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).o6z = gt;
initMetadataForClass(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, VOID, VOID, [ExpressionBuilder]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForCompanion(Companion_49);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_50);
protoOf(KmlGl).h6g = get_parentFeatures;
protoOf(KmlGl).i6g = get_isUniformBuffersSupported;
protoOf(KmlGl).j6g = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KmlGlContext, 'KmlGlContext', VOID, VOID, [AutoCloseable]);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_51);
initMetadataForCompanion(Companion_52);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_53);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_54);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(AgCachedBuffer, 'AgCachedBuffer');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_55);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).w89 = get_windowToGlobalScaleAvg;
protoOf(Base).x89 = get_globalToWindowScaleAvg;
protoOf(Base).y89 = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_56);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
initMetadataForObject(V2CallbackSupport, 'V2CallbackSupport');
protoOf(DEFAULT).p8b = get_devicePixelRatio;
protoOf(DEFAULT).q8b = get_pixelsPerInch;
protoOf(DEFAULT).r8b = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).a8b = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForCompanion(Companion_58);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForLambda(GameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv);
protoOf(GameWindow).p8b = get_devicePixelRatio;
protoOf(GameWindow).q8b = get_pixelsPerInch;
protoOf(GameWindow).r8b = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).a8b = get_computedPixelRatio;
protoOf(GameWindow).zc = get;
protoOf(GameWindow).zm = fold;
protoOf(GameWindow).ym = minusKey;
protoOf(GameWindow).an = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.g8i, VOID, [BaseEventListener, DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_59);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(TextClipboardData, 'TextClipboardData');
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_60);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.u8i, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.j8i, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_61);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForCompanion(Companion_62);
initMetadataForClass(SDL, 'SDL', SDL.w8m);
initMetadataForClass(KmlGlOpenGL, 'KmlGlOpenGL', KmlGlOpenGL);
initMetadataForCompanion(Companion_63);
initMetadataForClass(OpenGL, 'OpenGL', OpenGL.n8t);
initMetadataForClass(SDLGameWindow$ag$1);
initMetadataForClass(SDLGameWindow, 'SDLGameWindow', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(Size3D, 'Size3D');
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.o9e, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.h99, VOID, VOID, [0, 1]);
initMetadataForLambda(BrowserCanvasJsGameWindow$close$slambda, VOID, VOID, [0]);
initMetadataForLambda(BrowserCanvasJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.v96, VOID, VOID, [1, 0]);
initMetadataForLambda(DenoJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(DenoJsGameWindow, 'DenoJsGameWindow', DenoJsGameWindow.c9c, VOID, VOID, [1, 0]);
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
//endregion
//region block: init
Companion_instance_8 = new Companion();
Companion_instance_9 = new Companion_0();
Companion_instance_10 = new Companion_1();
Companion_instance_11 = new Companion_2();
Companion_instance_14 = new Companion_5();
Companion_instance_15 = new Companion_6();
Companion_instance_16 = new Companion_7();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_31 = new Companion_22();
Companion_instance_32 = new Companion_23();
AGFinish_instance = new AGFinish();
Companion_instance_48 = new Companion_39();
Companion_instance_53 = new Companion_44();
Companion_instance_54 = new Companion_45();
Companion_instance_58 = new Companion_49();
Companion_instance_59 = new Companion_50();
Companion_instance_60 = new Companion_51();
debugBmpFontOrNull = null;
Companion_instance_62 = new Companion_53();
Companion_instance_63 = new Companion_54();
DEFAULT_instance = new DEFAULT();
GLOBAL_CHECK_GL = false;
Companion_instance_70 = new Companion_61();
korgwJvmEngine = null;
Companion_instance_71 = new Companion_62();
Companion_instance_72 = new Companion_63();
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Size3D as Size3D,
};
export {
  Key_A_getInstance as Key_A_getInstance2hm1ual2b01a9,
  Key_BACKSPACE_getInstance as Key_BACKSPACE_getInstance1qsaehdyc2n7u,
  Key_D_getInstance as Key_D_getInstance2xm6ey9bthxfr,
  Key_F12_getInstance as Key_F12_getInstance20smmrbslhgku,
  Key_F7_getInstance as Key_F7_getInstance1fxfgbmldwoq6,
  Key_SPACE_getInstance as Key_SPACE_getInstance3ccpin6uc1wp0,
  Key_S_getInstance as Key_S_getInstance3a623w26n65ct,
  Key_TAB_getInstance as Key_TAB_getInstancerm3v8lzruhq1,
  Key_W_getInstance as Key_W_getInstance1e55atnxjyziq,
  Key_X_getInstance as Key_X_getInstance2ymba0j0rmblp,
  Type_DOWN_getInstance as Type_DOWN_getInstance3w3upujzs6x5,
  Type_TYPE_getInstance as Type_TYPE_getInstance3kl3gtiytkq1p,
  Type_UP_getInstance as Type_UP_getInstance2onpl7vaj0n6f,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2pxjdxrpl68c5,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance1zas01g4tazis,
  Type_DRAG_getInstance as Type_DRAG_getInstance1oyczma3u1sfi,
  Type_UP_getInstance_0 as Type_UP_getInstance1azeslmnft6l5,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance104tc4m897tyy,
  Status_ADD_getInstance as Status_ADD_getInstance22apyg5ct4px7,
  Status_KEEP_getInstance as Status_KEEP_getInstance3tj4183qdgyi5,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance19drpw6lfvon8,
  Type_END_getInstance_0 as Type_END_getInstance3ekhp9k4xqwsb,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstanceavavmobr5nzz,
  Type_START_getInstance_0 as Type_START_getInstance27oonvh9zpi1o,
  Precision_MEDIUM_getInstance as Precision_MEDIUM_getInstancewn61okav7bh4,
  VarType_Float1_getInstance as VarType_Float1_getInstance1fp6gxp2vmo7y,
  VarType_Float2_getInstance as VarType_Float2_getInstance321ftm11bbyai,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstancemdqrzfwu4c9e,
  Cursor_HAND_getInstance as Cursor_HAND_getInstance18p4ksi2yuad6,
  Cursor_TEXT_getInstance as Cursor_TEXT_getInstancebh4jd1821ndb,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstance2edcjnp9auwx5,
  debugBmpFont as debugBmpFont2i7i2ml66o1iy,
  configureLoggerFromProperties as configureLoggerFromProperties2zy8apzr93pqp,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv as AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3,
  AGStencilReference__withReadMask$default_impl_7mdffx as AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb,
  AGStencilReference__withReferenceValue$default_impl_2trj0v as AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t,
  AGStencilReference__withWriteMask$default_impl_b7j7b4 as AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42,
  _AGColorMask___init__impl__j38ai8_0 as _AGColorMask___init__impl__j38ai828hvpfxybxjk7,
  _AGColorMask___init__impl__j38ai8_1 as _AGColorMask___init__impl__j38ai819ejt5rq8iy6o,
  AGColorMask__hashCode_impl_g9082f as AGColorMask__hashCode_impl_g9082fge542b8j3bn5,
  AGColorMask__toString_impl_5i5oqg as AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a,
  AGCompareMode__inverted_impl_7xxk8m as AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy,
  AGCullFace__hashCode_impl_t4e5ur as AGCullFace__hashCode_impl_t4e5urey2md6modztx,
  AGCullFace__toString_impl_7d891w as AGCullFace__toString_impl_7d891w3d9dwll45l9u7,
  AGDrawType__hashCode_impl_ylaury as AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2,
  AGDrawType__toString_impl_eonaeb as AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw,
  AGStencilOpFunc__hashCode_impl_nopebb as AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s,
  AGStencilOpFunc__toString_impl_pl8quy as AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0,
  AGStencilOpFunc__withEnabled_impl_mpcwmr as AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4,
  AGStencilReference__hashCode_impl_52zufx as AGStencilReference__hashCode_impl_52zufx32vlakxm4newn,
  AGStencilReference__toString_impl_qu5r8s as AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx,
  Companion_instance_11 as Companion_instance99w5lpdgjzr4,
  Companion_getInstance_27 as Companion_getInstance18y91gyxi2z7,
  Companion_getInstance_33 as Companion_getInstanceok0yphc67vv6,
  Companion_instance_25 as Companion_instancekcgdgz2aik3h,
  Companion_getInstance_26 as Companion_getInstance2ckr5i14ndxro,
  Companion_getInstance_35 as Companion_getInstance2y4l90zc9q53m,
  Companion_getInstance_24 as Companion_getInstance1wltq3fgn1avz,
  Companion_getInstance_25 as Companion_getInstancekjblelnta22u,
  Companion_instance_8 as Companion_instance2ovjg7lp6gfg7,
  Companion_instance_16 as Companion_instance12t49ingjwxzt,
  Companion_instance_9 as Companion_instance3i2v9jzzqvdkl,
  Companion_instance_10 as Companion_instancef7estul0zruo,
  Companion_getInstance_29 as Companion_getInstance6ryfwvwg9trm,
  Companion_getInstance_64 as Companion_getInstance31h96uhdj5cc,
  Companion_instance_53 as Companion_instance31en7fj48z7ti,
  Companion_getInstance_48 as Companion_getInstance29a9zmyrrw3c9,
  Companion_getInstance_57 as Companion_getInstancei2plsq4vst79,
  Companion_getInstance_50 as Companion_getInstance14dcva8uz4sb6,
  Companion_getInstance_41 as Companion_getInstanceae40js4gnuwg,
  Companion_getInstance_44 as Companion_getInstance23l94gq35u9ye,
  Companion_getInstance_56 as Companion_getInstance203qp9xyfv543,
  Companion_getInstance_47 as Companion_getInstance2cx7brx0y6bm1,
  Companion_getInstance_46 as Companion_getInstance3dym1csqm206y,
  ProjViewUB_getInstance as ProjViewUB_getInstance2c14wyrj73xek,
  DefaultShaders_getInstance as DefaultShaders_getInstance2nkm3g7twu3qg,
  Companion_getInstance_68 as Companion_getInstance1ifu77pbb1si2,
  DefaultViewport_getInstance as DefaultViewport_getInstance3ta8638tkh0q1,
  Companion_getInstance_71 as Companion_getInstance1dp345vz250gb,
  SDFShaders_getInstance as SDFShaders_getInstance2aqc6fv2u457r,
  Companion_getInstance_73 as Companion_getInstance2vwksse73neff,
  KorgeReload_getInstance as KorgeReload_getInstance1jsrcs9uzp4z9,
  Companion_instance_60 as Companion_instance7uo85wjiqj61,
  Companion_instance_70 as Companion_instanceyamrbth4pjfq,
  CoroutineKey_getInstance as CoroutineKey_getInstance2jikmq30sknr8,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  ISoftKeyboardConfig as ISoftKeyboardConfige7b4czi6ukd7,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  SoftKeyboardConfig as SoftKeyboardConfig3ue4h4egpkqhq,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  AGPrint as AGPrint2do8iynklt71b,
  Attribute as Attribute3obvnbxr5w4xd,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  If as If1av5krmfyt44s,
  ProgramLayout as ProgramLayout373hh4xkth3qt,
  Program as Program1hnygp9hph4ry,
  UniformBlockBuffer as UniformBlockBuffer2p2oao2ic417b,
  UniformBlock as UniformBlock2qoqszhm3r9i2,
  Varying as Varying105nnu9x9j75f,
  VertexShader as VertexShader26kcg39ndf3s1,
  AGBatch as AGBatch2bse24318tbhc,
  AGColorMask as AGColorMaskwqd86t1dhpnk,
  AGCullFace as AGCullFaceff7di2v9k2ne,
  AGDrawType as AGDrawType11vxw4gf0yugk,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AGStencilOpFunc as AGStencilOpFunc1juigl5mvjr07,
  AGStencilReference as AGStencilReference8at184sv64zi,
  AGTextureUnits as AGTextureUnits3k80ikbk5qbv9,
  AGVertexArrayObject as AGVertexArrayObjectp6l6cor3jhq8,
  AGVertexData as AGVertexDatawn78bdwnwjab,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  applyMatrixBounds as applyMatrixBounds3j13fpymjibm6,
  draw as drawfyi5eaogony1,
  draw_1 as draw3n7i8s75fp58g,
  plus_5 as plus3tmekjwnqrsa6,
  toAGScissor as toAGScissor50oxbqy8vpfx,
  drawText as drawText2ld6eqw3mc9xd,
  Input as Input3ljaq07eyi73v,
  AgCachedBuffer as AgCachedBuffer8k1i505isl6b,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TextureBase as TextureBase31xvoisoo1pp7,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture as Texture2obedkmljq67n,
  Texture_1 as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  Stats as Statslnkcsgem8jjl,
  V2Callback as V2Callback2d6dtckx13wqz,
  V2 as V22su20mpwty0v0,
  _interpolateColor as _interpolateColor3ps0kri0tazz4,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  _interpolate as _interpolated0idy8l9id9j,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  TextClipboardData as TextClipboardDatafimoftc14pmm,
  configure as configure1a7py4k2lj4vi,
};
//endregion
